import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  GraphQLUrl: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  Json: any;
  GraphQLLocale: any;
  PhoneNumber: any;
  Timezone: any;
  BinaryRatingScalar: any;
  Gender: any;
  LimitedString: any;
  NumericRating: any;
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: any;
};


export type ActivitiesQueryType = {
  __typename?: 'ActivitiesQueryType';
  newActivities: Array<Maybe<Activity>>;
  oldActivities: Array<Maybe<Activity>>;
};

export type Activity = {
  __typename?: 'Activity';
  Actor?: Maybe<Profile>;
  Answer?: Maybe<Answer>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  Question?: Maybe<Question>;
  Reaction?: Maybe<Reaction>;
  type: ActivityType;
  updatedAt: Scalars['DateTime'];
  User?: Maybe<Profile>;
  userId: Scalars['ID'];
};

export enum ActivityType {
  AnswerRedeemed = 'ANSWER_REDEEMED',
  NotifyRedeemCollectible = 'NOTIFY_REDEEM_COLLECTIBLE',
  QuestionAnswered = 'QUESTION_ANSWERED',
  QuestionCreated = 'QUESTION_CREATED',
  QuestionExpiring = 'QUESTION_EXPIRING',
  ReactionAnswer = 'REACTION_ANSWER',
  ReactionQuestion = 'REACTION_QUESTION'
}

export type AdminMeeting = {
  __typename?: 'AdminMeeting';
  acceptedMessage?: Maybe<Scalars['String']>;
  agenda?: Maybe<Scalars['String']>;
  attendance?: Maybe<Scalars['String']>;
  canceledBy?: Maybe<User>;
  canceledMessage?: Maybe<Scalars['String']>;
  Coach: AdminUser;
  coachMessageToLearner?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  declinedMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  Learner: AdminUser;
  learnerMessageToCoach?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  revenue?: Maybe<Scalars['Int']>;
  scheduledTime: Scalars['DateTime'];
  state: MeetingState;
};

export type AdminMeetingsFilter = {
  attendance?: Maybe<AttendanceState>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<MeetingState>;
};

export type AdminMeetingsPaginated = {
  __typename?: 'AdminMeetingsPaginated';
  count: Scalars['Int'];
  meetings: Array<AdminMeeting>;
  offset: Scalars['Int'];
};

export type AdminRequest = {
  __typename?: 'AdminRequest';
  agenda?: Maybe<Scalars['String']>;
  Coach: AdminUser;
  createdAt: Scalars['DateTime'];
  declinedMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  Learner: AdminUser;
  price: Scalars['Int'];
  scheduledTime: Scalars['DateTime'];
  state: RequestState;
};

export type AdminRequestsFilter = {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<RequestState>;
};

export type AdminRequestsPaginated = {
  __typename?: 'AdminRequestsPaginated';
  count: Scalars['Int'];
  offset: Scalars['Int'];
  requests: Array<AdminRequest>;
};

export type AdminTag = {
  __typename?: 'AdminTag';
  count: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isApproved: Scalars['Boolean'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type AdminTagsFilter = {
  isApproved?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AdminTagsPaginated = {
  __typename?: 'AdminTagsPaginated';
  count: Scalars['Int'];
  offset: Scalars['Int'];
  tags: Array<AdminTag>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  bookable: Scalars['Boolean'];
  campaign?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  editoriallyApproved: Scalars['Boolean'];
  email: Scalars['String'];
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  headlines: Array<Headlines>;
  id: Scalars['String'];
  links: Array<Links>;
  name?: Maybe<Scalars['String']>;
  profilePercentCompleted: Scalars['Int'];
  profilePictureUrl: Scalars['String'];
  rating?: Maybe<Scalars['Float']>;
  tags: Array<UserTag>;
  talkToMeAbout?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  viewedDashboard: Scalars['Boolean'];
};

export type AdminUserDetail = {
  __typename?: 'AdminUserDetail';
  meetings: Array<AdminMeeting>;
  user: AdminUser;
};

export type AdminUsersFilter = {
  bookable?: Maybe<Scalars['Boolean']>;
  editoriallyApproved?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AdminUsersPaginated = {
  __typename?: 'AdminUsersPaginated';
  count: Scalars['Int'];
  offset: Scalars['Int'];
  users: Array<AdminUser>;
};

export type Alert = {
  __typename?: 'Alert';
  createdAt?: Maybe<Scalars['DateTime']>;
  howItWorks?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export enum AlertType {
  HowItWorks = 'HOW_IT_WORKS'
}

export type AllArtists = {
  __typename?: 'AllArtists';
  name: Scalars['String'];
  picture: Scalars['String'];
};

export type Answer = {
  __typename?: 'Answer';
  artistSeriesNumber: Scalars['Int'];
  audioRendition: Scalars['String'];
  body: Scalars['String'];
  coverImage?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  durationSeconds?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  igShareLink?: Maybe<Scalars['String']>;
  ipfsMedia?: Maybe<Scalars['String']>;
  ipfsThumb?: Maybe<Scalars['String']>;
  isGenerated: Scalars['Boolean'];
  nftNumber: Scalars['Int'];
  questionId: Scalars['ID'];
  shareRendition: Scalars['String'];
  transcript?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  youTubeId?: Maybe<Scalars['String']>;
};

export type AnswerSearchResult = {
  __typename?: 'AnswerSearchResult';
  Artist: Profile;
  body: Scalars['String'];
  entityType: SearchResultEntityType;
  highlight: SearchHighlight;
  questionId: Scalars['String'];
  transcript?: Maybe<Scalars['String']>;
};

export type ArtistInstagramCrawlJob = {
  __typename?: 'ArtistInstagramCrawlJob';
  Artist: Profile;
  caption: Scalars['String'];
  createdAt: Scalars['DateTime'];
  error?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  instagramUsername: Scalars['String'];
  mediaUrl: Scalars['String'];
  name: Scalars['String'];
  schedule: Scalars['String'];
  searchTerms: Scalars['String'];
  status: JobStatus;
  thumbnail: Scalars['String'];
  type: CrawlJobType;
  updatedAt: Scalars['DateTime'];
  videoId: Scalars['String'];
};

export type ArtistInstagramCrawlJobsQueryType = {
  __typename?: 'ArtistInstagramCrawlJobsQueryType';
  activeVideoCrawlJobs: Array<Maybe<ArtistInstagramCrawlJob>>;
  channelCrawlJob?: Maybe<ArtistInstagramCrawlJob>;
  inactiveVideoCrawlJobs: Array<Maybe<ArtistInstagramCrawlJob>>;
};

export type ArtistYouTubeChannelCrawlJob = {
  __typename?: 'ArtistYouTubeChannelCrawlJob';
  createdAt: Scalars['DateTime'];
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  schedule: Scalars['String'];
  status: JobStatus;
  updatedAt: Scalars['DateTime'];
  youTubeChannelId: Scalars['String'];
};

export type ArtistYouTubeVideoCrawlJob = {
  __typename?: 'ArtistYouTubeVideoCrawlJob';
  caption: Scalars['String'];
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  mediaUrl: Scalars['String'];
  name: Scalars['String'];
  schedule: Scalars['String'];
  status: JobStatus;
  thumbnail: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  videoId: Scalars['String'];
};

export enum AttendanceState {
  AllAttended = 'ALL_ATTENDED',
  AllNoShowed = 'ALL_NO_SHOWED',
  CoachNoShowed = 'COACH_NO_SHOWED',
  LearnerNoShowed = 'LEARNER_NO_SHOWED'
}

export type AuthPayload = {
  __typename?: 'AuthPayload';
  code: ResponseCode;
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export enum AuthRoleType {
  Admin = 'ADMIN',
  Staff = 'STAFF',
  Superuser = 'SUPERUSER',
  User = 'USER'
}

export enum AuthType {
  Apple = 'Apple',
  Email = 'Email',
  Facebook = 'Facebook',
  Google = 'Google'
}

export enum BinaryRating {
  Bad = 'BAD',
  Good = 'GOOD'
}


export type Block = {
  __typename?: 'Block';
  slots: Array<Scalars['DateTime']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  code: Scalars['String'];
  createdAt: Scalars['Date'];
  deletedAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: CampaignType;
  updatedAt: Scalars['Date'];
};

export enum CampaignType {
  Influencer = 'INFLUENCER',
  Paid = 'PAID',
  Partnership = 'PARTNERSHIP'
}

export type ChatMessage = {
  __typename?: 'ChatMessage';
  id: Scalars['ID'];
  message: Scalars['String'];
  name: Scalars['String'];
  profilePictureUrl: Scalars['String'];
  timestamp: Scalars['DateTime'];
  username: Scalars['String'];
};

export type ChimeTestMeeting = {
  __typename?: 'ChimeTestMeeting';
  attendeeSDKResponse: Scalars['Json'];
  meetingSDKResponse: Scalars['Json'];
};

export type CouponActivation = {
  __typename?: 'CouponActivation';
  discountAmountApplied: Scalars['Int'];
  id: Scalars['ID'];
};

export enum CrawlJobType {
  Channel = 'CHANNEL',
  Video = 'VIDEO'
}

export type CreateAnswerInput = {
  body: Scalars['String'];
  fanId: Scalars['ID'];
  questionId: Scalars['ID'];
};

export type CreateAnswerResponse = {
  __typename?: 'CreateAnswerResponse';
  answer?: Maybe<Answer>;
  error?: Maybe<Error>;
  success: Scalars['Boolean'];
};

export type CreateEmailReferralInput = {
  message: Scalars['String'];
  recipientEmail: Scalars['String'];
  recipientName: Scalars['String'];
  username: Scalars['String'];
};

export type CreateNftInput = {
  fanId: Scalars['ID'];
  questionId: Scalars['ID'];
  wallet: Scalars['String'];
};

export type CreateNftResponse = {
  __typename?: 'CreateNftResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean'];
};

export type CreateQuestionInput = {
  artistId: Scalars['ID'];
  body: Scalars['String'];
};

export type CreateQuestionResponse = {
  __typename?: 'CreateQuestionResponse';
  error?: Maybe<Error>;
  question?: Maybe<Question>;
  success: Scalars['Boolean'];
};

export type CreateReactionInput = {
  emoji?: Maybe<EmojiReaction>;
  questionId: Scalars['ID'];
};

export type CreateReactionResponse = {
  __typename?: 'CreateReactionResponse';
  error?: Maybe<Error>;
  reactions: Array<Maybe<Reaction>>;
  success: Scalars['Boolean'];
};

export type CreateRedditQuestionFromCommentInput = {
  redditCommentAuthorId: Scalars['String'];
  redditCommentAuthorName: Scalars['String'];
  redditCommentBody: Scalars['String'];
  redditCommentCreatedAt: Scalars['String'];
  redditCommentId: Scalars['String'];
  redditCommentScore: Scalars['Int'];
  redditCommentUrl: Scalars['String'];
  redditPostAuthorId: Scalars['String'];
  redditPostAuthorName: Scalars['String'];
  redditPostCommentCount: Scalars['Int'];
  redditPostCreatedAt: Scalars['String'];
  redditPostId: Scalars['String'];
  redditPostScore: Scalars['Int'];
  redditPostSubredditName: Scalars['String'];
  redditPostThumbnailUrl: Scalars['String'];
  redditPostTitle: Scalars['String'];
  redditPostUrl: Scalars['String'];
  subredditId: Scalars['String'];
};

export type CreateRedditQuestionFromPostInput = {
  redditPostAuthorId: Scalars['String'];
  redditPostAuthorName: Scalars['String'];
  redditPostCommentCount: Scalars['Int'];
  redditPostCreatedAt: Scalars['String'];
  redditPostId: Scalars['String'];
  redditPostScore: Scalars['Int'];
  redditPostSubredditName: Scalars['String'];
  redditPostText: Scalars['String'];
  redditPostThumbnailUrl: Scalars['String'];
  redditPostTitle: Scalars['String'];
  redditPostUrl: Scalars['String'];
  subredditId: Scalars['String'];
};

export type CreateRedditQuestionResponse = {
  __typename?: 'CreateRedditQuestionResponse';
  artistUsername?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  notifyUser?: Maybe<Scalars['Boolean']>;
  questionId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateRequestResponse = {
  __typename?: 'CreateRequestResponse';
  error?: Maybe<Error>;
  request?: Maybe<Request>;
  success: Scalars['Boolean'];
};

export type CreateRetoolPayoutRoyaltyInput = {
  id: Scalars['ID'];
};

export type CreateRoyaltyPayoutInput = {
  wallet: Scalars['String'];
};

export type CreateRoyaltyPayoutResponse = {
  __typename?: 'CreateRoyaltyPayoutResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean'];
};

export type CreateRoyaltySummaryInput = {
  artistId: Scalars['ID'];
};

export type CreateRoyaltySummaryResponse = {
  __typename?: 'CreateRoyaltySummaryResponse';
  amount: Scalars['Int'];
  usd_value: Scalars['Float'];
  value: Scalars['Float'];
};

export type CreateSupportPaymentInput = {
  couponCode?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  questionId: Scalars['ID'];
  savePaymentMethod: Scalars['Boolean'];
};

export type CreateSupportPaymentResponse = {
  __typename?: 'CreateSupportPaymentResponse';
  error?: Maybe<Error>;
  question: Question;
  success: Scalars['Boolean'];
  supportPayment?: Maybe<SupportPayment>;
};

export type CreateUserInput = {
  campaignCode?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  locale: Scalars['GraphQLLocale'];
  name: Scalars['String'];
  password: Scalars['String'];
  path?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  referredByCoach?: Maybe<Scalars['String']>;
  referredByUser?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  username: Scalars['String'];
};

export type CreateYouTubeCrawlJobInput = {
  mediaUrls: Array<Scalars['String']>;
  uploadChannel: Scalars['Boolean'];
};

export type CreateYouTubeCrawlJobResponse = {
  __typename?: 'CreateYouTubeCrawlJobResponse';
  channelCrawlJob?: Maybe<ArtistYouTubeChannelCrawlJob>;
  error?: Maybe<Scalars['String']>;
  jobs: Array<Maybe<ArtistYouTubeVideoCrawlJob>>;
  success: Scalars['Boolean'];
};



export enum DiscordGuildUserStatus {
  AvailableToInvite = 'AVAILABLE_TO_INVITE',
  CommandUser = 'COMMAND_USER',
  PendingInvitation = 'PENDING_INVITATION',
  ReadyToTakeQuestions = 'READY_TO_TAKE_QUESTIONS'
}

export type DiscordUser = {
  __typename?: 'DiscordUser';
  discordUserId: Scalars['String'];
  discordUsername: Scalars['String'];
  guildUserStatus: DiscordGuildUserStatus;
};

export enum EmojiReaction {
  Astonished = 'ASTONISHED',
  Heart = 'HEART',
  Joy = 'JOY',
  Pensive = 'PENSIVE',
  Sparkles = 'SPARKLES'
}

export type EngagementType = {
  __typename?: 'EngagementType';
  count: Scalars['Int'];
  platform: Platform;
};

export type Error = {
  __typename?: 'Error';
  errorType: ErrorType;
};

export enum ErrorType {
  MeetingErrorCantBookCoach = 'MEETING_ERROR_CANT_BOOK_COACH'
}

export type Fan = {
  __typename?: 'Fan';
  allPlatforms: Array<Platform>;
  answers: Scalars['Int'];
  email: Scalars['String'];
  fanId: Scalars['String'];
  identities?: Maybe<Array<Maybe<FanIdentity>>>;
  isFavorite: Scalars['Boolean'];
  openQuestion?: Maybe<Scalars['String']>;
  platforms: Array<Platform>;
  questions: Scalars['Int'];
  socialUrls: Array<Scalars['String']>;
  totalFans: Scalars['Int'];
  username: Scalars['String'];
};

export type FanIdentity = {
  __typename?: 'FanIdentity';
  answers: Scalars['Int'];
  email: Scalars['String'];
  fanId: Scalars['String'];
  isFavorite: Scalars['Boolean'];
  openQuestion?: Maybe<Scalars['String']>;
  platforms: Array<Platform>;
  questions: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  username: Scalars['String'];
};

export type FanSummary = {
  __typename?: 'FanSummary';
  fans: Array<Fan>;
  pagination: Pagination;
};

export type FeaturedEntities = {
  __typename?: 'FeaturedEntities';
  activities: Array<Activity>;
  answers: Array<Answer>;
  artistIds: Array<Maybe<Scalars['String']>>;
  artists: Array<Profile>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  questionIds: Array<Maybe<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
};




export type GuildModerator = {
  __typename?: 'GuildModerator';
  createdAt?: Maybe<Scalars['DateTime']>;
  guildId: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HeadlineInput = {
  institution: Scalars['String'];
  role: Scalars['String'];
};

export type Headlines = {
  __typename?: 'Headlines';
  institution: Scalars['String'];
  role: Scalars['String'];
};

export type HealthCheckResponse = {
  __typename?: 'HealthCheckResponse';
  response: Scalars['String'];
  status: Scalars['Int'];
  timestamp: Scalars['String'];
};

export type Highlight = {
  __typename?: 'Highlight';
  fullyHighlighted?: Maybe<Scalars['Boolean']>;
  matchedWords: Array<Scalars['String']>;
  matchLevel: SearchResultMatchLevelType;
  value: Scalars['String'];
};

export type InstagramAccountStatsQueryType = {
  __typename?: 'InstagramAccountStatsQueryType';
  channelCrawlPublishedAfter?: Maybe<Scalars['DateTime']>;
  followerCount: Scalars['Int'];
  latestQuestionCreatedAt?: Maybe<Scalars['DateTime']>;
  mediaCount: Scalars['Int'];
  videoCrawlJobCount?: Maybe<Scalars['Int']>;
};

export type InviteDiscordUsersInputType = {
  discordUserIds: Array<Scalars['String']>;
  guildId: Scalars['String'];
};

export enum JobStatus {
  Failed = 'FAILED',
  Ready = 'READY',
  Running = 'RUNNING',
  Stopped = 'STOPPED',
  Succeeded = 'SUCCEEDED'
}


export enum Language {
  Arabic = 'ARABIC',
  Chinese = 'CHINESE',
  Chinesetw = 'CHINESETW',
  English = 'ENGLISH',
  French = 'FRENCH',
  German = 'GERMAN',
  Hindi = 'HINDI',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  Portuguese = 'PORTUGUESE',
  Spanish = 'SPANISH'
}


export type LinkInput = {
  link: Scalars['GraphQLUrl'];
};

export type Links = {
  __typename?: 'Links';
  link: Scalars['GraphQLUrl'];
};

export type LoginFacebookUserInput = {
  facebookAccessToken: Scalars['String'];
  facebookUserId: Scalars['String'];
};

export type LoginUserInput = {
  email?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
};

export type MagicLoginInput = {
  token: Scalars['String'];
};

export type MagicSignupAction = {
  setSendVerifyEmailOtp?: Maybe<MagicSignupActionSetSendVerifyEmailOtp>;
  setSendVerifyPhoneOtp?: Maybe<MagicSignupActionSetSendVerifyPhoneOtp>;
  setVerifyEmailOtp?: Maybe<MagicSignupActionSetVerifyEmailOtp>;
  setVerifyPhoneOtp?: Maybe<MagicSignupActionSetVerifyPhoneOtp>;
};

export type MagicSignupActionSetSendVerifyEmailOtp = {
  email: Scalars['String'];
};

export type MagicSignupActionSetSendVerifyPhoneOtp = {
  phoneCountryCode: Scalars['Int'];
  phoneNumber: Scalars['PhoneNumber'];
};

export type MagicSignupActionSetVerifyEmailOtp = {
  code: Scalars['String'];
  email: Scalars['String'];
};

export type MagicSignupActionSetVerifyPhoneOtp = {
  code: Scalars['String'];
  phoneCountryCode: Scalars['Int'];
  phoneNumber: Scalars['PhoneNumber'];
};

export type MagicSignupInput = {
  actions: Array<MagicSignupAction>;
};

export type MagicSignupPayload = {
  __typename?: 'MagicSignupPayload';
  code?: Maybe<ResponseCode>;
  success: Scalars['Boolean'];
};

export type Manager = {
  __typename?: 'Manager';
  artists: Array<User>;
  createdAt: Scalars['String'];
  managerId: Scalars['String'];
};

export type ManagerArtistLoginInput = {
  artistUsername: Scalars['String'];
  managerToken?: Maybe<Scalars['String']>;
};

export type ManagerFan = {
  __typename?: 'ManagerFan';
  allArtists: Array<AllArtists>;
  allPlatforms: Array<Platform>;
  answers: Scalars['Int'];
  artistName: Scalars['String'];
  artistPicture: Scalars['String'];
  email: Scalars['String'];
  fanId: Scalars['String'];
  identities?: Maybe<Array<Maybe<ManagerFanIdentity>>>;
  isFavorite: Scalars['Boolean'];
  platforms: Array<Platform>;
  questions: Scalars['Int'];
  socialUrls: Array<Scalars['String']>;
  totalFans: Scalars['Int'];
  username: Scalars['String'];
};

export type ManagerFanIdentity = {
  __typename?: 'ManagerFanIdentity';
  answers: Scalars['Int'];
  artistName: Scalars['String'];
  artistPicture: Scalars['String'];
  email: Scalars['String'];
  fanId: Scalars['String'];
  isFavorite: Scalars['Boolean'];
  platforms: Array<Platform>;
  questions: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  username: Scalars['String'];
};

export type ManagerFanSummary = {
  __typename?: 'ManagerFanSummary';
  fans: Array<ManagerFan>;
  pagination: Pagination;
};

export type ManagerResponse = {
  __typename?: 'ManagerResponse';
  manager?: Maybe<Manager>;
  token: Scalars['String'];
};

export type MarketplaceHealth = {
  __typename?: 'MarketplaceHealth';
  averageCoachEarnings: Scalars['String'];
  averageLearnerSpending: Scalars['String'];
  averageMeetingValue: Scalars['String'];
  bonsaiRevenue: Scalars['String'];
  coachEarnings: Scalars['String'];
  grossMerchandiseValue: Scalars['String'];
  totalCompletedMeetings: Scalars['Int'];
  totalUniqueCoachParticipants: Scalars['Int'];
  totalUniqueLearnerParticipants: Scalars['Int'];
  totalUniqueParticipants: Scalars['Int'];
};

export type Meeting = {
  __typename?: 'Meeting';
  acceptedMessage?: Maybe<Scalars['String']>;
  agenda?: Maybe<Scalars['String']>;
  attendanceState: AttendanceState;
  canCancelMeeting: Scalars['Boolean'];
  canceledBy?: Maybe<User>;
  canceledMessage?: Maybe<Scalars['String']>;
  canDisplayJoinButton: Scalars['Boolean'];
  chatHistory: Array<ChatMessage>;
  chimeSDKResponse?: Maybe<Scalars['Json']>;
  Coach: Profile;
  coachAVRating?: Maybe<BinaryRating>;
  coachMessageToLearner?: Maybe<Scalars['String']>;
  declinedAt?: Maybe<Scalars['DateTime']>;
  declinedMessage?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  Learner: Profile;
  learnerAVRating?: Maybe<BinaryRating>;
  learnerMessageToCoach?: Maybe<Scalars['String']>;
  MeetingAttendee: Array<MeetingAttendee>;
  message?: Maybe<Scalars['String']>;
  paymentState?: Maybe<PaymentState>;
  price: Scalars['Int'];
  referredBy?: Maybe<Profile>;
  requestType: RequestType;
  scheduledTime: Scalars['DateTime'];
  secondsUntilStart: Scalars['Int'];
  state: MeetingState;
  updatedAt: Scalars['DateTime'];
};

export type MeetingAttendee = {
  __typename?: 'MeetingAttendee';
  chimeSDKResponse?: Maybe<Scalars['Json']>;
};

export type MeetingForAttendee = {
  __typename?: 'MeetingForAttendee';
  attendee: MeetingAttendee;
  meeting: Meeting;
};

export type MeetingLobby = {
  __typename?: 'MeetingLobby';
  attendee: MeetingAttendee;
  meeting: Meeting;
  meetingLobbyState: MeetingLobbyState;
};

export enum MeetingLobbyState {
  MeetingPending = 'MEETING_PENDING',
  MeetingReady = 'MEETING_READY',
  OtherAttendeeNoShowed = 'OTHER_ATTENDEE_NO_SHOWED'
}

export enum MeetingState {
  MeetingCanceled = 'MEETING_CANCELED',
  MeetingEnded = 'MEETING_ENDED',
  MeetingScheduled = 'MEETING_SCHEDULED',
  MeetingStarted = 'MEETING_STARTED'
}

export type ModeratorDataResponse = {
  __typename?: 'ModeratorDataResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  AuthenticateDiscordCallback: Scalars['Json'];
  AuthenticateGoogleCallback: Scalars['Json'];
  AuthenticateRedditCallback: RedditAuthResponse;
  CreateAnswer: CreateAnswerResponse;
  CreateEmailReferral?: Maybe<Scalars['Boolean']>;
  CreateNft: CreateNftResponse;
  CreateQuestion: CreateQuestionResponse;
  CreateReaction: CreateReactionResponse;
  CreateRedditQuestionFromComment: CreateRedditQuestionResponse;
  CreateRedditQuestionFromPost: CreateRedditQuestionResponse;
  CreateRoyaltyPayout: CreateRoyaltyPayoutResponse;
  CreateRoyaltySummary: CreateRoyaltySummaryResponse;
  CreateSupportPayment: CreateSupportPaymentResponse;
  CreateUser?: Maybe<AuthPayload>;
  CreateYouTubeCrawlJob?: Maybe<CreateYouTubeCrawlJobResponse>;
  DirectMessageDiscordUser: Scalars['Json'];
  ExportFanReport: S3UploadResult;
  ExportFanSummary: S3UploadResult;
  InviteDiscordUsers: Scalars['Json'];
  LoginFacebookUser: AuthPayload;
  LoginUser: AuthPayload;
  MagicLogin?: Maybe<AuthPayload>;
  MagicSignup?: Maybe<MagicSignupPayload>;
  ManagerArtistLogin: AuthPayload;
  PayoutRoyalty: CreateRoyaltyPayoutResponse;
  RefreshRedditModeratorData: ModeratorDataResponse;
  RequestMagicLogin?: Maybe<RequestMagicLoginPayload>;
  RequestPassword?: Maybe<RequestPasswordPayload>;
  ResetPassword?: Maybe<AuthPayload>;
  ResetTestDb: Scalars['Boolean'];
  RetoolCreateCampaign: Campaign;
  RetoolUpdateQuestion: Question;
  RetoolUpdateTag: Tag;
  RetoolUpdateUser: User;
  SetCrawlIgMedias: Scalars['Boolean'];
  StopCrawlIgMedia: Scalars['Boolean'];
  StopCrawlYouTubeMedia: Scalars['Boolean'];
  UpdateAlert: UpdateAlertResponse;
  UpdateAnswer: Answer;
  UpdateFeaturedEntities: FeaturedEntities;
  UpdateGuildCommandUsers: Scalars['Json'];
  UpdateInstagramLinked: UpdateInstagramLinkedResponse;
  UpdateManager?: Maybe<Manager>;
  UpdateProfile: Profile;
  UpdateQuestion: Question;
  UpdateRoyaltyPayout?: Maybe<Array<Maybe<PayoutRoyalties>>>;
  UpdateUser: User;
  UpdateYouTubeVideoCrawlJobStatus: ArtistYouTubeVideoCrawlJob;
  UpsertSubredditArtistBonsaiConfig: UpsertSubredditArtistBonsaiConfigResponse;
  ValidateFacebookAccessToken: Scalars['Boolean'];
  ValidateGoogleAccessToken: Scalars['Boolean'];
  ValidateIgMedia: ValidateIgMediaResponse;
  VerifyEmail: Scalars['Boolean'];
  VerifyManagerToken: Scalars['Boolean'];
  VerifyPhone: Scalars['Boolean'];
};


export type MutationAuthenticateDiscordCallbackArgs = {
  code: Scalars['String'];
  guildId: Scalars['String'];
};


export type MutationAuthenticateGoogleCallbackArgs = {
  code: Scalars['String'];
};


export type MutationAuthenticateRedditCallbackArgs = {
  code: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};


export type MutationCreateAnswerArgs = {
  input?: Maybe<CreateAnswerInput>;
};


export type MutationCreateEmailReferralArgs = {
  input?: Maybe<CreateEmailReferralInput>;
};


export type MutationCreateNftArgs = {
  input?: Maybe<CreateNftInput>;
};


export type MutationCreateQuestionArgs = {
  input?: Maybe<CreateQuestionInput>;
};


export type MutationCreateReactionArgs = {
  input?: Maybe<CreateReactionInput>;
};


export type MutationCreateRedditQuestionFromCommentArgs = {
  input?: Maybe<CreateRedditQuestionFromCommentInput>;
};


export type MutationCreateRedditQuestionFromPostArgs = {
  input?: Maybe<CreateRedditQuestionFromPostInput>;
};


export type MutationCreateRoyaltyPayoutArgs = {
  input?: Maybe<CreateRoyaltyPayoutInput>;
};


export type MutationCreateRoyaltySummaryArgs = {
  input?: Maybe<CreateRoyaltySummaryInput>;
};


export type MutationCreateSupportPaymentArgs = {
  input?: Maybe<CreateSupportPaymentInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationCreateYouTubeCrawlJobArgs = {
  input?: Maybe<CreateYouTubeCrawlJobInput>;
};


export type MutationDirectMessageDiscordUserArgs = {
  message: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationExportFanReportArgs = {
  dateEnd: Scalars['DateTime'];
  dateStart: Scalars['DateTime'];
};


export type MutationInviteDiscordUsersArgs = {
  input?: Maybe<InviteDiscordUsersInputType>;
};


export type MutationLoginFacebookUserArgs = {
  input?: Maybe<LoginFacebookUserInput>;
};


export type MutationLoginUserArgs = {
  input?: Maybe<LoginUserInput>;
};


export type MutationMagicLoginArgs = {
  input?: Maybe<MagicLoginInput>;
};


export type MutationMagicSignupArgs = {
  input?: Maybe<MagicSignupInput>;
};


export type MutationManagerArtistLoginArgs = {
  input?: Maybe<ManagerArtistLoginInput>;
};


export type MutationPayoutRoyaltyArgs = {
  input?: Maybe<CreateRetoolPayoutRoyaltyInput>;
};


export type MutationRefreshRedditModeratorDataArgs = {
  userId: Scalars['String'];
};


export type MutationRequestMagicLoginArgs = {
  input?: Maybe<RequestMagicLoginInput>;
};


export type MutationRequestPasswordArgs = {
  input?: Maybe<RequestPasswordInput>;
};


export type MutationResetPasswordArgs = {
  input?: Maybe<ResetPasswordInput>;
};


export type MutationResetTestDbArgs = {
  input?: Maybe<ResetTestDbInput>;
};


export type MutationRetoolCreateCampaignArgs = {
  input?: Maybe<RetoolCreateCampaignInput>;
};


export type MutationRetoolUpdateQuestionArgs = {
  input?: Maybe<RetoolUpdateQuestionInput>;
};


export type MutationRetoolUpdateTagArgs = {
  input?: Maybe<RetoolUpdateTagInput>;
};


export type MutationRetoolUpdateUserArgs = {
  input?: Maybe<RetoolUpdateUserInput>;
};


export type MutationSetCrawlIgMediasArgs = {
  input?: Maybe<SetCrawlIgMediasInput>;
};


export type MutationStopCrawlIgMediaArgs = {
  input?: Maybe<StopCrawlIgMediaInput>;
};


export type MutationStopCrawlYouTubeMediaArgs = {
  input?: Maybe<StopCrawlYouTubeMediaInput>;
};


export type MutationUpdateAlertArgs = {
  input?: Maybe<UpdateAlertInput>;
};


export type MutationUpdateAnswerArgs = {
  input?: Maybe<UpdateAnswerInput>;
};


export type MutationUpdateFeaturedEntitiesArgs = {
  input?: Maybe<UpdateFeaturedEntitiesInput>;
};


export type MutationUpdateGuildCommandUsersArgs = {
  input?: Maybe<UpdateGuildCommandUsersInputType>;
};


export type MutationUpdateManagerArgs = {
  input?: Maybe<UpdateManagerInput>;
};


export type MutationUpdateProfileArgs = {
  input?: Maybe<UpdateProfileInput>;
};


export type MutationUpdateQuestionArgs = {
  input?: Maybe<UpdateQuestionInput>;
};


export type MutationUpdateRoyaltyPayoutArgs = {
  input?: Maybe<UpdateRoyaltyInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationUpdateYouTubeVideoCrawlJobStatusArgs = {
  input?: Maybe<UpdateYouTubeCrawlVideoJobInput>;
};


export type MutationUpsertSubredditArtistBonsaiConfigArgs = {
  input?: Maybe<UpsertSubredditArtistBonsaiConfigInput>;
};


export type MutationValidateIgMediaArgs = {
  input?: Maybe<ValidateIgMediaInput>;
};


export type MutationVerifyEmailArgs = {
  input?: Maybe<UpdateUserVerifyEmailInputType>;
};


export type MutationVerifyManagerTokenArgs = {
  input?: Maybe<VerifyManagerTokenInput>;
};


export type MutationVerifyPhoneArgs = {
  input?: Maybe<UpdateUserVerifyPhoneInputType>;
};

export type MyCoaches = {
  __typename?: 'MyCoaches';
  coaches: Array<Profile>;
};

export type NetworkHealthResponse = {
  __typename?: 'NetworkHealthResponse';
  stripeReachable: Scalars['Boolean'];
};


export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  totalFans: Scalars['Int'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  cardType: Scalars['String'];
  last4: Scalars['Int'];
  paymentMethodId: Scalars['String'];
};

export enum PaymentState {
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentNotApplicable = 'PAYMENT_NOT_APPLICABLE',
  PaymentProcessing = 'PAYMENT_PROCESSING',
  PaymentRefunded = 'PAYMENT_REFUNDED',
  PaymentSucceeded = 'PAYMENT_SUCCEEDED'
}

export type PayoutRoyalties = {
  __typename?: 'PayoutRoyalties';
  artistId: Scalars['String'];
  artistUsername: Scalars['String'];
  artistWallet: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  nftAmount: Scalars['Int'];
  royalty: Scalars['Float'];
  royaltyIds: Array<Maybe<Scalars['String']>>;
  settled: Scalars['Boolean'];
  txID?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type PayoutRoyaltiesUser = {
  __typename?: 'PayoutRoyaltiesUser';
  isPending: Scalars['Boolean'];
};

export type PersonalizedTag = {
  __typename?: 'PersonalizedTag';
  shared: Scalars['Boolean'];
  tag: Tag;
};


export enum Platform {
  Discord = 'DISCORD',
  Instagram = 'INSTAGRAM',
  Reddit = 'REDDIT',
  WebClient = 'WEB_CLIENT',
  Youtube = 'YOUTUBE'
}

export type Preflight = {
  __typename?: 'Preflight';
  authRole?: Maybe<AuthRoleType>;
  code: ResponseCode;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  publicId?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
  username?: Maybe<Scalars['String']>;
};

export enum PresenceType {
  Busy = 'BUSY',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type Profile = {
  __typename?: 'Profile';
  authRole: Scalars['String'];
  bio?: Maybe<Scalars['String']>;
  discordUserId?: Maybe<Scalars['String']>;
  discordUsername?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instagramAccountId?: Maybe<Scalars['String']>;
  instagramUsername?: Maybe<Scalars['String']>;
  isTakingQuestions: Scalars['Boolean'];
  link?: Maybe<Scalars['GraphQLUrl']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  profilePictureUrl: Scalars['String'];
  redditUserId?: Maybe<Scalars['String']>;
  redditUsername?: Maybe<Scalars['String']>;
  talkToMeAbout?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  verified: Scalars['Boolean'];
  youTubeChannelId?: Maybe<Scalars['String']>;
  youTubeHandle?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  Activities?: Maybe<ActivitiesQueryType>;
  AdminMeetings: AdminMeetingsPaginated;
  AdminRequests: AdminRequestsPaginated;
  AdminTags: AdminTagsPaginated;
  AdminUser: AdminUserDetail;
  AdminUsers: AdminUsersPaginated;
  AllQuestions: Array<Question>;
  AllUsers: Array<User>;
  AllUsersTakingQuestions: Array<User>;
  ArtistInstagramCrawlJobs?: Maybe<ArtistInstagramCrawlJobsQueryType>;
  CheckRedditInstallationStatus: Scalars['Boolean'];
  crawlJobsDetail: YouTubeCrawlJobsDetail;
  DiscordUsers?: Maybe<Array<Scalars['Json']>>;
  EmailAvailable: Scalars['Boolean'];
  engagement: Array<EngagementType>;
  FanSummary?: Maybe<FanSummary>;
  FeaturedEntities: FeaturedEntities;
  GuildModerators: Array<GuildModerator>;
  GuildName: Scalars['String'];
  GuildUsers: Array<DiscordUser>;
  healthCheck: HealthCheckResponse;
  InstagramAccountStats?: Maybe<InstagramAccountStatsQueryType>;
  IsModerator: Scalars['Boolean'];
  languages: Scalars['Json'];
  LoginAssignedManager: ManagerResponse;
  Manager: ManagerResponse;
  managerEngagement: Array<EngagementType>;
  ManagerFanSummary: ManagerFanSummary;
  managerLanguages: Scalars['Json'];
  managerSentiments: Array<SentimentType>;
  MarketplaceHealth: MarketplaceHealth;
  MySubreddits: Array<SubredditData>;
  networkHealth: NetworkHealthResponse;
  NewestOpenQuestion?: Maybe<Question>;
  PayoutRoyalties?: Maybe<Array<Maybe<PayoutRoyalties>>>;
  PayoutRoyaltiesUser: PayoutRoyaltiesUser;
  PhoneNumberAvailable: Scalars['Boolean'];
  Preflight: Preflight;
  Profile?: Maybe<Profile>;
  ProfileSearch: Search;
  Question?: Maybe<Question>;
  QuestionListNavigation: QuestionListNavigation;
  Search: Search;
  sentiments: Array<SentimentType>;
  SortedAnswers: SortedAnswersResponse;
  SortedQuestions: SortedQuestionsResponse;
  SubredditArtistBonsaiConfig: SubredditArtistBonsaiConfigData;
  SubredditModerators: SubredditModeratorsResponse;
  TagPage: TagPage;
  Tags: Array<Tag>;
  TopFanQuestions?: Maybe<TopFanQuestions>;
  User?: Maybe<User>;
  Username: Scalars['String'];
  UsernameAvailable: Scalars['Boolean'];
  UsernameValid: UsernameValidResponse;
  ValidatePasswordResetRequest: ValidatePasswordResetRequestPayload;
  YouTubeMediaDetails?: Maybe<YouTubeMediaDetails>;
};


export type QueryAdminMeetingsArgs = {
  attendance?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<AdminMeetingsFilter>>>;
  offset?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
};


export type QueryAdminRequestsArgs = {
  filters?: Maybe<Array<Maybe<AdminRequestsFilter>>>;
  offset?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
};


export type QueryAdminTagsArgs = {
  filters?: Maybe<Array<Maybe<AdminTagsFilter>>>;
  offset?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
};


export type QueryAdminUserArgs = {
  username: Scalars['String'];
};


export type QueryAdminUsersArgs = {
  endDate?: Maybe<Scalars['DateTime']>;
  filters?: Maybe<Array<Maybe<AdminUsersFilter>>>;
  offset?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
};


export type QueryCheckRedditInstallationStatusArgs = {
  subredditId: Scalars['String'];
};


export type QueryDiscordUsersArgs = {
  guildId: Scalars['String'];
};


export type QueryEmailAvailableArgs = {
  email: Scalars['String'];
};


export type QueryEngagementArgs = {
  days: Scalars['Int'];
};


export type QueryFanSummaryArgs = {
  days: Scalars['Int'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  platform?: Maybe<Platform>;
  sortAnswers?: Maybe<Scalars['String']>;
  sortQuestions?: Maybe<Scalars['String']>;
  sortUsernames?: Maybe<Scalars['String']>;
};


export type QueryGuildNameArgs = {
  guildId: Scalars['String'];
};


export type QueryGuildUsersArgs = {
  guildId: Scalars['String'];
};


export type QueryIsModeratorArgs = {
  guildId: Scalars['String'];
};


export type QueryLanguagesArgs = {
  days: Scalars['Int'];
};


export type QueryLoginAssignedManagerArgs = {
  assignedId: Scalars['String'];
};


export type QueryManagerArgs = {
  managerId?: Maybe<Scalars['String']>;
};


export type QueryManagerEngagementArgs = {
  artistId?: Maybe<Scalars['String']>;
  days: Scalars['Int'];
};


export type QueryManagerFanSummaryArgs = {
  artistId?: Maybe<Scalars['String']>;
  days: Scalars['Int'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  platform?: Maybe<Platform>;
  sortAnswers?: Maybe<Scalars['String']>;
  sortQuestions?: Maybe<Scalars['String']>;
  sortUsernames?: Maybe<Scalars['String']>;
};


export type QueryManagerLanguagesArgs = {
  artistId?: Maybe<Scalars['String']>;
  days: Scalars['Int'];
};


export type QueryManagerSentimentsArgs = {
  artistId?: Maybe<Scalars['String']>;
  days: Scalars['Int'];
};


export type QueryMarketplaceHealthArgs = {
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
};


export type QueryPhoneNumberAvailableArgs = {
  phoneCountryCode: Scalars['Int'];
  phoneNumber: Scalars['String'];
};


export type QueryPreflightArgs = {
  token?: Maybe<Scalars['String']>;
};


export type QueryProfileArgs = {
  username?: Maybe<Scalars['String']>;
};


export type QueryProfileSearchArgs = {
  substring: Scalars['String'];
  username: Scalars['String'];
};


export type QueryQuestionArgs = {
  id: Scalars['ID'];
};


export type QueryQuestionListNavigationArgs = {
  currentQuestionId: Scalars['String'];
  platform?: Maybe<Platform>;
  state: QuestionState;
  username: Scalars['String'];
};


export type QuerySearchArgs = {
  substring: Scalars['String'];
};


export type QuerySentimentsArgs = {
  days: Scalars['Int'];
};


export type QuerySortedAnswersArgs = {
  page: Scalars['Int'];
  platform?: Maybe<Platform>;
  sort: Scalars['String'];
  username: Scalars['String'];
};


export type QuerySortedQuestionsArgs = {
  page: Scalars['Int'];
  platform?: Maybe<Platform>;
  sort: Scalars['String'];
  username: Scalars['String'];
  videoId?: Maybe<Scalars['String']>;
};


export type QuerySubredditArtistBonsaiConfigArgs = {
  subredditId: Scalars['String'];
};


export type QuerySubredditModeratorsArgs = {
  subredditId: Scalars['String'];
};


export type QueryTagPageArgs = {
  slug: Scalars['String'];
};


export type QueryTagsArgs = {
  search?: Maybe<Scalars['String']>;
};


export type QueryTopFanQuestionsArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryUsernameAvailableArgs = {
  username: Scalars['String'];
};


export type QueryUsernameValidArgs = {
  username: Scalars['String'];
};


export type QueryValidatePasswordResetRequestArgs = {
  token: Scalars['String'];
};


export type QueryYouTubeMediaDetailsArgs = {
  mediaUrl: Scalars['String'];
};

export type Question = {
  __typename?: 'Question';
  Answer?: Maybe<Answer>;
  Artist: Profile;
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  discordChannelId?: Maybe<Scalars['String']>;
  discordReactionCount?: Maybe<Scalars['Int']>;
  Fan: Profile;
  flaggedMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: Maybe<Language>;
  platform?: Maybe<Platform>;
  ranking?: Maybe<Scalars['Int']>;
  reactions: Array<Reaction>;
  sentiment?: Maybe<Sentiment>;
  signedUploadShareUrl: Scalars['String'];
  signedUploadUrl: Scalars['String'];
  SourceComment?: Maybe<SourceComment>;
  state: QuestionState;
  supportPayments: Array<SupportPayment>;
  updatedAt: Scalars['DateTime'];
};


export type QuestionSignedUploadShareUrlArgs = {
  fileType: Scalars['String'];
  key?: Maybe<Scalars['String']>;
};


export type QuestionSignedUploadUrlArgs = {
  fileType: Scalars['String'];
  key?: Maybe<Scalars['String']>;
};

export type QuestionListNavigation = {
  __typename?: 'QuestionListNavigation';
  Index: Scalars['Int'];
  NextQuestion?: Maybe<Question>;
  PreviousQuestion?: Maybe<Question>;
  TotalCount: Scalars['Int'];
};

export type QuestionSearchResult = {
  __typename?: 'QuestionSearchResult';
  Artist: Profile;
  body: Scalars['String'];
  entityType: SearchResultEntityType;
  Fan: Profile;
  fanName: Scalars['String'];
  highlight: SearchHighlight;
  id: Scalars['String'];
};

export enum QuestionState {
  AnswerPublishing = 'ANSWER_PUBLISHING',
  Answered = 'ANSWERED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Flagged = 'FLAGGED',
  Open = 'OPEN'
}

export type Reaction = {
  __typename?: 'Reaction';
  artistEmoji?: Maybe<EmojiReaction>;
  createdAt: Scalars['DateTime'];
  emoji: EmojiReaction;
  id: Scalars['ID'];
  questionId: Scalars['ID'];
  ranking: Array<Maybe<EmojiReaction>>;
  Reactor: Profile;
  updatedAt: Scalars['DateTime'];
};

export type RedditAuthResponse = {
  __typename?: 'RedditAuthResponse';
  code: ResponseCode;
  error?: Maybe<Scalars['String']>;
  redirectTarget: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type Request = {
  __typename?: 'Request';
  agenda?: Maybe<Scalars['String']>;
  Coach: Profile;
  declinedAt?: Maybe<Scalars['DateTime']>;
  declinedMessage?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  id: Scalars['ID'];
  Learner: Profile;
  meetingId?: Maybe<Scalars['ID']>;
  price: Scalars['Int'];
  referredBy?: Maybe<Profile>;
  state: RequestState;
  timeSlots: Array<Maybe<Scalars['DateTime']>>;
  type: RequestType;
  updatedAt: Scalars['DateTime'];
};

export type RequestMagicLoginInput = {
  email?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
};

export type RequestMagicLoginPayload = {
  __typename?: 'RequestMagicLoginPayload';
  code: ResponseCode;
  success: Scalars['Boolean'];
};

export type RequestMagicSignupPayload = {
  __typename?: 'RequestMagicSignupPayload';
  code: ResponseCode;
  success: Scalars['Boolean'];
};

export type RequestPasswordInput = {
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
};

export type RequestPasswordPayload = {
  __typename?: 'RequestPasswordPayload';
  code: ResponseCode;
  success: Scalars['Boolean'];
};

export enum RequestState {
  RequestAccepted = 'REQUEST_ACCEPTED',
  RequestCanceled = 'REQUEST_CANCELED',
  RequestDeclined = 'REQUEST_DECLINED',
  RequestIgnored = 'REQUEST_IGNORED',
  RequestSent = 'REQUEST_SENT'
}

export enum RequestType {
  Now = 'NOW',
  Scheduled = 'SCHEDULED'
}

export type ResetPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type ResetTestDbInput = {
  reset: Scalars['Boolean'];
};

export enum ResponseCode {
  AppInstallSuccessful = 'APP_INSTALL_SUCCESSFUL',
  BotInstallationFailed = 'BOT_INSTALLATION_FAILED',
  ErrorAuthenticatingWithDiscord = 'ERROR_AUTHENTICATING_WITH_DISCORD',
  LoginFailedInvalidUser = 'LOGIN_FAILED_INVALID_USER',
  LoginFailedPendingResetRequest = 'LOGIN_FAILED_PENDING_RESET_REQUEST',
  LoginFailedWrongPassword = 'LOGIN_FAILED_WRONG_PASSWORD',
  LoginSuccessful = 'LOGIN_SUCCESSFUL',
  MagicLoginCodeExpired = 'MAGIC_LOGIN_CODE_EXPIRED',
  MagicLoginCodeNotValid = 'MAGIC_LOGIN_CODE_NOT_VALID',
  MagicLoginRequestSuccessful = 'MAGIC_LOGIN_REQUEST_SUCCESSFUL',
  MagicLoginSuccessful = 'MAGIC_LOGIN_SUCCESSFUL',
  MagicLoginUserNotFound = 'MAGIC_LOGIN_USER_NOT_FOUND',
  MagicSignupCodeExpired = 'MAGIC_SIGNUP_CODE_EXPIRED',
  MagicSignupCodeNotValid = 'MAGIC_SIGNUP_CODE_NOT_VALID',
  MagicSignupSuccessful = 'MAGIC_SIGNUP_SUCCESSFUL',
  PreflightFailedTokenNotFound = 'PREFLIGHT_FAILED_TOKEN_NOT_FOUND',
  PreflightFailedTokenNotValid = 'PREFLIGHT_FAILED_TOKEN_NOT_VALID',
  PreflightSuccessful = 'PREFLIGHT_SUCCESSFUL',
  RedditAuthFailed = 'REDDIT_AUTH_FAILED',
  RedditAuthSuccessful = 'REDDIT_AUTH_SUCCESSFUL',
  RequestFailedUserNotFound = 'REQUEST_FAILED_USER_NOT_FOUND',
  RequestSuccessful = 'REQUEST_SUCCESSFUL',
  ResetFailedCodeExpired = 'RESET_FAILED_CODE_EXPIRED',
  ResetFailedCodeNotValid = 'RESET_FAILED_CODE_NOT_VALID',
  ResetSuccessful = 'RESET_SUCCESSFUL',
  SignupFailedInvalidUser = 'SIGNUP_FAILED_INVALID_USER',
  SignupFailedUserNotVerified = 'SIGNUP_FAILED_USER_NOT_VERIFIED',
  SignupSuccessful = 'SIGNUP_SUCCESSFUL',
  UserSignupFailed = 'USER_SIGNUP_FAILED',
  UserSignupSuccessful = 'USER_SIGNUP_SUCCESSFUL',
  ValidationFailedTokenExpired = 'VALIDATION_FAILED_TOKEN_EXPIRED',
  ValidationFailedTokenNotFound = 'VALIDATION_FAILED_TOKEN_NOT_FOUND',
  ValidationSuccessful = 'VALIDATION_SUCCESSFUL'
}

export type ResultsInfo = {
  __typename?: 'ResultsInfo';
  count: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type RetoolCreateCampaignInput = {
  code: Scalars['String'];
  name: Scalars['String'];
  type: CampaignType;
};

export type RetoolUpdateQuestionInput = {
  questionId: Scalars['ID'];
};

export type RetoolUpdateTagAction = {
  setApproved?: Maybe<RetoolUpdateTagActionSetApproved>;
};

export type RetoolUpdateTagActionSetApproved = {
  approved: Scalars['Boolean'];
};

export type RetoolUpdateTagInput = {
  actions: Array<RetoolUpdateTagAction>;
  name: Scalars['String'];
};

export type RetoolUpdateUserAction = {
  setEditoriallyApproved?: Maybe<RetoolUpdateUserActionSetApproved>;
  setFeatured?: Maybe<RetoolUpdateUserActionSetFeatured>;
  setVerified?: Maybe<RetoolUpdateUserActionSetVerified>;
};

export type RetoolUpdateUserActionSetApproved = {
  editoriallyApproved: Scalars['Boolean'];
};

export type RetoolUpdateUserActionSetFeatured = {
  isFeatured: Scalars['Boolean'];
};

export type RetoolUpdateUserActionSetVerified = {
  verified: Scalars['Boolean'];
};

export type RetoolUpdateUserInput = {
  actions: Array<RetoolUpdateUserAction>;
  userId: Scalars['ID'];
};

export type S3UploadResult = {
  __typename?: 'S3UploadResult';
  s3url: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Search = {
  __typename?: 'Search';
  results: Array<SearchResultEntity>;
};

export type SearchHighlight = {
  __typename?: 'SearchHighlight';
  bio?: Maybe<Highlight>;
  body?: Maybe<Highlight>;
  fanName?: Maybe<Highlight>;
  instagramMediaCaption?: Maybe<Highlight>;
  name?: Maybe<Highlight>;
  transcript?: Maybe<Highlight>;
  youTubeVideoTitle?: Maybe<Highlight>;
};

export type SearchResultEntity = AnswerSearchResult | QuestionSearchResult | SourceCommentSearchResult | UserSearchResult;

export enum SearchResultEntityType {
  Answer = 'ANSWER',
  Question = 'QUESTION',
  Sourcecomment = 'SOURCECOMMENT',
  User = 'USER'
}

export enum SearchResultMatchLevelType {
  Full = 'FULL',
  None = 'NONE',
  Partial = 'PARTIAL'
}

export enum Sentiment {
  Mixed = 'MIXED',
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type SentimentType = {
  __typename?: 'SentimentType';
  negative: Scalars['Int'];
  neutral: Scalars['Int'];
  positive: Scalars['Int'];
  range: Scalars['String'];
};

export type SetCrawlIgMediasInput = {
  crawlChannel?: Maybe<Scalars['Boolean']>;
  mediaUrls?: Maybe<Array<Scalars['String']>>;
  searchTerms?: Maybe<Scalars['String']>;
};

export type SortedAnswersResponse = {
  __typename?: 'SortedAnswersResponse';
  answers: Array<Question>;
  nextPage: Scalars['Boolean'];
};

export type SortedQuestionsResponse = {
  __typename?: 'SortedQuestionsResponse';
  nextPage: Scalars['Boolean'];
  questions: Array<Question>;
};

export type SourceComment = {
  __typename?: 'SourceComment';
  artistInstagramUsername?: Maybe<Scalars['String']>;
  artistYouTubeChannelId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  fanInstagramUsername?: Maybe<Scalars['String']>;
  fanYouTubeChannelId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instagramMediaCaption?: Maybe<Scalars['String']>;
  likeCount: Scalars['Int'];
  mediaUrl: Scalars['String'];
  platform?: Maybe<Platform>;
  questionId: Scalars['ID'];
  thumbnail?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  videoId: Scalars['ID'];
  youTubeVideoTitle?: Maybe<Scalars['String']>;
};

export type SourceCommentSearchResult = {
  __typename?: 'SourceCommentSearchResult';
  count: Scalars['Int'];
  entityType: SearchResultEntityType;
  highlight: SearchHighlight;
  instagramMediaCaption?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  videoId: Scalars['String'];
  youTubeVideoTitle?: Maybe<Scalars['String']>;
};

export type StopCrawlIgMediaInput = {
  name: Scalars['String'];
};

export type StopCrawlYouTubeMediaInput = {
  name: Scalars['String'];
};

export enum StripeConnectState {
  ActionRequired = 'ACTION_REQUIRED',
  Connected = 'CONNECTED',
  Connecting = 'CONNECTING',
  NotConnected = 'NOT_CONNECTED'
}

export type SubredditArtistBonsaiConfigData = {
  __typename?: 'SubredditArtistBonsaiConfigData';
  questionRecipient?: Maybe<Profile>;
};

export type SubredditData = {
  __typename?: 'SubredditData';
  subredditId: Scalars['String'];
  subredditName: Scalars['String'];
  subredditUrl: Scalars['String'];
};

export type SubredditModeratorsResponse = {
  __typename?: 'SubredditModeratorsResponse';
  error?: Maybe<Scalars['String']>;
  moderators: Array<Profile>;
  subreddit: SubredditData;
  success: Scalars['Boolean'];
};

export type SupportPayment = {
  __typename?: 'SupportPayment';
  CouponActivation?: Maybe<CouponActivation>;
  couponActivationId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isMinted: Scalars['Boolean'];
  price: Scalars['Int'];
  questionId: Scalars['ID'];
  state: SupportPaymentState;
  Supporter: Profile;
  updatedAt: Scalars['DateTime'];
};

export enum SupportPaymentState {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED'
}

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID'];
  isApproved: Scalars['Boolean'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type TagPage = {
  __typename?: 'TagPage';
  Coaches?: Maybe<Array<Profile>>;
  Tag?: Maybe<Tag>;
};


export type TimelineContact = {
  __typename?: 'TimelineContact';
  Meetings: Array<Meeting>;
  Profile: Profile;
};

export type TimelineSections = {
  __typename?: 'TimelineSections';
  Contacts: Array<TimelineContact>;
  Requests: Array<TimelineContact>;
};


export type TopFanQuestions = {
  __typename?: 'TopFanQuestions';
  topFanQuestions: Array<Question>;
  topFans: Array<TopFans>;
};

export type TopFans = {
  __typename?: 'TopFans';
  answers: Scalars['Int'];
  platform: Array<Platform>;
  questions: Scalars['Int'];
  topQuestion?: Maybe<Question>;
  user: Profile;
};

export type UpdateAlertInput = {
  alertType: AlertType;
};

export type UpdateAlertResponse = {
  __typename?: 'UpdateAlertResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean'];
};

export type UpdateAnswerAction = {
  setBody?: Maybe<UpdateAnswerActionSetBody>;
  setTranscript?: Maybe<UpdateAnswerActionSetTranscript>;
};

export type UpdateAnswerActionSetBody = {
  body: Scalars['String'];
};

export type UpdateAnswerActionSetTranscript = {
  transcript: Scalars['String'];
};

export type UpdateAnswerInput = {
  actions: Array<UpdateAnswerAction>;
  id: Scalars['ID'];
};

export type UpdateDiscordAction = {
  UpdateBotInstall?: Maybe<UpdateDiscordActionUpdateBotInstall>;
  UpsertWebHook?: Maybe<UpdateDiscordActionSetWebHook>;
};

export type UpdateDiscordActionGetCachedUserRequestData = {
  discordUserId: Scalars['String'];
};

export type UpdateDiscordActionSetCacheUserData = {
  artistBonsaiUserId: Scalars['String'];
  fanDiscordUserId: Scalars['String'];
  questionBody: Scalars['String'];
};

export type UpdateDiscordActionSetWebHook = {
  applicationId: Scalars['String'];
  channelId: Scalars['String'];
  guildId: Scalars['String'];
  webHookUrl: Scalars['String'];
};

export type UpdateDiscordActionUpdateBotInstall = {
  applicationAccessToken: Scalars['String'];
  applicationId: Scalars['String'];
  channelId: Scalars['String'];
  guildId: Scalars['String'];
  guildName: Scalars['String'];
  webHookUrl?: Maybe<Scalars['String']>;
};

export type UpdateDiscordActionUpsertBonsaiUser = {
  avatar: Scalars['String'];
  discordUserId: Scalars['String'];
  discordUsername: Scalars['String'];
  email: Scalars['String'];
  locale: Scalars['String'];
};

export type UpdateDiscordInput = {
  actions: Array<UpdateDiscordAction>;
};

export type UpdateFeaturedEntitiesAction = {
  setArtistIds?: Maybe<UpdateFeaturedEntitiesActionSetArtistIds>;
  setQuestionIds?: Maybe<UpdateFeaturedEntitiesActionSetQuestionIds>;
};

export type UpdateFeaturedEntitiesActionSetArtistIds = {
  artistId: Scalars['ID'];
  index: Scalars['Int'];
  replace: Scalars['Int'];
};

export type UpdateFeaturedEntitiesActionSetQuestionIds = {
  index: Scalars['Int'];
  questionId: Scalars['ID'];
  replace: Scalars['Int'];
};

export type UpdateFeaturedEntitiesInput = {
  actions: Array<UpdateFeaturedEntitiesAction>;
};

export type UpdateGuildCommandUsersInputType = {
  guildId: Scalars['String'];
  selectedDiscordUserIds: Array<Scalars['String']>;
};

export type UpdateInstagramLinkedResponse = {
  __typename?: 'UpdateInstagramLinkedResponse';
  deletedSchedules: Array<Maybe<Scalars['String']>>;
};

export type UpdateManagerAction = {
  addArtist?: Maybe<UpdateManagerActionAddArtist>;
  updateManagerToken?: Maybe<UpdateManagerActionUpdateManagerToken>;
};

export type UpdateManagerActionAddArtist = {
  artistUsername: Scalars['String'];
};

export type UpdateManagerActionUpdateManagerToken = {
  artistUsername: Scalars['String'];
};

export type UpdateManagerInput = {
  actions: Array<UpdateManagerAction>;
};

export type UpdateProfileAction = {
  setBio?: Maybe<UpdateProfileActionSetBio>;
  setBookable?: Maybe<UpdateProfileActionSetBookable>;
  setHeadlines?: Maybe<UpdateProfileActionSetHeadlines>;
  setIsTakingQuestions?: Maybe<UpdateProfileActionSetIsTakingQuestions>;
  setLink?: Maybe<UpdateProfileActionSetLink>;
  setLinks?: Maybe<UpdateProfileActionSetLinks>;
  setName?: Maybe<UpdateProfileActionSetName>;
  setPrice?: Maybe<UpdateProfileActionSetPrice>;
  setProfilePicture?: Maybe<UpdateProfileActionSetProfilePicture>;
  setSchedulingConflict?: Maybe<UpdateProfileActionSetSchedulingConflict>;
  setSchedulingConflicts?: Maybe<UpdateProfileActionSetSchedulingConflicts>;
  setTags?: Maybe<UpdateProfileActionSetTags>;
  setTalkToMeAbout?: Maybe<UpdateProfileActionSetTalkToMeAbout>;
  setUsername?: Maybe<UpdateProfileActionSetUsername>;
  setVerified?: Maybe<UpdateProfileActionSetVerified>;
};

export type UpdateProfileActionSetBio = {
  bio?: Maybe<Scalars['String']>;
};

export type UpdateProfileActionSetBookable = {
  bookable: Scalars['Boolean'];
};

export type UpdateProfileActionSetHeadlines = {
  headlines: Array<HeadlineInput>;
};

export type UpdateProfileActionSetIsTakingQuestions = {
  isTakingQuestions: Scalars['Boolean'];
};

export type UpdateProfileActionSetLink = {
  link?: Maybe<Scalars['GraphQLUrl']>;
};

export type UpdateProfileActionSetLinks = {
  links: Array<LinkInput>;
};

export type UpdateProfileActionSetName = {
  name: Scalars['String'];
};

export type UpdateProfileActionSetPrice = {
  isTakingQuestions?: Maybe<Scalars['Boolean']>;
  price: Scalars['Int'];
};

export type UpdateProfileActionSetProfilePicture = {
  profilePictureUrl?: Maybe<Scalars['String']>;
};

export type UpdateProfileActionSetSchedulingConflict = {
  schedulingConflict: Scalars['DateTime'];
};

export type UpdateProfileActionSetSchedulingConflicts = {
  schedulingConflicts: Array<Scalars['DateTime']>;
};

export type UpdateProfileActionSetTags = {
  tags: Array<Scalars['String']>;
};

export type UpdateProfileActionSetTalkToMeAbout = {
  talkToMeAbout?: Maybe<Scalars['String']>;
};

export type UpdateProfileActionSetUsername = {
  username: Scalars['String'];
};

export type UpdateProfileActionSetVerified = {
  verified: Scalars['Boolean'];
};

export type UpdateProfileInput = {
  actions: Array<UpdateProfileAction>;
  id?: Maybe<Scalars['ID']>;
};

export type UpdateQuestionAction = {
  setDeclined?: Maybe<UpdateQuestionActionSetDeclined>;
  setFlagged?: Maybe<UpdateQuestionActionSetFlagged>;
};

export type UpdateQuestionActionSetDeclined = {
  declined: Scalars['Boolean'];
};

export type UpdateQuestionActionSetFlagged = {
  flaggedMessage: Scalars['String'];
};

export type UpdateQuestionInput = {
  actions: Array<UpdateQuestionAction>;
  id: Scalars['ID'];
};

export type UpdateRoyaltyInput = {
  id: Scalars['ID'];
  txID: Scalars['String'];
};

export type UpdateUserAction = {
  setCountryCodeAndPhoneNumber?: Maybe<UpdateUserActionSetCountryCodeAndPhoneNumber>;
  setEnableAnswerCreatedNotifications?: Maybe<UpdateUserActionSetEnableAnswerCreatedNotifications>;
  setEnableQuestionCreatedNotifications?: Maybe<UpdateUserActionSetEnableQuestionCreatedNotifications>;
  setEnableQuestionExpirationNotifications?: Maybe<UpdateUserActionSetEnableQuestionExpirationNotifications>;
  setFavoriteUsers?: Maybe<UpdateUserActionSetFavoriteUsers>;
  setLastSeen?: Maybe<UpdateUserActionSetLastSeen>;
  setManager?: Maybe<UpdateUserActionSetManager>;
  setPassword?: Maybe<UpdateUserActionSetPassword>;
  setReceivePromotionalEmailUpdates?: Maybe<UpdateUserActionSetReceivePromotionalEmailUpdates>;
  setReceiveSMSUpdates?: Maybe<UpdateUserActionSetReceiveSmsUpdates>;
  setResendPhoneVerification?: Maybe<UpdateUserActionSetResendPhoneVerification>;
  setSavePaymentMethod?: Maybe<UpdateUserActionSetSavePaymentMethod>;
  setTimezone?: Maybe<UpdateUserActionSetTimezone>;
  setTransferBalance?: Maybe<UpdateUserActionSetTransferBalance>;
  setUnlinkReddit?: Maybe<UpdateUserActionSetUnlinkReddit>;
  setUnlinkYouTube?: Maybe<UpdateUserActionSetUnlinkYouTube>;
};

export type UpdateUserActionSetCountryCodeAndPhoneNumber = {
  phoneCountryCode: Scalars['Int'];
  phoneNumber: Scalars['PhoneNumber'];
};

export type UpdateUserActionSetEnableAnswerCreatedNotifications = {
  enable: Scalars['Boolean'];
};

export type UpdateUserActionSetEnableQuestionCreatedNotifications = {
  enable: Scalars['Boolean'];
};

export type UpdateUserActionSetEnableQuestionExpirationNotifications = {
  enable: Scalars['Boolean'];
};

export type UpdateUserActionSetFavoriteUsers = {
  userIds: Array<Maybe<Scalars['String']>>;
};

export type UpdateUserActionSetLastSeen = {
  seen: Scalars['Boolean'];
};

export type UpdateUserActionSetManager = {
  isManager: Scalars['Boolean'];
};

export type UpdateUserActionSetPassword = {
  password: Scalars['String'];
};

export type UpdateUserActionSetReceivePromotionalEmailUpdates = {
  receivePromotionalEmailUpdates: Scalars['Boolean'];
};

export type UpdateUserActionSetReceiveSmsUpdates = {
  receiveSMSUpdates: Scalars['Boolean'];
};

export type UpdateUserActionSetResendEmailVerification = {
  email: Scalars['String'];
};

export type UpdateUserActionSetResendPhoneVerification = {
  resend: Scalars['Boolean'];
};

export type UpdateUserActionSetSavePaymentMethod = {
  paymentMethodId?: Maybe<Scalars['String']>;
  savePaymentMethod: Scalars['Boolean'];
};

export type UpdateUserActionSetTimezone = {
  timezone: Scalars['Timezone'];
};

export type UpdateUserActionSetTransferBalance = {
  transferBalance: Scalars['Boolean'];
};

export type UpdateUserActionSetUnlinkReddit = {
  isRedditUnlinked: Scalars['Boolean'];
};

export type UpdateUserActionSetUnlinkYouTube = {
  isYouTubeUnlinked: Scalars['Boolean'];
};

export type UpdateUserInput = {
  actions: Array<UpdateUserAction>;
};

export type UpdateUserVerifyEmailActions = {
  sendEmailVerification?: Maybe<UpdateUserVerifyEmailActionSendEmailVerification>;
  verifyEmail?: Maybe<UpdateUserVerifyEmailActionVerifyEmail>;
};

export type UpdateUserVerifyEmailActionSendEmailVerification = {
  email: Scalars['String'];
};

export type UpdateUserVerifyEmailActionVerifyEmail = {
  email: Scalars['String'];
  verificationToken: Scalars['String'];
};

export type UpdateUserVerifyEmailInputType = {
  actions: Array<UpdateUserVerifyEmailActions>;
};

export type UpdateUserVerifyPhoneActions = {
  sendPhoneVerification?: Maybe<UpdateUserVerifyPhoneActionSendPhoneVerification>;
  verifyPhone?: Maybe<UpdateUserVerifyPhoneActionVerifyPhone>;
};

export type UpdateUserVerifyPhoneActionSendPhoneVerification = {
  phoneCountryCode: Scalars['Int'];
  phoneNumber: Scalars['String'];
};

export type UpdateUserVerifyPhoneActionVerifyPhone = {
  phoneCountryCode: Scalars['Int'];
  phoneNumber: Scalars['String'];
  verificationToken: Scalars['String'];
};

export type UpdateUserVerifyPhoneInputType = {
  actions: Array<UpdateUserVerifyPhoneActions>;
};

export type UpdateYouTubeCrawlVideoJobInput = {
  jobId: Scalars['ID'];
  status: JobStatus;
};

export type UpsertSubredditArtistBonsaiConfigInput = {
  questionRecipientId?: Maybe<Scalars['String']>;
  subredditId: Scalars['String'];
};

export type UpsertSubredditArtistBonsaiConfigResponse = {
  __typename?: 'UpsertSubredditArtistBonsaiConfigResponse';
  error?: Maybe<Scalars['String']>;
  questionRecipient?: Maybe<Profile>;
  questionRecipientId?: Maybe<Scalars['String']>;
  subredditId: Scalars['String'];
  success: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  allTimeEarnings: Scalars['Float'];
  answerCreatedNotificationEnabled?: Maybe<Scalars['Boolean']>;
  authRole: AuthRoleType;
  bankAccountCountry: Scalars['String'];
  Campaign?: Maybe<Campaign>;
  canRequestFreeMeeting: Scalars['Boolean'];
  cashBalance: Scalars['Float'];
  createdAt: Scalars['Date'];
  deletedAt: Scalars['Date'];
  discordUserId?: Maybe<Scalars['String']>;
  discordUsername?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  favoriteUserIds: Array<Maybe<Scalars['String']>>;
  hasFans: Scalars['Boolean'];
  id: Scalars['ID'];
  instagramAccountId?: Maybe<Scalars['String']>;
  instagramFollowerCount?: Maybe<Scalars['String']>;
  instagramMediaCount?: Maybe<Scalars['String']>;
  instagramUsername?: Maybe<Scalars['String']>;
  isInstagramLinked: Scalars['Boolean'];
  isRedditLinked: Scalars['Boolean'];
  isTakingQuestions: Scalars['Boolean'];
  lastSeen?: Maybe<Scalars['DateTime']>;
  managerIds: Array<Maybe<Scalars['String']>>;
  managerToken?: Maybe<Scalars['String']>;
  managerTokenRequestedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneVerified: Scalars['Boolean'];
  profilePercentCompleted: Scalars['Int'];
  profilePictureUrl: Scalars['String'];
  publicId: Scalars['ID'];
  questionCreatedNotificationEnabled?: Maybe<Scalars['Boolean']>;
  questionExpirationReminderEnabled?: Maybe<Scalars['Boolean']>;
  receivePromotionalEmailUpdates: Scalars['Boolean'];
  receiveSMSUpdates: Scalars['Boolean'];
  redditAccountAge?: Maybe<Scalars['String']>;
  redditCommentKarma?: Maybe<Scalars['String']>;
  redditUserId?: Maybe<Scalars['String']>;
  redditUsername?: Maybe<Scalars['String']>;
  savedPaymentMethod?: Maybe<PaymentMethod>;
  savePaymentMethod: Scalars['Boolean'];
  signedUploadUrl: Scalars['String'];
  stripeConnectLoginUrl: Scalars['String'];
  stripeConnectSetupUrl: Scalars['String'];
  stripeConnectState: StripeConnectState;
  stripeSetupIntentClientSecret: Scalars['String'];
  timezone: Scalars['String'];
  updatedAt: Scalars['Date'];
  username: Scalars['String'];
  youTubeAccountDetails?: Maybe<YouTubeAccountDetails>;
  youTubeChannelId?: Maybe<Scalars['String']>;
  youTubeChannelSubscriberCount?: Maybe<Scalars['Int']>;
  youTubeChannelVideoCount?: Maybe<Scalars['Int']>;
  youTubeHandle?: Maybe<Scalars['String']>;
};


export type UserSignedUploadUrlArgs = {
  fileType: Scalars['String'];
};


export type UserStripeConnectSetupUrlArgs = {
  country: Scalars['String'];
};

export type UserIdentity = {
  __typename?: 'UserIdentity';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  platform: Platform;
  primaryUserId: Scalars['String'];
  score?: Maybe<Scalars['Int']>;
  userId: Scalars['String'];
  username: Scalars['String'];
};

export type UsernameValidResponse = {
  __typename?: 'UsernameValidResponse';
  isValid: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  suggestedUsername?: Maybe<Scalars['String']>;
};

export type UserSearchResult = {
  __typename?: 'UserSearchResult';
  bio?: Maybe<Scalars['String']>;
  entityType: SearchResultEntityType;
  highlight: SearchHighlight;
  name?: Maybe<Scalars['String']>;
  profilePictureUrl: Scalars['String'];
  username: Scalars['String'];
  verified: Scalars['Boolean'];
};

export type UserTag = {
  __typename?: 'UserTag';
  tag: Tag;
};

export type ValidateIgMediaInput = {
  mediaUrl: Scalars['String'];
};

export type ValidateIgMediaResponse = {
  __typename?: 'ValidateIgMediaResponse';
  caption?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  mediaUrl: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type ValidatePasswordResetRequestPayload = {
  __typename?: 'ValidatePasswordResetRequestPayload';
  code: ResponseCode;
  success: Scalars['Boolean'];
};

export type VerifyManagerTokenInput = {
  managerToken: Scalars['String'];
};

export type VerifyPhoneActionSetVerifyPhone = {
  code: Scalars['String'];
};

export type VerifyPhoneNumberAction = {
  setVerifyPhone?: Maybe<VerifyPhoneActionSetVerifyPhone>;
};

export type VerifyPhoneNumberInput = {
  actions: Array<VerifyPhoneNumberAction>;
};

export type YouTubeAccountDetails = {
  __typename?: 'YouTubeAccountDetails';
  channelCrawlJobCreatedAt?: Maybe<Scalars['DateTime']>;
  isChannelCrawlEnabled: Scalars['Boolean'];
  isLinked: Scalars['Boolean'];
  latestQuestionCreatedAt?: Maybe<Scalars['DateTime']>;
  questionCreatedCount: Scalars['Int'];
  videoCrawlJobCount: Scalars['Int'];
};

export type YouTubeCrawlJobs = {
  __typename?: 'YouTubeCrawlJobs';
  ArtistYouTubeChannelCrawlJob?: Maybe<ArtistYouTubeChannelCrawlJob>;
  ArtistYouTubeVideoCrawlJobs: Array<ArtistYouTubeVideoCrawlJob>;
};

export type YouTubeCrawlJobsDetail = {
  __typename?: 'YouTubeCrawlJobsDetail';
  channelCrawlJob?: Maybe<ArtistYouTubeChannelCrawlJob>;
  videoCrawlJobs: Array<ArtistYouTubeVideoCrawlJob>;
};

export type YouTubeMediaDetails = {
  __typename?: 'YouTubeMediaDetails';
  error?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  mediaUrl: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type LoginUserMutationVariables = Exact<{
  password: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
}>;


export type LoginUserMutation = { __typename?: 'Mutation', LoginUser: { __typename?: 'AuthPayload', token?: Maybe<string>, success: boolean, code: ResponseCode, userId?: Maybe<string>, username?: Maybe<string> } };

export type RequestMagicLoginMutationVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  path?: Maybe<Scalars['String']>;
}>;


export type RequestMagicLoginMutation = { __typename?: 'Mutation', RequestMagicLogin?: Maybe<{ __typename?: 'RequestMagicLoginPayload', success: boolean, code: ResponseCode }> };

export type MagicLoginMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type MagicLoginMutation = { __typename?: 'Mutation', MagicLogin?: Maybe<{ __typename?: 'AuthPayload', success: boolean, code: ResponseCode, token?: Maybe<string>, userId?: Maybe<string>, username?: Maybe<string> }> };

export type RequestPasswordMutationVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
}>;


export type RequestPasswordMutation = { __typename?: 'Mutation', RequestPassword?: Maybe<{ __typename?: 'RequestPasswordPayload', success: boolean, code: ResponseCode }> };

export type ValidatePasswordResetRequestQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type ValidatePasswordResetRequestQuery = { __typename?: 'Query', ValidatePasswordResetRequest: { __typename?: 'ValidatePasswordResetRequestPayload', success: boolean, code: ResponseCode } };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', ResetPassword?: Maybe<{ __typename?: 'AuthPayload', success: boolean, code: ResponseCode, token?: Maybe<string>, userId?: Maybe<string> }> };

export type VerifyEmailOtpMutationVariables = Exact<{
  code: Scalars['String'];
  email: Scalars['String'];
}>;


export type VerifyEmailOtpMutation = { __typename?: 'Mutation', MagicSignup?: Maybe<{ __typename?: 'MagicSignupPayload', success: boolean, code?: Maybe<ResponseCode> }> };

export type SendVerifyEmailOtpMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendVerifyEmailOtpMutation = { __typename?: 'Mutation', MagicSignup?: Maybe<{ __typename?: 'MagicSignupPayload', success: boolean, code?: Maybe<ResponseCode> }> };

export type VerifyPhoneOtpMutationVariables = Exact<{
  code: Scalars['String'];
  phoneNumber: Scalars['PhoneNumber'];
  phoneCountryCode: Scalars['Int'];
}>;


export type VerifyPhoneOtpMutation = { __typename?: 'Mutation', MagicSignup?: Maybe<{ __typename?: 'MagicSignupPayload', success: boolean, code?: Maybe<ResponseCode> }> };

export type SendVerifyPhoneOtpMutationVariables = Exact<{
  phoneNumber: Scalars['PhoneNumber'];
  phoneCountryCode: Scalars['Int'];
}>;


export type SendVerifyPhoneOtpMutation = { __typename?: 'Mutation', MagicSignup?: Maybe<{ __typename?: 'MagicSignupPayload', success: boolean, code?: Maybe<ResponseCode> }> };

export type InviteDiscordUsersMutationVariables = Exact<{
  discordUserIds: Array<Scalars['String']>;
  guildId: Scalars['String'];
}>;


export type InviteDiscordUsersMutation = { __typename?: 'Mutation', InviteDiscordUsers: any };

export type AuthenticateDiscordCallbackMutationVariables = Exact<{
  code: Scalars['String'];
  guildId: Scalars['String'];
}>;


export type AuthenticateDiscordCallbackMutation = { __typename?: 'Mutation', AuthenticateDiscordCallback: any };

export type UpdateGuildCommandUsersMutationVariables = Exact<{
  selectedDiscordUserIds: Array<Scalars['String']>;
  guildId: Scalars['String'];
}>;


export type UpdateGuildCommandUsersMutation = { __typename?: 'Mutation', UpdateGuildCommandUsers: any };

export type ExportFanSummaryMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportFanSummaryMutation = { __typename?: 'Mutation', ExportFanSummary: { __typename?: 'S3UploadResult', s3url: string, success: boolean } };

export type UpdateFeaturedEntitiesSetQuestionIdsMutationVariables = Exact<{
  questionId: Scalars['ID'];
  index: Scalars['Int'];
  replace: Scalars['Int'];
}>;


export type UpdateFeaturedEntitiesSetQuestionIdsMutation = { __typename?: 'Mutation', UpdateFeaturedEntities: { __typename?: 'FeaturedEntities', id: string } };

export type UpdateFeaturedEntitiesSetArtistIdsMutationVariables = Exact<{
  artistId: Scalars['ID'];
  index: Scalars['Int'];
  replace: Scalars['Int'];
}>;


export type UpdateFeaturedEntitiesSetArtistIdsMutation = { __typename?: 'Mutation', UpdateFeaturedEntities: { __typename?: 'FeaturedEntities', id: string } };

export type LoginFacebookUserMutationVariables = Exact<{
  facebookAccessToken: Scalars['String'];
  facebookUserId: Scalars['String'];
}>;


export type LoginFacebookUserMutation = { __typename?: 'Mutation', LoginFacebookUser: { __typename?: 'AuthPayload', token?: Maybe<string>, success: boolean, code: ResponseCode, userId?: Maybe<string>, username?: Maybe<string> } };

export type SetCrawlIgMediasMutationVariables = Exact<{
  mediaUrls?: Maybe<Array<Scalars['String']>>;
  searchTerms?: Maybe<Scalars['String']>;
  crawlChannel?: Maybe<Scalars['Boolean']>;
}>;


export type SetCrawlIgMediasMutation = { __typename?: 'Mutation', SetCrawlIgMedias: boolean };

export type StopCrawlIgMediaMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type StopCrawlIgMediaMutation = { __typename?: 'Mutation', StopCrawlIgMedia: boolean };

export type ValidateFacebookAccessTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type ValidateFacebookAccessTokenMutation = { __typename?: 'Mutation', ValidateFacebookAccessToken: boolean };

export type ValidateIgMediaMutationVariables = Exact<{
  mediaUrl: Scalars['String'];
}>;


export type ValidateIgMediaMutation = { __typename?: 'Mutation', ValidateIgMedia: { __typename?: 'ValidateIgMediaResponse', errorMessage?: Maybe<string>, caption?: Maybe<string>, thumbnail?: Maybe<string>, username?: Maybe<string>, mediaUrl: string } };

export type UpdateInstagramLinkedMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateInstagramLinkedMutation = { __typename?: 'Mutation', UpdateInstagramLinked: { __typename?: 'UpdateInstagramLinkedResponse', deletedSchedules: Array<Maybe<string>> } };

export type UpdateProfileSetUsernameMutationVariables = Exact<{
  username: Scalars['String'];
}>;


export type UpdateProfileSetUsernameMutation = { __typename?: 'Mutation', UpdateProfile: { __typename?: 'Profile', username: string } };

export type UpdateProfileSetLinkMutationVariables = Exact<{
  link?: Maybe<Scalars['GraphQLUrl']>;
}>;


export type UpdateProfileSetLinkMutation = { __typename?: 'Mutation', UpdateProfile: { __typename?: 'Profile', link?: Maybe<any> } };

export type UpdateProfileSetBioMutationVariables = Exact<{
  bio?: Maybe<Scalars['String']>;
}>;


export type UpdateProfileSetBioMutation = { __typename?: 'Mutation', UpdateProfile: { __typename?: 'Profile', bio?: Maybe<string> } };

export type UpdateProfileSetTalkToMeAboutMutationVariables = Exact<{
  talkToMeAbout: Scalars['String'];
}>;


export type UpdateProfileSetTalkToMeAboutMutation = { __typename?: 'Mutation', UpdateProfile: { __typename?: 'Profile', talkToMeAbout?: Maybe<string> } };

export type UpdateProfileSetPriceMutationVariables = Exact<{
  price: Scalars['Int'];
  isTakingQuestions: Scalars['Boolean'];
}>;


export type UpdateProfileSetPriceMutation = { __typename?: 'Mutation', UpdateProfile: { __typename?: 'Profile', price?: Maybe<number> } };

export type UpdateProfileSetProfilePictureMutationVariables = Exact<{
  profilePictureUrl: Scalars['String'];
}>;


export type UpdateProfileSetProfilePictureMutation = { __typename?: 'Mutation', UpdateProfile: { __typename?: 'Profile', profilePictureUrl: string } };

export type UpdateProfileSetNameMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type UpdateProfileSetNameMutation = { __typename?: 'Mutation', UpdateProfile: { __typename?: 'Profile', name?: Maybe<string> } };

export type UpdateProfileSetIsTakingQuestionsMutationVariables = Exact<{
  isTakingQuestions: Scalars['Boolean'];
}>;


export type UpdateProfileSetIsTakingQuestionsMutation = { __typename?: 'Mutation', UpdateProfile: { __typename?: 'Profile', isTakingQuestions: boolean } };

export type CreateQuestionMutationVariables = Exact<{
  artistId: Scalars['ID'];
  body: Scalars['String'];
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', CreateQuestion: { __typename?: 'CreateQuestionResponse', success: boolean, question?: Maybe<{ __typename?: 'Question', id: string }>, error?: Maybe<{ __typename?: 'Error', errorType: ErrorType }> } };

export type CreateAnswerMutationVariables = Exact<{
  fanId: Scalars['ID'];
  body: Scalars['String'];
  questionId: Scalars['ID'];
}>;


export type CreateAnswerMutation = { __typename?: 'Mutation', CreateAnswer: { __typename?: 'CreateAnswerResponse', success: boolean, answer?: Maybe<{ __typename?: 'Answer', id: string, body: string, questionId: string }>, error?: Maybe<{ __typename?: 'Error', errorType: ErrorType }> } };

export type CreateNftMutationVariables = Exact<{
  fanId: Scalars['ID'];
  questionId: Scalars['ID'];
  wallet: Scalars['String'];
}>;


export type CreateNftMutation = { __typename?: 'Mutation', CreateNft: { __typename?: 'CreateNftResponse', success: boolean, error?: Maybe<{ __typename?: 'Error', errorType: ErrorType }> } };

export type CreateSupportPaymentMutationVariables = Exact<{
  questionId: Scalars['ID'];
  price: Scalars['Int'];
  paymentMethodId?: Maybe<Scalars['String']>;
  savePaymentMethod: Scalars['Boolean'];
  couponCode?: Maybe<Scalars['String']>;
}>;


export type CreateSupportPaymentMutation = { __typename?: 'Mutation', CreateSupportPayment: { __typename?: 'CreateSupportPaymentResponse', success: boolean, supportPayment?: Maybe<{ __typename?: 'SupportPayment', id: string, price: number, state: SupportPaymentState, Supporter: { __typename?: 'Profile', id: string }, CouponActivation?: Maybe<{ __typename?: 'CouponActivation', id: string, discountAmountApplied: number }> }>, question: { __typename?: 'Question', supportPayments: Array<{ __typename?: 'SupportPayment', id: string }> }, error?: Maybe<{ __typename?: 'Error', errorType: ErrorType }> } };

export type UpdateQuestionSetDeclinedMutationVariables = Exact<{
  questionId: Scalars['ID'];
}>;


export type UpdateQuestionSetDeclinedMutation = { __typename?: 'Mutation', UpdateQuestion: { __typename?: 'Question', id: string } };

export type UpdateQuestionSetFlaggedMutationVariables = Exact<{
  questionId: Scalars['ID'];
  flaggedMessage: Scalars['String'];
}>;


export type UpdateQuestionSetFlaggedMutation = { __typename?: 'Mutation', UpdateQuestion: { __typename?: 'Question', id: string } };

export type UpdateAnswerSetBodyMutationVariables = Exact<{
  answerId: Scalars['ID'];
  body: Scalars['String'];
}>;


export type UpdateAnswerSetBodyMutation = { __typename?: 'Mutation', UpdateAnswer: { __typename?: 'Answer', body: string } };

export type CreateReactionMutationVariables = Exact<{
  questionId: Scalars['ID'];
  emoji?: Maybe<EmojiReaction>;
}>;


export type CreateReactionMutation = { __typename?: 'Mutation', CreateReaction: { __typename?: 'CreateReactionResponse', reactions: Array<Maybe<{ __typename?: 'Reaction', emoji: EmojiReaction, ranking: Array<Maybe<EmojiReaction>>, artistEmoji?: Maybe<EmojiReaction>, Reactor: { __typename?: 'Profile', id: string } }>> } };

export type CreateEmailReferralMutationVariables = Exact<{
  recipientName: Scalars['String'];
  recipientEmail: Scalars['String'];
  message: Scalars['String'];
  username: Scalars['String'];
}>;


export type CreateEmailReferralMutation = { __typename?: 'Mutation', CreateEmailReferral?: Maybe<boolean> };

export type CreateRoyaltySummaryMutationVariables = Exact<{
  artistId: Scalars['ID'];
}>;


export type CreateRoyaltySummaryMutation = { __typename?: 'Mutation', CreateRoyaltySummary: { __typename?: 'CreateRoyaltySummaryResponse', amount: number, value: number, usd_value: number } };

export type CreateRoyaltyPayoutMutationVariables = Exact<{
  wallet: Scalars['String'];
}>;


export type CreateRoyaltyPayoutMutation = { __typename?: 'Mutation', CreateRoyaltyPayout: { __typename?: 'CreateRoyaltyPayoutResponse', success: boolean, error?: Maybe<{ __typename?: 'Error', errorType: ErrorType }> } };

export type UpdateRoyaltyPayoutMutationVariables = Exact<{
  id: Scalars['ID'];
  txID: Scalars['String'];
}>;


export type UpdateRoyaltyPayoutMutation = { __typename?: 'Mutation', UpdateRoyaltyPayout?: Maybe<Array<Maybe<{ __typename?: 'PayoutRoyalties', nftAmount: number, artistWallet: string, createdAt: string, artistUsername: string, artistId: string, txID?: Maybe<string>, royalty: number, settled: boolean, royaltyIds: Array<Maybe<string>>, id: string }>>> };

export type CreateUserMutationVariables = Exact<{
  name: Scalars['String'];
  username: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['PhoneNumber'];
  phoneCountryCode: Scalars['Int'];
  password: Scalars['String'];
  path?: Maybe<Scalars['String']>;
  locale: Scalars['GraphQLLocale'];
  referredByCoach?: Maybe<Scalars['String']>;
  referredByUser?: Maybe<Scalars['String']>;
  campaignCode?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', CreateUser?: Maybe<{ __typename?: 'AuthPayload', token?: Maybe<string>, userId?: Maybe<string>, username?: Maybe<string>, code: ResponseCode, success: boolean }> };

export type ManagerArtistLoginMutationVariables = Exact<{
  artistUsername: Scalars['String'];
  managerToken?: Maybe<Scalars['String']>;
}>;


export type ManagerArtistLoginMutation = { __typename?: 'Mutation', ManagerArtistLogin: { __typename?: 'AuthPayload', token?: Maybe<string>, userId?: Maybe<string>, username?: Maybe<string>, code: ResponseCode, success: boolean } };

export type UpdateUserSetLastSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateUserSetLastSeenMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', id: string } };

export type UpdateAlertMutationVariables = Exact<{
  alertType: AlertType;
}>;


export type UpdateAlertMutation = { __typename?: 'Mutation', UpdateAlert: { __typename?: 'UpdateAlertResponse', success: boolean, error?: Maybe<{ __typename?: 'Error', errorType: ErrorType }> } };

export type UpdateUserSetCountryCodeAndPhoneNumberMutationVariables = Exact<{
  phoneCountryCode: Scalars['Int'];
  phoneNumber: Scalars['PhoneNumber'];
}>;


export type UpdateUserSetCountryCodeAndPhoneNumberMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', phoneCountryCode?: Maybe<number>, phoneNumber?: Maybe<string>, phoneVerified: boolean } };

export type ResendPhoneVerificationMutationVariables = Exact<{
  resend: Scalars['Boolean'];
}>;


export type ResendPhoneVerificationMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', id: string } };

export type UpdateUserSetReceiveSmsUpdatesMutationVariables = Exact<{
  receiveSMSUpdates: Scalars['Boolean'];
}>;


export type UpdateUserSetReceiveSmsUpdatesMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', receiveSMSUpdates: boolean } };

export type UpdateUserSetEnableQuestionCreatedNotificationsMutationVariables = Exact<{
  enableQuestionCreatedNotifications: Scalars['Boolean'];
}>;


export type UpdateUserSetEnableQuestionCreatedNotificationsMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', questionCreatedNotificationEnabled?: Maybe<boolean> } };

export type UpdateUserSetEnableAnswerCreatedNotificationsMutationVariables = Exact<{
  enableAnswerCreatedNotifications: Scalars['Boolean'];
}>;


export type UpdateUserSetEnableAnswerCreatedNotificationsMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', answerCreatedNotificationEnabled?: Maybe<boolean> } };

export type UpdateUserSetEnableQuestionExpirationNotificationsMutationVariables = Exact<{
  enableQuestionExpirationNotifications: Scalars['Boolean'];
}>;


export type UpdateUserSetEnableQuestionExpirationNotificationsMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', questionExpirationReminderEnabled?: Maybe<boolean> } };

export type UpdateUserSetSavePaymentMethodMutationVariables = Exact<{
  savePaymentMethod: Scalars['Boolean'];
  paymentMethodId: Scalars['String'];
}>;


export type UpdateUserSetSavePaymentMethodMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', id: string } };

export type UpdateUserActionSetTimezoneMutationVariables = Exact<{
  timezone: Scalars['Timezone'];
}>;


export type UpdateUserActionSetTimezoneMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', id: string } };

export type UpdateUserSetTransferBalanceMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateUserSetTransferBalanceMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', id: string } };

export type UpdateUserSetReceivePromotionalEmailUpdatesMutationVariables = Exact<{
  receivePromotionalEmailUpdates: Scalars['Boolean'];
}>;


export type UpdateUserSetReceivePromotionalEmailUpdatesMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', receivePromotionalEmailUpdates: boolean } };

export type UpdateUserSetPasswordMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type UpdateUserSetPasswordMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', email: string } };

export type UpdateUserSetUnlinkYouTubeMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateUserSetUnlinkYouTubeMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', id: string } };

export type UpdateUserSetManagerMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateUserSetManagerMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', id: string } };

export type UpdateUserSetUnlinkRedditMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateUserSetUnlinkRedditMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', id: string } };

export type UpdateUserSetFavoriteUsersMutationVariables = Exact<{
  userIds: Array<Scalars['String']>;
}>;


export type UpdateUserSetFavoriteUsersMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', favoriteUserIds: Array<Maybe<string>> } };

export type UpdateManagerAddArtistMutationVariables = Exact<{
  artistUsername: Scalars['String'];
}>;


export type UpdateManagerAddArtistMutation = { __typename?: 'Mutation', UpdateManager?: Maybe<{ __typename?: 'Manager', managerId: string, createdAt: string, artists: Array<(
      { __typename?: 'User' }
      & UserOnGetUserFragmentFragment
    )> }> };

export type UpdateManagerUpdateManagerTokenMutationVariables = Exact<{
  artistUsername: Scalars['String'];
}>;


export type UpdateManagerUpdateManagerTokenMutation = { __typename?: 'Mutation', UpdateManager?: Maybe<{ __typename?: 'Manager', managerId: string, createdAt: string, artists: Array<(
      { __typename?: 'User' }
      & UserOnGetUserFragmentFragment
    )> }> };

export type UpdateUserVerifyEmailActionSendEmailVerificationMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type UpdateUserVerifyEmailActionSendEmailVerificationMutation = { __typename?: 'Mutation', VerifyEmail: boolean };

export type UpdateUserVerifyEmailActionVerifyEmailMutationVariables = Exact<{
  email: Scalars['String'];
  verificationToken: Scalars['String'];
}>;


export type UpdateUserVerifyEmailActionVerifyEmailMutation = { __typename?: 'Mutation', VerifyEmail: boolean };

export type UpdateUserVerifyPhoneActionSendPhoneVerificationMutationVariables = Exact<{
  phoneCountryCode: Scalars['Int'];
  phoneNumber: Scalars['String'];
}>;


export type UpdateUserVerifyPhoneActionSendPhoneVerificationMutation = { __typename?: 'Mutation', VerifyPhone: boolean };

export type UpdateUserVerifyPhoneActionVerifyPhoneMutationVariables = Exact<{
  phoneCountryCode: Scalars['Int'];
  phoneNumber: Scalars['String'];
  verificationToken: Scalars['String'];
}>;


export type UpdateUserVerifyPhoneActionVerifyPhoneMutation = { __typename?: 'Mutation', VerifyPhone: boolean };

export type GetYouTubeMediaDetailsQueryVariables = Exact<{
  mediaUrl: Scalars['String'];
}>;


export type GetYouTubeMediaDetailsQuery = { __typename?: 'Query', YouTubeMediaDetails?: Maybe<{ __typename?: 'YouTubeMediaDetails', isValid: boolean, error?: Maybe<string>, title?: Maybe<string>, thumbnail?: Maybe<string>, mediaUrl: string }> };

export type CreateYouTubeCrawlJobMutationVariables = Exact<{
  mediaUrls: Array<Scalars['String']>;
  uploadChannel: Scalars['Boolean'];
}>;


export type CreateYouTubeCrawlJobMutation = { __typename?: 'Mutation', CreateYouTubeCrawlJob?: Maybe<{ __typename?: 'CreateYouTubeCrawlJobResponse', success: boolean, error?: Maybe<string>, jobs: Array<Maybe<{ __typename?: 'ArtistYouTubeVideoCrawlJob', name: string, status: JobStatus, videoId: string, schedule: string, expiresAt?: Maybe<any>, createdAt: any }>>, channelCrawlJob?: Maybe<{ __typename?: 'ArtistYouTubeChannelCrawlJob', name: string, status: JobStatus, schedule: string, createdAt: any }> }> };

export type AuthenticateGoogleCallbackMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type AuthenticateGoogleCallbackMutation = { __typename?: 'Mutation', AuthenticateGoogleCallback: any };

export type ValidateGoogleAccessTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type ValidateGoogleAccessTokenMutation = { __typename?: 'Mutation', ValidateGoogleAccessToken: boolean };

export type StopCrawlYouTubeMediaMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type StopCrawlYouTubeMediaMutation = { __typename?: 'Mutation', StopCrawlYouTubeMedia: boolean };

export type ActivityDetailFragment = { __typename?: 'Activity', id: string, userId: string, type: ActivityType, createdAt: any, updatedAt: any, Question?: Maybe<(
    { __typename?: 'Question' }
    & QuestionDetailFragment
  )>, Reaction?: Maybe<(
    { __typename?: 'Reaction' }
    & ReactionDetailFragment
  )>, Answer?: Maybe<(
    { __typename?: 'Answer' }
    & AnswerDetailFragment
  )>, Actor?: Maybe<(
    { __typename?: 'Profile' }
    & ProfileOnGetProfileFragment
  )>, User?: Maybe<(
    { __typename?: 'Profile' }
    & ProfileOnGetProfileFragment
  )> };

export type GetActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivitiesQuery = { __typename?: 'Query', Activities?: Maybe<{ __typename?: 'ActivitiesQueryType', newActivities: Array<Maybe<(
      { __typename?: 'Activity' }
      & ActivityDetailFragment
    )>>, oldActivities: Array<Maybe<(
      { __typename?: 'Activity' }
      & ActivityDetailFragment
    )>> }> };

export type GetSentimentAnalysisQueryVariables = Exact<{
  days: Scalars['Int'];
}>;


export type GetSentimentAnalysisQuery = { __typename?: 'Query', sentiments: Array<{ __typename?: 'SentimentType', range: string, positive: number, neutral: number, negative: number }> };

export type GetManagerSentimentAnalysisQueryVariables = Exact<{
  days: Scalars['Int'];
  artistId?: Maybe<Scalars['String']>;
}>;


export type GetManagerSentimentAnalysisQuery = { __typename?: 'Query', managerSentiments: Array<{ __typename?: 'SentimentType', range: string, positive: number, neutral: number, negative: number }> };

export type GetManagerEngagementQueryVariables = Exact<{
  days: Scalars['Int'];
  artistId?: Maybe<Scalars['String']>;
}>;


export type GetManagerEngagementQuery = { __typename?: 'Query', managerEngagement: Array<{ __typename?: 'EngagementType', platform: Platform, count: number }> };

export type GetEngagementQueryVariables = Exact<{
  days: Scalars['Int'];
}>;


export type GetEngagementQuery = { __typename?: 'Query', engagement: Array<{ __typename?: 'EngagementType', platform: Platform, count: number }> };

export type GetLanguagesQueryVariables = Exact<{
  days: Scalars['Int'];
}>;


export type GetLanguagesQuery = { __typename?: 'Query', languages: any };

export type GetManagerLanguagesQueryVariables = Exact<{
  days: Scalars['Int'];
  artistId?: Maybe<Scalars['String']>;
}>;


export type GetManagerLanguagesQuery = { __typename?: 'Query', managerLanguages: any };

export type GetDiscordGuildInfoQueryVariables = Exact<{
  guildId: Scalars['String'];
}>;


export type GetDiscordGuildInfoQuery = { __typename?: 'Query', Username: string, GuildName: string, GuildUsers: Array<{ __typename?: 'DiscordUser', discordUserId: string, discordUsername: string, guildUserStatus: DiscordGuildUserStatus }> };

export type GetMyGuildModerationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyGuildModerationStatusQuery = { __typename?: 'Query', GuildModerators: Array<{ __typename?: 'GuildModerator', name: string, guildId: string, createdAt?: Maybe<any>, updatedAt?: Maybe<any> }> };

export type GetFanSummaryQueryVariables = Exact<{
  days: Scalars['Int'];
  platform?: Maybe<Platform>;
  page: Scalars['Int'];
  sortUsernames?: Maybe<Scalars['String']>;
  sortQuestions?: Maybe<Scalars['String']>;
  sortAnswers?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
}>;


export type GetFanSummaryQuery = { __typename?: 'Query', FanSummary?: Maybe<{ __typename?: 'FanSummary', fans: Array<{ __typename?: 'Fan', fanId: string, isFavorite: boolean, totalFans: number, username: string, openQuestion?: Maybe<string>, questions: number, answers: number, platforms: Array<Platform>, allPlatforms: Array<Platform>, socialUrls: Array<string>, email: string, identities?: Maybe<Array<Maybe<{ __typename?: 'FanIdentity', isFavorite: boolean, score?: Maybe<number>, username: string, platforms: Array<Platform>, email: string, fanId: string, openQuestion?: Maybe<string>, questions: number, answers: number }>>> }>, pagination: { __typename?: 'Pagination', page: number, totalFans: number } }> };

export type GetTopQuestionsQueryVariables = Exact<{
  page: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetTopQuestionsQuery = { __typename?: 'Query', TopFanQuestions?: Maybe<{ __typename?: 'TopFanQuestions', topFanQuestions: Array<(
      { __typename?: 'Question' }
      & QuestionDetailFragment
    )>, topFans: Array<{ __typename?: 'TopFans', questions: number, answers: number, user: (
        { __typename?: 'Profile' }
        & ProfileOnGetProfileFragment
      ) }> }> };

export type GetManagerFanSummaryQueryVariables = Exact<{
  days: Scalars['Int'];
  platform?: Maybe<Platform>;
  page: Scalars['Int'];
  sortUsernames?: Maybe<Scalars['String']>;
  sortQuestions?: Maybe<Scalars['String']>;
  sortAnswers?: Maybe<Scalars['String']>;
  artistId?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
}>;


export type GetManagerFanSummaryQuery = { __typename?: 'Query', ManagerFanSummary: { __typename?: 'ManagerFanSummary', fans: Array<{ __typename?: 'ManagerFan', fanId: string, isFavorite: boolean, totalFans: number, username: string, artistName: string, artistPicture: string, socialUrls: Array<string>, questions: number, answers: number, platforms: Array<Platform>, allPlatforms: Array<Platform>, email: string, allArtists: Array<{ __typename?: 'AllArtists', name: string, picture: string }>, identities?: Maybe<Array<Maybe<{ __typename?: 'ManagerFanIdentity', isFavorite: boolean, score?: Maybe<number>, username: string, platforms: Array<Platform>, email: string, fanId: string, questions: number, answers: number, artistPicture: string, artistName: string }>>> }>, pagination: { __typename?: 'Pagination', page: number, totalFans: number } } };

export type GetFeaturedEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturedEntitiesQuery = { __typename?: 'Query', FeaturedEntities: { __typename?: 'FeaturedEntities', id: string, createdAt: any, updatedAt: any, questionIds: Array<Maybe<string>>, artistIds: Array<Maybe<string>>, answers: Array<(
      { __typename?: 'Answer' }
      & AnswerDetailFragment
    )>, artists: Array<(
      { __typename?: 'Profile' }
      & ProfileOnGetProfileFragment
    )>, activities: Array<(
      { __typename?: 'Activity' }
      & ActivityDetailFragment
    )> } };

export type HealthCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type HealthCheckQuery = { __typename?: 'Query', healthCheck: { __typename?: 'HealthCheckResponse', status: number, response: string, timestamp: string } };

export type GetInstagramAccountStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstagramAccountStatsQuery = { __typename?: 'Query', InstagramAccountStats?: Maybe<{ __typename?: 'InstagramAccountStatsQueryType', followerCount: number, mediaCount: number, videoCrawlJobCount?: Maybe<number>, channelCrawlPublishedAfter?: Maybe<any>, latestQuestionCreatedAt?: Maybe<any> }> };

export type ArtistInstagramCrawlJobDetailFragment = { __typename?: 'ArtistInstagramCrawlJob', id: string, videoId: string, name: string, thumbnail: string, caption: string, mediaUrl: string, type: CrawlJobType, status: JobStatus, error?: Maybe<string>, schedule: string, expiresAt?: Maybe<any>, updatedAt: any, Artist: (
    { __typename?: 'Profile' }
    & ProfileOnGetProfileFragment
  ) };

export type GetArtistInstagramActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetArtistInstagramActivityQuery = { __typename?: 'Query', ArtistInstagramCrawlJobs?: Maybe<{ __typename?: 'ArtistInstagramCrawlJobsQueryType', activeVideoCrawlJobs: Array<Maybe<(
      { __typename?: 'ArtistInstagramCrawlJob' }
      & ArtistInstagramCrawlJobDetailFragment
    )>>, inactiveVideoCrawlJobs: Array<Maybe<(
      { __typename?: 'ArtistInstagramCrawlJob' }
      & ArtistInstagramCrawlJobDetailFragment
    )>>, channelCrawlJob?: Maybe<(
      { __typename?: 'ArtistInstagramCrawlJob' }
      & ArtistInstagramCrawlJobDetailFragment
    )> }>, InstagramAccountStats?: Maybe<{ __typename?: 'InstagramAccountStatsQueryType', followerCount: number, mediaCount: number, videoCrawlJobCount?: Maybe<number>, channelCrawlPublishedAfter?: Maybe<any>, latestQuestionCreatedAt?: Maybe<any> }> };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { __typename?: 'Query', Profile?: Maybe<(
    { __typename?: 'Profile' }
    & ProfileOnGetProfileFragment
  )>, User?: Maybe<(
    { __typename?: 'User' }
    & UserOnGetUserFragmentFragment
  )> };

export type GetUsernameAvailableQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type GetUsernameAvailableQuery = { __typename?: 'Query', UsernameAvailable: boolean };

export type PayoutRoyaltiesQueryVariables = Exact<{ [key: string]: never; }>;


export type PayoutRoyaltiesQuery = { __typename?: 'Query', PayoutRoyalties?: Maybe<Array<Maybe<{ __typename?: 'PayoutRoyalties', nftAmount: number, artistWallet: string, createdAt: string, artistUsername: string, artistId: string, txID?: Maybe<string>, royalty: number, settled: boolean, royaltyIds: Array<Maybe<string>>, id: string }>>> };

export type PayoutRoyaltiesUserQueryVariables = Exact<{ [key: string]: never; }>;


export type PayoutRoyaltiesUserQuery = { __typename?: 'Query', PayoutRoyaltiesUser: { __typename?: 'PayoutRoyaltiesUser', isPending: boolean } };

export type ProfileOnGetProfileFragment = { __typename?: 'Profile', id: string, name?: Maybe<string>, username: string, authRole: string, profilePictureUrl: string, timezone?: Maybe<string>, bio?: Maybe<string>, verified: boolean, link?: Maybe<any>, talkToMeAbout?: Maybe<string>, price?: Maybe<number>, isTakingQuestions: boolean, discordUserId?: Maybe<string>, discordUsername?: Maybe<string>, instagramUsername?: Maybe<string>, youTubeChannelId?: Maybe<string>, youTubeHandle?: Maybe<string>, redditUsername?: Maybe<string> };

export type ProfileQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type ProfileQuery = { __typename?: 'Query', Profile?: Maybe<(
    { __typename?: 'Profile' }
    & ProfileOnGetProfileFragment
  )>, User?: Maybe<(
    { __typename?: 'User' }
    & UserOnGetUserFragmentFragment
  )> };

export type GetSortedQuestionsQueryVariables = Exact<{
  username: Scalars['String'];
  platform?: Maybe<Platform>;
  page: Scalars['Int'];
  sort: Scalars['String'];
  videoId?: Maybe<Scalars['String']>;
}>;


export type GetSortedQuestionsQuery = { __typename?: 'Query', SortedQuestions: { __typename?: 'SortedQuestionsResponse', nextPage: boolean, questions: Array<(
      { __typename?: 'Question' }
      & QuestionDetailFragment
    )> } };

export type GetSortedAnswersQueryVariables = Exact<{
  username: Scalars['String'];
  platform?: Maybe<Platform>;
  page: Scalars['Int'];
  sort: Scalars['String'];
}>;


export type GetSortedAnswersQuery = { __typename?: 'Query', SortedAnswers: { __typename?: 'SortedAnswersResponse', nextPage: boolean, answers: Array<(
      { __typename?: 'Question' }
      & QuestionDetailFragment
    )> } };

export type SourceCommentDetailFragment = { __typename?: 'SourceComment', id: string, videoId: string, mediaUrl: string, artistYouTubeChannelId?: Maybe<string>, fanYouTubeChannelId?: Maybe<string>, artistInstagramUsername?: Maybe<string>, fanInstagramUsername?: Maybe<string>, questionId: string, likeCount: number, platform?: Maybe<Platform>, thumbnail?: Maybe<string>, youTubeVideoTitle?: Maybe<string>, instagramMediaCaption?: Maybe<string> };

export type SupportPaymentDetailFragment = { __typename?: 'SupportPayment', id: string, questionId: string, price: number, state: SupportPaymentState, isMinted: boolean, createdAt: any, updatedAt: any, Supporter: (
    { __typename?: 'Profile' }
    & ProfileOnGetProfileFragment
  ) };

export type AnswerDetailFragment = { __typename?: 'Answer', id: string, questionId: string, body: string, igShareLink?: Maybe<string>, shareRendition: string, audioRendition: string, nftNumber: number, coverImage?: Maybe<string>, transcript?: Maybe<string>, createdAt: any, updatedAt: any, durationSeconds?: Maybe<number>, youTubeId?: Maybe<string> };

export type QuestionDetailFragment = { __typename?: 'Question', id: string, body: string, state: QuestionState, flaggedMessage?: Maybe<string>, createdAt: any, updatedAt: any, platform?: Maybe<Platform>, ranking?: Maybe<number>, discordReactionCount?: Maybe<number>, sentiment?: Maybe<Sentiment>, language?: Maybe<Language>, Answer?: Maybe<(
    { __typename?: 'Answer' }
    & AnswerDetailFragment
  )>, Fan: (
    { __typename?: 'Profile' }
    & ProfileOnGetProfileFragment
  ), Artist: (
    { __typename?: 'Profile' }
    & ProfileOnGetProfileFragment
  ), SourceComment?: Maybe<(
    { __typename?: 'SourceComment' }
    & SourceCommentDetailFragment
  )>, supportPayments: Array<(
    { __typename?: 'SupportPayment' }
    & SupportPaymentDetailFragment
  )>, reactions: Array<(
    { __typename?: 'Reaction' }
    & ReactionDetailFragment
  )> };

export type SignedUploadUrlQueryVariables = Exact<{
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  fileType: Scalars['String'];
}>;


export type SignedUploadUrlQuery = { __typename?: 'Query', Question?: Maybe<{ __typename?: 'Question', signedUploadUrl: string }> };

export type SignedUploadShareUrlQueryVariables = Exact<{
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  fileType: Scalars['String'];
}>;


export type SignedUploadShareUrlQuery = { __typename?: 'Query', Question?: Maybe<{ __typename?: 'Question', signedUploadShareUrl: string }> };

export type GetQuestionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetQuestionQuery = { __typename?: 'Query', Question?: Maybe<(
    { __typename?: 'Question' }
    & QuestionDetailFragment
  )>, User?: Maybe<(
    { __typename?: 'User' }
    & UserOnGetUserFragmentFragment
  )> };

export type GetNewestOpenQuestionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewestOpenQuestionQuery = { __typename?: 'Query', NewestOpenQuestion?: Maybe<(
    { __typename?: 'Question' }
    & QuestionDetailFragment
  )> };

export type GetQuestionListNavigationQueryVariables = Exact<{
  username: Scalars['String'];
  currentQuestionId: Scalars['String'];
  state: QuestionState;
}>;


export type GetQuestionListNavigationQuery = { __typename?: 'Query', QuestionListNavigation: { __typename?: 'QuestionListNavigation', Index: number, TotalCount: number, NextQuestion?: Maybe<(
      { __typename?: 'Question' }
      & QuestionDetailFragment
    )>, PreviousQuestion?: Maybe<(
      { __typename?: 'Question' }
      & QuestionDetailFragment
    )> } };

export type ReactionDetailFragment = { __typename?: 'Reaction', id: string, questionId: string, emoji: EmojiReaction, artistEmoji?: Maybe<EmojiReaction>, ranking: Array<Maybe<EmojiReaction>>, createdAt: any, updatedAt: any, Reactor: (
    { __typename?: 'Profile' }
    & ProfileOnGetProfileFragment
  ) };

export type AuthenticateRedditCallbackMutationVariables = Exact<{
  code: Scalars['String'];
  state?: Maybe<Scalars['String']>;
}>;


export type AuthenticateRedditCallbackMutation = { __typename?: 'Mutation', AuthenticateRedditCallback: { __typename?: 'RedditAuthResponse', redirectTarget: string, token?: Maybe<string>, userId?: Maybe<string>, username?: Maybe<string>, code: ResponseCode, error?: Maybe<string> } };

export type GetSubredditArtistBonsaiConfigQueryVariables = Exact<{
  subredditId: Scalars['String'];
}>;


export type GetSubredditArtistBonsaiConfigQuery = { __typename?: 'Query', SubredditArtistBonsaiConfig: { __typename?: 'SubredditArtistBonsaiConfigData', questionRecipient?: Maybe<{ __typename?: 'Profile', id: string, name?: Maybe<string>, username: string }> } };

export type GetMySubredditsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMySubredditsQuery = { __typename?: 'Query', MySubreddits: Array<{ __typename?: 'SubredditData', subredditId: string, subredditName: string, subredditUrl: string }> };

export type UpsertSubredditArtistBonsaiConfigMutationVariables = Exact<{
  subredditId: Scalars['String'];
  questionRecipientId?: Maybe<Scalars['String']>;
}>;


export type UpsertSubredditArtistBonsaiConfigMutation = { __typename?: 'Mutation', UpsertSubredditArtistBonsaiConfig: { __typename?: 'UpsertSubredditArtistBonsaiConfigResponse', success: boolean, error?: Maybe<string>, questionRecipient?: Maybe<{ __typename?: 'Profile', id: string, name?: Maybe<string>, username: string }> } };

export type GetSubredditModeratorsQueryVariables = Exact<{
  subredditId: Scalars['String'];
}>;


export type GetSubredditModeratorsQuery = { __typename?: 'Query', SubredditModerators: { __typename?: 'SubredditModeratorsResponse', success: boolean, error?: Maybe<string>, subreddit: { __typename?: 'SubredditData', subredditName: string, subredditUrl: string }, moderators: Array<{ __typename?: 'Profile', id: string, name?: Maybe<string>, username: string }> } };

export type CheckRedditInstallationStatusQueryVariables = Exact<{
  subredditId: Scalars['String'];
}>;


export type CheckRedditInstallationStatusQuery = { __typename?: 'Query', CheckRedditInstallationStatus: boolean };

export type SearchQueryVariables = Exact<{
  substring: Scalars['String'];
}>;


export type SearchQuery = { __typename?: 'Query', Search: { __typename?: 'Search', results: Array<{ __typename: 'AnswerSearchResult', body: string, questionId: string, transcript?: Maybe<string>, entityType: SearchResultEntityType, Artist: { __typename?: 'Profile', name?: Maybe<string>, bio?: Maybe<string>, profilePictureUrl: string }, highlight: { __typename?: 'SearchHighlight', transcript?: Maybe<{ __typename?: 'Highlight', value: string, fullyHighlighted?: Maybe<boolean>, matchedWords: Array<string>, matchLevel: SearchResultMatchLevelType }>, body?: Maybe<{ __typename?: 'Highlight', value: string, fullyHighlighted?: Maybe<boolean>, matchedWords: Array<string>, matchLevel: SearchResultMatchLevelType }> } } | { __typename: 'QuestionSearchResult', id: string, body: string, entityType: SearchResultEntityType, Artist: { __typename?: 'Profile', name?: Maybe<string>, bio?: Maybe<string>, profilePictureUrl: string }, highlight: { __typename?: 'SearchHighlight', body?: Maybe<{ __typename?: 'Highlight', value: string, fullyHighlighted?: Maybe<boolean>, matchedWords: Array<string>, matchLevel: SearchResultMatchLevelType }> } } | { __typename: 'SourceCommentSearchResult' } | { __typename: 'UserSearchResult', name?: Maybe<string>, username: string, verified: boolean, profilePictureUrl: string, entityType: SearchResultEntityType, bio?: Maybe<string>, highlight: { __typename?: 'SearchHighlight', name?: Maybe<{ __typename?: 'Highlight', value: string, fullyHighlighted?: Maybe<boolean>, matchedWords: Array<string>, matchLevel: SearchResultMatchLevelType }>, bio?: Maybe<{ __typename?: 'Highlight', value: string, fullyHighlighted?: Maybe<boolean>, matchedWords: Array<string>, matchLevel: SearchResultMatchLevelType }> } }> } };

export type ProfileSearchQueryVariables = Exact<{
  substring: Scalars['String'];
  username: Scalars['String'];
}>;


export type ProfileSearchQuery = { __typename?: 'Query', ProfileSearch: { __typename?: 'Search', results: Array<{ __typename: 'AnswerSearchResult' } | { __typename: 'QuestionSearchResult', id: string, body: string, fanName: string, entityType: SearchResultEntityType, Fan: { __typename?: 'Profile', name?: Maybe<string>, bio?: Maybe<string>, profilePictureUrl: string }, highlight: { __typename?: 'SearchHighlight', fanName?: Maybe<{ __typename?: 'Highlight', value: string, fullyHighlighted?: Maybe<boolean>, matchedWords: Array<string>, matchLevel: SearchResultMatchLevelType }>, body?: Maybe<{ __typename?: 'Highlight', value: string, fullyHighlighted?: Maybe<boolean>, matchedWords: Array<string>, matchLevel: SearchResultMatchLevelType }> } } | { __typename: 'SourceCommentSearchResult', entityType: SearchResultEntityType, videoId: string, count: number, thumbnail?: Maybe<string>, youTubeVideoTitle?: Maybe<string>, instagramMediaCaption?: Maybe<string>, highlight: { __typename?: 'SearchHighlight', youTubeVideoTitle?: Maybe<{ __typename?: 'Highlight', value: string, fullyHighlighted?: Maybe<boolean>, matchedWords: Array<string>, matchLevel: SearchResultMatchLevelType }>, instagramMediaCaption?: Maybe<{ __typename?: 'Highlight', value: string, fullyHighlighted?: Maybe<boolean>, matchedWords: Array<string>, matchLevel: SearchResultMatchLevelType }> } } | { __typename: 'UserSearchResult' }> } };

export type TagPageQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type TagPageQuery = { __typename?: 'Query', TagPage: { __typename?: 'TagPage', Tag?: Maybe<{ __typename?: 'Tag', name: string }>, Coaches?: Maybe<Array<(
      { __typename?: 'Profile' }
      & ProfileOnGetProfileFragment
    )>> } };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', Tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string }> };

export type SiteMapDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteMapDataQuery = { __typename?: 'Query', AllUsersTakingQuestions: Array<{ __typename?: 'User', id: string, username: string, updatedAt: any }>, AllQuestions: Array<{ __typename?: 'Question', id: string, state: QuestionState, updatedAt: any }> };

export type GetAppPreflightDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppPreflightDataQuery = { __typename?: 'Query', Preflight: { __typename?: 'Preflight', authRole?: Maybe<AuthRoleType>, success: boolean, code: ResponseCode, publicId?: Maybe<string>, id?: Maybe<string>, name?: Maybe<string>, username?: Maybe<string>, profilePictureUrl?: Maybe<string>, email?: Maybe<string> } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', User?: Maybe<(
    { __typename?: 'User' }
    & UserOnGetUserFragmentFragment
  )> };

export type UserOnGetUserFragmentFragment = { __typename?: 'User', username: string, profilePictureUrl: string, name?: Maybe<string>, id: string, lastSeen?: Maybe<any>, publicId: string, authRole: AuthRoleType, managerIds: Array<Maybe<string>>, favoriteUserIds: Array<Maybe<string>>, managerToken?: Maybe<string>, managerTokenRequestedAt?: Maybe<any>, instagramAccountId?: Maybe<string>, instagramUsername?: Maybe<string>, instagramFollowerCount?: Maybe<string>, instagramMediaCount?: Maybe<string>, isInstagramLinked: boolean, youTubeChannelId?: Maybe<string>, youTubeHandle?: Maybe<string>, youTubeChannelSubscriberCount?: Maybe<number>, youTubeChannelVideoCount?: Maybe<number>, phoneNumber?: Maybe<string>, phoneCountryCode?: Maybe<number>, phoneVerified: boolean, email: string, emailVerified: boolean, receiveSMSUpdates: boolean, receivePromotionalEmailUpdates: boolean, cashBalance: number, allTimeEarnings: number, stripeConnectState: StripeConnectState, stripeSetupIntentClientSecret: string, bankAccountCountry: string, savePaymentMethod: boolean, answerCreatedNotificationEnabled?: Maybe<boolean>, questionCreatedNotificationEnabled?: Maybe<boolean>, questionExpirationReminderEnabled?: Maybe<boolean>, hasFans: boolean, discordUserId?: Maybe<string>, isRedditLinked: boolean, redditUsername?: Maybe<string>, redditUserId?: Maybe<string>, redditAccountAge?: Maybe<string>, redditCommentKarma?: Maybe<string>, savedPaymentMethod?: Maybe<{ __typename?: 'PaymentMethod', cardType: string, last4: number, paymentMethodId: string }>, youTubeAccountDetails?: Maybe<{ __typename?: 'YouTubeAccountDetails', isLinked: boolean, questionCreatedCount: number, videoCrawlJobCount: number, isChannelCrawlEnabled: boolean, latestQuestionCreatedAt?: Maybe<any>, channelCrawlJobCreatedAt?: Maybe<any> }> };

export type GetSignedUploadUrlQueryVariables = Exact<{
  fileType: Scalars['String'];
}>;


export type GetSignedUploadUrlQuery = { __typename?: 'Query', User?: Maybe<{ __typename?: 'User', id: string, signedUploadUrl: string }> };

export type GetStripeConnectStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripeConnectStateQuery = { __typename?: 'Query', User?: Maybe<{ __typename?: 'User', stripeConnectState: StripeConnectState }> };

export type GetStripeConnectLoginUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripeConnectLoginUrlQuery = { __typename?: 'Query', User?: Maybe<{ __typename?: 'User', stripeConnectLoginUrl: string }> };

export type GetStripeConnectSetupUrlQueryVariables = Exact<{
  country: Scalars['String'];
}>;


export type GetStripeConnectSetupUrlQuery = { __typename?: 'Query', User?: Maybe<{ __typename?: 'User', stripeConnectSetupUrl: string }> };

export type GetPhoneNumberAvailableQueryVariables = Exact<{
  phoneCountryCode: Scalars['Int'];
  phoneNumber: Scalars['String'];
}>;


export type GetPhoneNumberAvailableQuery = { __typename?: 'Query', PhoneNumberAvailable: boolean };

export type GetEmailAvailableQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetEmailAvailableQuery = { __typename?: 'Query', EmailAvailable: boolean };

export type IsUsernameValidQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type IsUsernameValidQuery = { __typename?: 'Query', UsernameValid: { __typename?: 'UsernameValidResponse', isValid: boolean, message?: Maybe<string>, suggestedUsername?: Maybe<string> } };

export type GetManagerQueryVariables = Exact<{
  managerId?: Maybe<Scalars['String']>;
}>;


export type GetManagerQuery = { __typename?: 'Query', Manager: { __typename?: 'ManagerResponse', token: string, manager?: Maybe<{ __typename?: 'Manager', managerId: string, createdAt: string, artists: Array<(
        { __typename?: 'User' }
        & UserOnGetUserFragmentFragment
      )> }> } };

export type LoginAssignedManagerQueryVariables = Exact<{
  assignedId: Scalars['String'];
}>;


export type LoginAssignedManagerQuery = { __typename?: 'Query', LoginAssignedManager: { __typename?: 'ManagerResponse', token: string, manager?: Maybe<{ __typename?: 'Manager', managerId: string, createdAt: string, artists: Array<(
        { __typename?: 'User' }
        & UserOnGetUserFragmentFragment
      )> }> } };

export type GetArtistYouTubeCrawlJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetArtistYouTubeCrawlJobsQuery = { __typename?: 'Query', crawlJobsDetail: { __typename?: 'YouTubeCrawlJobsDetail', channelCrawlJob?: Maybe<{ __typename?: 'ArtistYouTubeChannelCrawlJob', name: string, status: JobStatus, youTubeChannelId: string, schedule: string, createdAt: any, updatedAt: any }>, videoCrawlJobs: Array<{ __typename?: 'ArtistYouTubeVideoCrawlJob', name: string, status: JobStatus, mediaUrl: string, thumbnail: string, caption: string, schedule: string, createdAt: any, updatedAt: any }> } };

export const AnswerDetailFragmentDoc = gql`
    fragment AnswerDetail on Answer {
  id
  questionId
  body
  igShareLink
  shareRendition
  audioRendition
  nftNumber
  coverImage
  transcript
  createdAt
  updatedAt
  durationSeconds
  youTubeId
}
    `;
export const ProfileOnGetProfileFragmentDoc = gql`
    fragment ProfileOnGetProfile on Profile {
  id
  name
  username
  authRole
  profilePictureUrl
  timezone
  bio
  verified
  link
  talkToMeAbout
  price
  isTakingQuestions
  discordUserId
  discordUsername
  instagramUsername
  youTubeChannelId
  youTubeHandle
  redditUsername
}
    `;
export const SourceCommentDetailFragmentDoc = gql`
    fragment SourceCommentDetail on SourceComment {
  id
  videoId
  mediaUrl
  artistYouTubeChannelId
  fanYouTubeChannelId
  artistInstagramUsername
  fanInstagramUsername
  questionId
  likeCount
  platform
  thumbnail
  youTubeVideoTitle
  instagramMediaCaption
}
    `;
export const SupportPaymentDetailFragmentDoc = gql`
    fragment SupportPaymentDetail on SupportPayment {
  id
  questionId
  price
  state
  isMinted
  createdAt
  updatedAt
  Supporter {
    ...ProfileOnGetProfile
  }
}
    ${ProfileOnGetProfileFragmentDoc}`;
export const ReactionDetailFragmentDoc = gql`
    fragment ReactionDetail on Reaction {
  id
  questionId
  emoji
  artistEmoji
  ranking
  createdAt
  updatedAt
  Reactor {
    ...ProfileOnGetProfile
  }
}
    ${ProfileOnGetProfileFragmentDoc}`;
export const QuestionDetailFragmentDoc = gql`
    fragment QuestionDetail on Question {
  id
  body
  state
  flaggedMessage
  createdAt
  updatedAt
  platform
  ranking
  discordReactionCount
  sentiment
  language
  Answer {
    ...AnswerDetail
  }
  Fan {
    ...ProfileOnGetProfile
  }
  Artist {
    ...ProfileOnGetProfile
  }
  SourceComment {
    ...SourceCommentDetail
  }
  supportPayments {
    ...SupportPaymentDetail
  }
  reactions {
    ...ReactionDetail
  }
}
    ${AnswerDetailFragmentDoc}
${ProfileOnGetProfileFragmentDoc}
${SourceCommentDetailFragmentDoc}
${SupportPaymentDetailFragmentDoc}
${ReactionDetailFragmentDoc}`;
export const ActivityDetailFragmentDoc = gql`
    fragment ActivityDetail on Activity {
  id
  userId
  type
  createdAt
  updatedAt
  Question {
    ...QuestionDetail
  }
  Reaction {
    ...ReactionDetail
  }
  Answer {
    ...AnswerDetail
  }
  Actor {
    ...ProfileOnGetProfile
  }
  User {
    ...ProfileOnGetProfile
  }
}
    ${QuestionDetailFragmentDoc}
${ReactionDetailFragmentDoc}
${AnswerDetailFragmentDoc}
${ProfileOnGetProfileFragmentDoc}`;
export const ArtistInstagramCrawlJobDetailFragmentDoc = gql`
    fragment ArtistInstagramCrawlJobDetail on ArtistInstagramCrawlJob {
  id
  videoId
  name
  thumbnail
  caption
  mediaUrl
  type
  status
  error
  schedule
  expiresAt
  updatedAt
  Artist {
    ...ProfileOnGetProfile
  }
}
    ${ProfileOnGetProfileFragmentDoc}`;
export const UserOnGetUserFragmentFragmentDoc = gql`
    fragment UserOnGetUserFragment on User {
  username
  profilePictureUrl
  name
  id
  lastSeen
  publicId
  authRole
  managerIds
  favoriteUserIds
  managerToken
  managerTokenRequestedAt
  instagramAccountId
  instagramUsername
  instagramFollowerCount
  instagramMediaCount
  isInstagramLinked
  youTubeChannelId
  youTubeHandle
  youTubeChannelSubscriberCount
  youTubeChannelVideoCount
  phoneNumber
  phoneCountryCode
  phoneVerified
  email
  emailVerified
  receiveSMSUpdates
  receivePromotionalEmailUpdates
  cashBalance
  allTimeEarnings
  stripeConnectState
  stripeSetupIntentClientSecret
  bankAccountCountry
  savePaymentMethod
  savedPaymentMethod {
    cardType
    last4
    paymentMethodId
  }
  answerCreatedNotificationEnabled
  questionCreatedNotificationEnabled
  questionExpirationReminderEnabled
  youTubeAccountDetails {
    isLinked
    questionCreatedCount
    videoCrawlJobCount
    isChannelCrawlEnabled
    latestQuestionCreatedAt
    channelCrawlJobCreatedAt
  }
  hasFans
  discordUserId
  isRedditLinked
  redditUsername
  redditUserId
  redditAccountAge
  redditCommentKarma
}
    `;
export const LoginUserDocument = gql`
    mutation LoginUser($password: String!, $email: String, $phoneNumber: PhoneNumber) {
  LoginUser(input: {password: $password, email: $email, phoneNumber: $phoneNumber}) {
    token
    success
    code
    userId
    username
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      password: // value for 'password'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        return Apollo.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, baseOptions);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const RequestMagicLoginDocument = gql`
    mutation RequestMagicLogin($email: String, $phoneNumber: PhoneNumber, $path: String) {
  RequestMagicLogin(input: {email: $email, phoneNumber: $phoneNumber, path: $path}) {
    success
    code
  }
}
    `;
export type RequestMagicLoginMutationFn = Apollo.MutationFunction<RequestMagicLoginMutation, RequestMagicLoginMutationVariables>;

/**
 * __useRequestMagicLoginMutation__
 *
 * To run a mutation, you first call `useRequestMagicLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMagicLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMagicLoginMutation, { data, loading, error }] = useRequestMagicLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useRequestMagicLoginMutation(baseOptions?: Apollo.MutationHookOptions<RequestMagicLoginMutation, RequestMagicLoginMutationVariables>) {
        return Apollo.useMutation<RequestMagicLoginMutation, RequestMagicLoginMutationVariables>(RequestMagicLoginDocument, baseOptions);
      }
export type RequestMagicLoginMutationHookResult = ReturnType<typeof useRequestMagicLoginMutation>;
export type RequestMagicLoginMutationResult = Apollo.MutationResult<RequestMagicLoginMutation>;
export type RequestMagicLoginMutationOptions = Apollo.BaseMutationOptions<RequestMagicLoginMutation, RequestMagicLoginMutationVariables>;
export const MagicLoginDocument = gql`
    mutation MagicLogin($token: String!) {
  MagicLogin(input: {token: $token}) {
    success
    code
    token
    userId
    username
  }
}
    `;
export type MagicLoginMutationFn = Apollo.MutationFunction<MagicLoginMutation, MagicLoginMutationVariables>;

/**
 * __useMagicLoginMutation__
 *
 * To run a mutation, you first call `useMagicLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMagicLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [magicLoginMutation, { data, loading, error }] = useMagicLoginMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useMagicLoginMutation(baseOptions?: Apollo.MutationHookOptions<MagicLoginMutation, MagicLoginMutationVariables>) {
        return Apollo.useMutation<MagicLoginMutation, MagicLoginMutationVariables>(MagicLoginDocument, baseOptions);
      }
export type MagicLoginMutationHookResult = ReturnType<typeof useMagicLoginMutation>;
export type MagicLoginMutationResult = Apollo.MutationResult<MagicLoginMutation>;
export type MagicLoginMutationOptions = Apollo.BaseMutationOptions<MagicLoginMutation, MagicLoginMutationVariables>;
export const RequestPasswordDocument = gql`
    mutation RequestPassword($email: String, $phoneNumber: PhoneNumber) {
  RequestPassword(input: {email: $email, phoneNumber: $phoneNumber}) {
    success
    code
  }
}
    `;
export type RequestPasswordMutationFn = Apollo.MutationFunction<RequestPasswordMutation, RequestPasswordMutationVariables>;

/**
 * __useRequestPasswordMutation__
 *
 * To run a mutation, you first call `useRequestPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordMutation, { data, loading, error }] = useRequestPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useRequestPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordMutation, RequestPasswordMutationVariables>) {
        return Apollo.useMutation<RequestPasswordMutation, RequestPasswordMutationVariables>(RequestPasswordDocument, baseOptions);
      }
export type RequestPasswordMutationHookResult = ReturnType<typeof useRequestPasswordMutation>;
export type RequestPasswordMutationResult = Apollo.MutationResult<RequestPasswordMutation>;
export type RequestPasswordMutationOptions = Apollo.BaseMutationOptions<RequestPasswordMutation, RequestPasswordMutationVariables>;
export const ValidatePasswordResetRequestDocument = gql`
    query ValidatePasswordResetRequest($token: String!) {
  ValidatePasswordResetRequest(token: $token) {
    success
    code
  }
}
    `;

/**
 * __useValidatePasswordResetRequestQuery__
 *
 * To run a query within a React component, call `useValidatePasswordResetRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePasswordResetRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePasswordResetRequestQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidatePasswordResetRequestQuery(baseOptions: Apollo.QueryHookOptions<ValidatePasswordResetRequestQuery, ValidatePasswordResetRequestQueryVariables>) {
        return Apollo.useQuery<ValidatePasswordResetRequestQuery, ValidatePasswordResetRequestQueryVariables>(ValidatePasswordResetRequestDocument, baseOptions);
      }
export function useValidatePasswordResetRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatePasswordResetRequestQuery, ValidatePasswordResetRequestQueryVariables>) {
          return Apollo.useLazyQuery<ValidatePasswordResetRequestQuery, ValidatePasswordResetRequestQueryVariables>(ValidatePasswordResetRequestDocument, baseOptions);
        }
export type ValidatePasswordResetRequestQueryHookResult = ReturnType<typeof useValidatePasswordResetRequestQuery>;
export type ValidatePasswordResetRequestLazyQueryHookResult = ReturnType<typeof useValidatePasswordResetRequestLazyQuery>;
export type ValidatePasswordResetRequestQueryResult = Apollo.QueryResult<ValidatePasswordResetRequestQuery, ValidatePasswordResetRequestQueryVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($token: String!, $password: String!) {
  ResetPassword(input: {token: $token, password: $password}) {
    success
    code
    token
    userId
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, baseOptions);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const VerifyEmailOtpDocument = gql`
    mutation VerifyEmailOtp($code: String!, $email: String!) {
  MagicSignup(input: {actions: [{setVerifyEmailOtp: {code: $code, email: $email}}]}) {
    success
    code
  }
}
    `;
export type VerifyEmailOtpMutationFn = Apollo.MutationFunction<VerifyEmailOtpMutation, VerifyEmailOtpMutationVariables>;

/**
 * __useVerifyEmailOtpMutation__
 *
 * To run a mutation, you first call `useVerifyEmailOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailOtpMutation, { data, loading, error }] = useVerifyEmailOtpMutation({
 *   variables: {
 *      code: // value for 'code'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useVerifyEmailOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailOtpMutation, VerifyEmailOtpMutationVariables>) {
        return Apollo.useMutation<VerifyEmailOtpMutation, VerifyEmailOtpMutationVariables>(VerifyEmailOtpDocument, baseOptions);
      }
export type VerifyEmailOtpMutationHookResult = ReturnType<typeof useVerifyEmailOtpMutation>;
export type VerifyEmailOtpMutationResult = Apollo.MutationResult<VerifyEmailOtpMutation>;
export type VerifyEmailOtpMutationOptions = Apollo.BaseMutationOptions<VerifyEmailOtpMutation, VerifyEmailOtpMutationVariables>;
export const SendVerifyEmailOtpDocument = gql`
    mutation SendVerifyEmailOtp($email: String!) {
  MagicSignup(input: {actions: [{setSendVerifyEmailOtp: {email: $email}}]}) {
    success
    code
  }
}
    `;
export type SendVerifyEmailOtpMutationFn = Apollo.MutationFunction<SendVerifyEmailOtpMutation, SendVerifyEmailOtpMutationVariables>;

/**
 * __useSendVerifyEmailOtpMutation__
 *
 * To run a mutation, you first call `useSendVerifyEmailOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerifyEmailOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerifyEmailOtpMutation, { data, loading, error }] = useSendVerifyEmailOtpMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendVerifyEmailOtpMutation(baseOptions?: Apollo.MutationHookOptions<SendVerifyEmailOtpMutation, SendVerifyEmailOtpMutationVariables>) {
        return Apollo.useMutation<SendVerifyEmailOtpMutation, SendVerifyEmailOtpMutationVariables>(SendVerifyEmailOtpDocument, baseOptions);
      }
export type SendVerifyEmailOtpMutationHookResult = ReturnType<typeof useSendVerifyEmailOtpMutation>;
export type SendVerifyEmailOtpMutationResult = Apollo.MutationResult<SendVerifyEmailOtpMutation>;
export type SendVerifyEmailOtpMutationOptions = Apollo.BaseMutationOptions<SendVerifyEmailOtpMutation, SendVerifyEmailOtpMutationVariables>;
export const VerifyPhoneOtpDocument = gql`
    mutation VerifyPhoneOtp($code: String!, $phoneNumber: PhoneNumber!, $phoneCountryCode: Int!) {
  MagicSignup(input: {actions: [{setVerifyPhoneOtp: {code: $code, phoneNumber: $phoneNumber, phoneCountryCode: $phoneCountryCode}}]}) {
    success
    code
  }
}
    `;
export type VerifyPhoneOtpMutationFn = Apollo.MutationFunction<VerifyPhoneOtpMutation, VerifyPhoneOtpMutationVariables>;

/**
 * __useVerifyPhoneOtpMutation__
 *
 * To run a mutation, you first call `useVerifyPhoneOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPhoneOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPhoneOtpMutation, { data, loading, error }] = useVerifyPhoneOtpMutation({
 *   variables: {
 *      code: // value for 'code'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *   },
 * });
 */
export function useVerifyPhoneOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPhoneOtpMutation, VerifyPhoneOtpMutationVariables>) {
        return Apollo.useMutation<VerifyPhoneOtpMutation, VerifyPhoneOtpMutationVariables>(VerifyPhoneOtpDocument, baseOptions);
      }
export type VerifyPhoneOtpMutationHookResult = ReturnType<typeof useVerifyPhoneOtpMutation>;
export type VerifyPhoneOtpMutationResult = Apollo.MutationResult<VerifyPhoneOtpMutation>;
export type VerifyPhoneOtpMutationOptions = Apollo.BaseMutationOptions<VerifyPhoneOtpMutation, VerifyPhoneOtpMutationVariables>;
export const SendVerifyPhoneOtpDocument = gql`
    mutation SendVerifyPhoneOtp($phoneNumber: PhoneNumber!, $phoneCountryCode: Int!) {
  MagicSignup(input: {actions: [{setSendVerifyPhoneOtp: {phoneNumber: $phoneNumber, phoneCountryCode: $phoneCountryCode}}]}) {
    success
    code
  }
}
    `;
export type SendVerifyPhoneOtpMutationFn = Apollo.MutationFunction<SendVerifyPhoneOtpMutation, SendVerifyPhoneOtpMutationVariables>;

/**
 * __useSendVerifyPhoneOtpMutation__
 *
 * To run a mutation, you first call `useSendVerifyPhoneOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerifyPhoneOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerifyPhoneOtpMutation, { data, loading, error }] = useSendVerifyPhoneOtpMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *   },
 * });
 */
export function useSendVerifyPhoneOtpMutation(baseOptions?: Apollo.MutationHookOptions<SendVerifyPhoneOtpMutation, SendVerifyPhoneOtpMutationVariables>) {
        return Apollo.useMutation<SendVerifyPhoneOtpMutation, SendVerifyPhoneOtpMutationVariables>(SendVerifyPhoneOtpDocument, baseOptions);
      }
export type SendVerifyPhoneOtpMutationHookResult = ReturnType<typeof useSendVerifyPhoneOtpMutation>;
export type SendVerifyPhoneOtpMutationResult = Apollo.MutationResult<SendVerifyPhoneOtpMutation>;
export type SendVerifyPhoneOtpMutationOptions = Apollo.BaseMutationOptions<SendVerifyPhoneOtpMutation, SendVerifyPhoneOtpMutationVariables>;
export const InviteDiscordUsersDocument = gql`
    mutation InviteDiscordUsers($discordUserIds: [String!]!, $guildId: String!) {
  InviteDiscordUsers(input: {discordUserIds: $discordUserIds, guildId: $guildId})
}
    `;
export type InviteDiscordUsersMutationFn = Apollo.MutationFunction<InviteDiscordUsersMutation, InviteDiscordUsersMutationVariables>;

/**
 * __useInviteDiscordUsersMutation__
 *
 * To run a mutation, you first call `useInviteDiscordUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteDiscordUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteDiscordUsersMutation, { data, loading, error }] = useInviteDiscordUsersMutation({
 *   variables: {
 *      discordUserIds: // value for 'discordUserIds'
 *      guildId: // value for 'guildId'
 *   },
 * });
 */
export function useInviteDiscordUsersMutation(baseOptions?: Apollo.MutationHookOptions<InviteDiscordUsersMutation, InviteDiscordUsersMutationVariables>) {
        return Apollo.useMutation<InviteDiscordUsersMutation, InviteDiscordUsersMutationVariables>(InviteDiscordUsersDocument, baseOptions);
      }
export type InviteDiscordUsersMutationHookResult = ReturnType<typeof useInviteDiscordUsersMutation>;
export type InviteDiscordUsersMutationResult = Apollo.MutationResult<InviteDiscordUsersMutation>;
export type InviteDiscordUsersMutationOptions = Apollo.BaseMutationOptions<InviteDiscordUsersMutation, InviteDiscordUsersMutationVariables>;
export const AuthenticateDiscordCallbackDocument = gql`
    mutation AuthenticateDiscordCallback($code: String!, $guildId: String!) {
  AuthenticateDiscordCallback(code: $code, guildId: $guildId)
}
    `;
export type AuthenticateDiscordCallbackMutationFn = Apollo.MutationFunction<AuthenticateDiscordCallbackMutation, AuthenticateDiscordCallbackMutationVariables>;

/**
 * __useAuthenticateDiscordCallbackMutation__
 *
 * To run a mutation, you first call `useAuthenticateDiscordCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateDiscordCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateDiscordCallbackMutation, { data, loading, error }] = useAuthenticateDiscordCallbackMutation({
 *   variables: {
 *      code: // value for 'code'
 *      guildId: // value for 'guildId'
 *   },
 * });
 */
export function useAuthenticateDiscordCallbackMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateDiscordCallbackMutation, AuthenticateDiscordCallbackMutationVariables>) {
        return Apollo.useMutation<AuthenticateDiscordCallbackMutation, AuthenticateDiscordCallbackMutationVariables>(AuthenticateDiscordCallbackDocument, baseOptions);
      }
export type AuthenticateDiscordCallbackMutationHookResult = ReturnType<typeof useAuthenticateDiscordCallbackMutation>;
export type AuthenticateDiscordCallbackMutationResult = Apollo.MutationResult<AuthenticateDiscordCallbackMutation>;
export type AuthenticateDiscordCallbackMutationOptions = Apollo.BaseMutationOptions<AuthenticateDiscordCallbackMutation, AuthenticateDiscordCallbackMutationVariables>;
export const UpdateGuildCommandUsersDocument = gql`
    mutation UpdateGuildCommandUsers($selectedDiscordUserIds: [String!]!, $guildId: String!) {
  UpdateGuildCommandUsers(input: {selectedDiscordUserIds: $selectedDiscordUserIds, guildId: $guildId})
}
    `;
export type UpdateGuildCommandUsersMutationFn = Apollo.MutationFunction<UpdateGuildCommandUsersMutation, UpdateGuildCommandUsersMutationVariables>;

/**
 * __useUpdateGuildCommandUsersMutation__
 *
 * To run a mutation, you first call `useUpdateGuildCommandUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuildCommandUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuildCommandUsersMutation, { data, loading, error }] = useUpdateGuildCommandUsersMutation({
 *   variables: {
 *      selectedDiscordUserIds: // value for 'selectedDiscordUserIds'
 *      guildId: // value for 'guildId'
 *   },
 * });
 */
export function useUpdateGuildCommandUsersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuildCommandUsersMutation, UpdateGuildCommandUsersMutationVariables>) {
        return Apollo.useMutation<UpdateGuildCommandUsersMutation, UpdateGuildCommandUsersMutationVariables>(UpdateGuildCommandUsersDocument, baseOptions);
      }
export type UpdateGuildCommandUsersMutationHookResult = ReturnType<typeof useUpdateGuildCommandUsersMutation>;
export type UpdateGuildCommandUsersMutationResult = Apollo.MutationResult<UpdateGuildCommandUsersMutation>;
export type UpdateGuildCommandUsersMutationOptions = Apollo.BaseMutationOptions<UpdateGuildCommandUsersMutation, UpdateGuildCommandUsersMutationVariables>;
export const ExportFanSummaryDocument = gql`
    mutation ExportFanSummary {
  ExportFanSummary {
    s3url
    success
  }
}
    `;
export type ExportFanSummaryMutationFn = Apollo.MutationFunction<ExportFanSummaryMutation, ExportFanSummaryMutationVariables>;

/**
 * __useExportFanSummaryMutation__
 *
 * To run a mutation, you first call `useExportFanSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportFanSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportFanSummaryMutation, { data, loading, error }] = useExportFanSummaryMutation({
 *   variables: {
 *   },
 * });
 */
export function useExportFanSummaryMutation(baseOptions?: Apollo.MutationHookOptions<ExportFanSummaryMutation, ExportFanSummaryMutationVariables>) {
        return Apollo.useMutation<ExportFanSummaryMutation, ExportFanSummaryMutationVariables>(ExportFanSummaryDocument, baseOptions);
      }
export type ExportFanSummaryMutationHookResult = ReturnType<typeof useExportFanSummaryMutation>;
export type ExportFanSummaryMutationResult = Apollo.MutationResult<ExportFanSummaryMutation>;
export type ExportFanSummaryMutationOptions = Apollo.BaseMutationOptions<ExportFanSummaryMutation, ExportFanSummaryMutationVariables>;
export const UpdateFeaturedEntitiesSetQuestionIdsDocument = gql`
    mutation UpdateFeaturedEntitiesSetQuestionIds($questionId: ID!, $index: Int!, $replace: Int!) {
  UpdateFeaturedEntities(input: {actions: [{setQuestionIds: {questionId: $questionId, index: $index, replace: $replace}}]}) {
    id
  }
}
    `;
export type UpdateFeaturedEntitiesSetQuestionIdsMutationFn = Apollo.MutationFunction<UpdateFeaturedEntitiesSetQuestionIdsMutation, UpdateFeaturedEntitiesSetQuestionIdsMutationVariables>;

/**
 * __useUpdateFeaturedEntitiesSetQuestionIdsMutation__
 *
 * To run a mutation, you first call `useUpdateFeaturedEntitiesSetQuestionIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeaturedEntitiesSetQuestionIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeaturedEntitiesSetQuestionIdsMutation, { data, loading, error }] = useUpdateFeaturedEntitiesSetQuestionIdsMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      index: // value for 'index'
 *      replace: // value for 'replace'
 *   },
 * });
 */
export function useUpdateFeaturedEntitiesSetQuestionIdsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeaturedEntitiesSetQuestionIdsMutation, UpdateFeaturedEntitiesSetQuestionIdsMutationVariables>) {
        return Apollo.useMutation<UpdateFeaturedEntitiesSetQuestionIdsMutation, UpdateFeaturedEntitiesSetQuestionIdsMutationVariables>(UpdateFeaturedEntitiesSetQuestionIdsDocument, baseOptions);
      }
export type UpdateFeaturedEntitiesSetQuestionIdsMutationHookResult = ReturnType<typeof useUpdateFeaturedEntitiesSetQuestionIdsMutation>;
export type UpdateFeaturedEntitiesSetQuestionIdsMutationResult = Apollo.MutationResult<UpdateFeaturedEntitiesSetQuestionIdsMutation>;
export type UpdateFeaturedEntitiesSetQuestionIdsMutationOptions = Apollo.BaseMutationOptions<UpdateFeaturedEntitiesSetQuestionIdsMutation, UpdateFeaturedEntitiesSetQuestionIdsMutationVariables>;
export const UpdateFeaturedEntitiesSetArtistIdsDocument = gql`
    mutation UpdateFeaturedEntitiesSetArtistIds($artistId: ID!, $index: Int!, $replace: Int!) {
  UpdateFeaturedEntities(input: {actions: [{setArtistIds: {artistId: $artistId, index: $index, replace: $replace}}]}) {
    id
  }
}
    `;
export type UpdateFeaturedEntitiesSetArtistIdsMutationFn = Apollo.MutationFunction<UpdateFeaturedEntitiesSetArtistIdsMutation, UpdateFeaturedEntitiesSetArtistIdsMutationVariables>;

/**
 * __useUpdateFeaturedEntitiesSetArtistIdsMutation__
 *
 * To run a mutation, you first call `useUpdateFeaturedEntitiesSetArtistIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeaturedEntitiesSetArtistIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeaturedEntitiesSetArtistIdsMutation, { data, loading, error }] = useUpdateFeaturedEntitiesSetArtistIdsMutation({
 *   variables: {
 *      artistId: // value for 'artistId'
 *      index: // value for 'index'
 *      replace: // value for 'replace'
 *   },
 * });
 */
export function useUpdateFeaturedEntitiesSetArtistIdsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeaturedEntitiesSetArtistIdsMutation, UpdateFeaturedEntitiesSetArtistIdsMutationVariables>) {
        return Apollo.useMutation<UpdateFeaturedEntitiesSetArtistIdsMutation, UpdateFeaturedEntitiesSetArtistIdsMutationVariables>(UpdateFeaturedEntitiesSetArtistIdsDocument, baseOptions);
      }
export type UpdateFeaturedEntitiesSetArtistIdsMutationHookResult = ReturnType<typeof useUpdateFeaturedEntitiesSetArtistIdsMutation>;
export type UpdateFeaturedEntitiesSetArtistIdsMutationResult = Apollo.MutationResult<UpdateFeaturedEntitiesSetArtistIdsMutation>;
export type UpdateFeaturedEntitiesSetArtistIdsMutationOptions = Apollo.BaseMutationOptions<UpdateFeaturedEntitiesSetArtistIdsMutation, UpdateFeaturedEntitiesSetArtistIdsMutationVariables>;
export const LoginFacebookUserDocument = gql`
    mutation LoginFacebookUser($facebookAccessToken: String!, $facebookUserId: String!) {
  LoginFacebookUser(input: {facebookAccessToken: $facebookAccessToken, facebookUserId: $facebookUserId}) {
    token
    success
    code
    userId
    username
  }
}
    `;
export type LoginFacebookUserMutationFn = Apollo.MutationFunction<LoginFacebookUserMutation, LoginFacebookUserMutationVariables>;

/**
 * __useLoginFacebookUserMutation__
 *
 * To run a mutation, you first call `useLoginFacebookUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginFacebookUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginFacebookUserMutation, { data, loading, error }] = useLoginFacebookUserMutation({
 *   variables: {
 *      facebookAccessToken: // value for 'facebookAccessToken'
 *      facebookUserId: // value for 'facebookUserId'
 *   },
 * });
 */
export function useLoginFacebookUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginFacebookUserMutation, LoginFacebookUserMutationVariables>) {
        return Apollo.useMutation<LoginFacebookUserMutation, LoginFacebookUserMutationVariables>(LoginFacebookUserDocument, baseOptions);
      }
export type LoginFacebookUserMutationHookResult = ReturnType<typeof useLoginFacebookUserMutation>;
export type LoginFacebookUserMutationResult = Apollo.MutationResult<LoginFacebookUserMutation>;
export type LoginFacebookUserMutationOptions = Apollo.BaseMutationOptions<LoginFacebookUserMutation, LoginFacebookUserMutationVariables>;
export const SetCrawlIgMediasDocument = gql`
    mutation SetCrawlIgMedias($mediaUrls: [String!], $searchTerms: String, $crawlChannel: Boolean) {
  SetCrawlIgMedias(input: {mediaUrls: $mediaUrls, searchTerms: $searchTerms, crawlChannel: $crawlChannel})
}
    `;
export type SetCrawlIgMediasMutationFn = Apollo.MutationFunction<SetCrawlIgMediasMutation, SetCrawlIgMediasMutationVariables>;

/**
 * __useSetCrawlIgMediasMutation__
 *
 * To run a mutation, you first call `useSetCrawlIgMediasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCrawlIgMediasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCrawlIgMediasMutation, { data, loading, error }] = useSetCrawlIgMediasMutation({
 *   variables: {
 *      mediaUrls: // value for 'mediaUrls'
 *      searchTerms: // value for 'searchTerms'
 *      crawlChannel: // value for 'crawlChannel'
 *   },
 * });
 */
export function useSetCrawlIgMediasMutation(baseOptions?: Apollo.MutationHookOptions<SetCrawlIgMediasMutation, SetCrawlIgMediasMutationVariables>) {
        return Apollo.useMutation<SetCrawlIgMediasMutation, SetCrawlIgMediasMutationVariables>(SetCrawlIgMediasDocument, baseOptions);
      }
export type SetCrawlIgMediasMutationHookResult = ReturnType<typeof useSetCrawlIgMediasMutation>;
export type SetCrawlIgMediasMutationResult = Apollo.MutationResult<SetCrawlIgMediasMutation>;
export type SetCrawlIgMediasMutationOptions = Apollo.BaseMutationOptions<SetCrawlIgMediasMutation, SetCrawlIgMediasMutationVariables>;
export const StopCrawlIgMediaDocument = gql`
    mutation StopCrawlIgMedia($name: String!) {
  StopCrawlIgMedia(input: {name: $name})
}
    `;
export type StopCrawlIgMediaMutationFn = Apollo.MutationFunction<StopCrawlIgMediaMutation, StopCrawlIgMediaMutationVariables>;

/**
 * __useStopCrawlIgMediaMutation__
 *
 * To run a mutation, you first call `useStopCrawlIgMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopCrawlIgMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopCrawlIgMediaMutation, { data, loading, error }] = useStopCrawlIgMediaMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useStopCrawlIgMediaMutation(baseOptions?: Apollo.MutationHookOptions<StopCrawlIgMediaMutation, StopCrawlIgMediaMutationVariables>) {
        return Apollo.useMutation<StopCrawlIgMediaMutation, StopCrawlIgMediaMutationVariables>(StopCrawlIgMediaDocument, baseOptions);
      }
export type StopCrawlIgMediaMutationHookResult = ReturnType<typeof useStopCrawlIgMediaMutation>;
export type StopCrawlIgMediaMutationResult = Apollo.MutationResult<StopCrawlIgMediaMutation>;
export type StopCrawlIgMediaMutationOptions = Apollo.BaseMutationOptions<StopCrawlIgMediaMutation, StopCrawlIgMediaMutationVariables>;
export const ValidateFacebookAccessTokenDocument = gql`
    mutation ValidateFacebookAccessToken {
  ValidateFacebookAccessToken
}
    `;
export type ValidateFacebookAccessTokenMutationFn = Apollo.MutationFunction<ValidateFacebookAccessTokenMutation, ValidateFacebookAccessTokenMutationVariables>;

/**
 * __useValidateFacebookAccessTokenMutation__
 *
 * To run a mutation, you first call `useValidateFacebookAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateFacebookAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateFacebookAccessTokenMutation, { data, loading, error }] = useValidateFacebookAccessTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useValidateFacebookAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidateFacebookAccessTokenMutation, ValidateFacebookAccessTokenMutationVariables>) {
        return Apollo.useMutation<ValidateFacebookAccessTokenMutation, ValidateFacebookAccessTokenMutationVariables>(ValidateFacebookAccessTokenDocument, baseOptions);
      }
export type ValidateFacebookAccessTokenMutationHookResult = ReturnType<typeof useValidateFacebookAccessTokenMutation>;
export type ValidateFacebookAccessTokenMutationResult = Apollo.MutationResult<ValidateFacebookAccessTokenMutation>;
export type ValidateFacebookAccessTokenMutationOptions = Apollo.BaseMutationOptions<ValidateFacebookAccessTokenMutation, ValidateFacebookAccessTokenMutationVariables>;
export const ValidateIgMediaDocument = gql`
    mutation ValidateIgMedia($mediaUrl: String!) {
  ValidateIgMedia(input: {mediaUrl: $mediaUrl}) {
    errorMessage
    caption
    thumbnail
    username
    mediaUrl
  }
}
    `;
export type ValidateIgMediaMutationFn = Apollo.MutationFunction<ValidateIgMediaMutation, ValidateIgMediaMutationVariables>;

/**
 * __useValidateIgMediaMutation__
 *
 * To run a mutation, you first call `useValidateIgMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateIgMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateIgMediaMutation, { data, loading, error }] = useValidateIgMediaMutation({
 *   variables: {
 *      mediaUrl: // value for 'mediaUrl'
 *   },
 * });
 */
export function useValidateIgMediaMutation(baseOptions?: Apollo.MutationHookOptions<ValidateIgMediaMutation, ValidateIgMediaMutationVariables>) {
        return Apollo.useMutation<ValidateIgMediaMutation, ValidateIgMediaMutationVariables>(ValidateIgMediaDocument, baseOptions);
      }
export type ValidateIgMediaMutationHookResult = ReturnType<typeof useValidateIgMediaMutation>;
export type ValidateIgMediaMutationResult = Apollo.MutationResult<ValidateIgMediaMutation>;
export type ValidateIgMediaMutationOptions = Apollo.BaseMutationOptions<ValidateIgMediaMutation, ValidateIgMediaMutationVariables>;
export const UpdateInstagramLinkedDocument = gql`
    mutation UpdateInstagramLinked {
  UpdateInstagramLinked {
    deletedSchedules
  }
}
    `;
export type UpdateInstagramLinkedMutationFn = Apollo.MutationFunction<UpdateInstagramLinkedMutation, UpdateInstagramLinkedMutationVariables>;

/**
 * __useUpdateInstagramLinkedMutation__
 *
 * To run a mutation, you first call `useUpdateInstagramLinkedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstagramLinkedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstagramLinkedMutation, { data, loading, error }] = useUpdateInstagramLinkedMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateInstagramLinkedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstagramLinkedMutation, UpdateInstagramLinkedMutationVariables>) {
        return Apollo.useMutation<UpdateInstagramLinkedMutation, UpdateInstagramLinkedMutationVariables>(UpdateInstagramLinkedDocument, baseOptions);
      }
export type UpdateInstagramLinkedMutationHookResult = ReturnType<typeof useUpdateInstagramLinkedMutation>;
export type UpdateInstagramLinkedMutationResult = Apollo.MutationResult<UpdateInstagramLinkedMutation>;
export type UpdateInstagramLinkedMutationOptions = Apollo.BaseMutationOptions<UpdateInstagramLinkedMutation, UpdateInstagramLinkedMutationVariables>;
export const UpdateProfileSetUsernameDocument = gql`
    mutation UpdateProfileSetUsername($username: String!) {
  UpdateProfile(input: {actions: [{setUsername: {username: $username}}]}) {
    username
  }
}
    `;
export type UpdateProfileSetUsernameMutationFn = Apollo.MutationFunction<UpdateProfileSetUsernameMutation, UpdateProfileSetUsernameMutationVariables>;

/**
 * __useUpdateProfileSetUsernameMutation__
 *
 * To run a mutation, you first call `useUpdateProfileSetUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileSetUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileSetUsernameMutation, { data, loading, error }] = useUpdateProfileSetUsernameMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUpdateProfileSetUsernameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileSetUsernameMutation, UpdateProfileSetUsernameMutationVariables>) {
        return Apollo.useMutation<UpdateProfileSetUsernameMutation, UpdateProfileSetUsernameMutationVariables>(UpdateProfileSetUsernameDocument, baseOptions);
      }
export type UpdateProfileSetUsernameMutationHookResult = ReturnType<typeof useUpdateProfileSetUsernameMutation>;
export type UpdateProfileSetUsernameMutationResult = Apollo.MutationResult<UpdateProfileSetUsernameMutation>;
export type UpdateProfileSetUsernameMutationOptions = Apollo.BaseMutationOptions<UpdateProfileSetUsernameMutation, UpdateProfileSetUsernameMutationVariables>;
export const UpdateProfileSetLinkDocument = gql`
    mutation UpdateProfileSetLink($link: GraphQLUrl) {
  UpdateProfile(input: {actions: [{setLink: {link: $link}}]}) {
    link
  }
}
    `;
export type UpdateProfileSetLinkMutationFn = Apollo.MutationFunction<UpdateProfileSetLinkMutation, UpdateProfileSetLinkMutationVariables>;

/**
 * __useUpdateProfileSetLinkMutation__
 *
 * To run a mutation, you first call `useUpdateProfileSetLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileSetLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileSetLinkMutation, { data, loading, error }] = useUpdateProfileSetLinkMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useUpdateProfileSetLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileSetLinkMutation, UpdateProfileSetLinkMutationVariables>) {
        return Apollo.useMutation<UpdateProfileSetLinkMutation, UpdateProfileSetLinkMutationVariables>(UpdateProfileSetLinkDocument, baseOptions);
      }
export type UpdateProfileSetLinkMutationHookResult = ReturnType<typeof useUpdateProfileSetLinkMutation>;
export type UpdateProfileSetLinkMutationResult = Apollo.MutationResult<UpdateProfileSetLinkMutation>;
export type UpdateProfileSetLinkMutationOptions = Apollo.BaseMutationOptions<UpdateProfileSetLinkMutation, UpdateProfileSetLinkMutationVariables>;
export const UpdateProfileSetBioDocument = gql`
    mutation UpdateProfileSetBio($bio: String) {
  UpdateProfile(input: {actions: [{setBio: {bio: $bio}}]}) {
    bio
  }
}
    `;
export type UpdateProfileSetBioMutationFn = Apollo.MutationFunction<UpdateProfileSetBioMutation, UpdateProfileSetBioMutationVariables>;

/**
 * __useUpdateProfileSetBioMutation__
 *
 * To run a mutation, you first call `useUpdateProfileSetBioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileSetBioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileSetBioMutation, { data, loading, error }] = useUpdateProfileSetBioMutation({
 *   variables: {
 *      bio: // value for 'bio'
 *   },
 * });
 */
export function useUpdateProfileSetBioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileSetBioMutation, UpdateProfileSetBioMutationVariables>) {
        return Apollo.useMutation<UpdateProfileSetBioMutation, UpdateProfileSetBioMutationVariables>(UpdateProfileSetBioDocument, baseOptions);
      }
export type UpdateProfileSetBioMutationHookResult = ReturnType<typeof useUpdateProfileSetBioMutation>;
export type UpdateProfileSetBioMutationResult = Apollo.MutationResult<UpdateProfileSetBioMutation>;
export type UpdateProfileSetBioMutationOptions = Apollo.BaseMutationOptions<UpdateProfileSetBioMutation, UpdateProfileSetBioMutationVariables>;
export const UpdateProfileSetTalkToMeAboutDocument = gql`
    mutation UpdateProfileSetTalkToMeAbout($talkToMeAbout: String!) {
  UpdateProfile(input: {actions: [{setTalkToMeAbout: {talkToMeAbout: $talkToMeAbout}}]}) {
    talkToMeAbout
  }
}
    `;
export type UpdateProfileSetTalkToMeAboutMutationFn = Apollo.MutationFunction<UpdateProfileSetTalkToMeAboutMutation, UpdateProfileSetTalkToMeAboutMutationVariables>;

/**
 * __useUpdateProfileSetTalkToMeAboutMutation__
 *
 * To run a mutation, you first call `useUpdateProfileSetTalkToMeAboutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileSetTalkToMeAboutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileSetTalkToMeAboutMutation, { data, loading, error }] = useUpdateProfileSetTalkToMeAboutMutation({
 *   variables: {
 *      talkToMeAbout: // value for 'talkToMeAbout'
 *   },
 * });
 */
export function useUpdateProfileSetTalkToMeAboutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileSetTalkToMeAboutMutation, UpdateProfileSetTalkToMeAboutMutationVariables>) {
        return Apollo.useMutation<UpdateProfileSetTalkToMeAboutMutation, UpdateProfileSetTalkToMeAboutMutationVariables>(UpdateProfileSetTalkToMeAboutDocument, baseOptions);
      }
export type UpdateProfileSetTalkToMeAboutMutationHookResult = ReturnType<typeof useUpdateProfileSetTalkToMeAboutMutation>;
export type UpdateProfileSetTalkToMeAboutMutationResult = Apollo.MutationResult<UpdateProfileSetTalkToMeAboutMutation>;
export type UpdateProfileSetTalkToMeAboutMutationOptions = Apollo.BaseMutationOptions<UpdateProfileSetTalkToMeAboutMutation, UpdateProfileSetTalkToMeAboutMutationVariables>;
export const UpdateProfileSetPriceDocument = gql`
    mutation UpdateProfileSetPrice($price: Int!, $isTakingQuestions: Boolean!) {
  UpdateProfile(input: {actions: [{setPrice: {price: $price, isTakingQuestions: $isTakingQuestions}}]}) {
    price
  }
}
    `;
export type UpdateProfileSetPriceMutationFn = Apollo.MutationFunction<UpdateProfileSetPriceMutation, UpdateProfileSetPriceMutationVariables>;

/**
 * __useUpdateProfileSetPriceMutation__
 *
 * To run a mutation, you first call `useUpdateProfileSetPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileSetPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileSetPriceMutation, { data, loading, error }] = useUpdateProfileSetPriceMutation({
 *   variables: {
 *      price: // value for 'price'
 *      isTakingQuestions: // value for 'isTakingQuestions'
 *   },
 * });
 */
export function useUpdateProfileSetPriceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileSetPriceMutation, UpdateProfileSetPriceMutationVariables>) {
        return Apollo.useMutation<UpdateProfileSetPriceMutation, UpdateProfileSetPriceMutationVariables>(UpdateProfileSetPriceDocument, baseOptions);
      }
export type UpdateProfileSetPriceMutationHookResult = ReturnType<typeof useUpdateProfileSetPriceMutation>;
export type UpdateProfileSetPriceMutationResult = Apollo.MutationResult<UpdateProfileSetPriceMutation>;
export type UpdateProfileSetPriceMutationOptions = Apollo.BaseMutationOptions<UpdateProfileSetPriceMutation, UpdateProfileSetPriceMutationVariables>;
export const UpdateProfileSetProfilePictureDocument = gql`
    mutation UpdateProfileSetProfilePicture($profilePictureUrl: String!) {
  UpdateProfile(input: {actions: [{setProfilePicture: {profilePictureUrl: $profilePictureUrl}}]}) {
    profilePictureUrl
  }
}
    `;
export type UpdateProfileSetProfilePictureMutationFn = Apollo.MutationFunction<UpdateProfileSetProfilePictureMutation, UpdateProfileSetProfilePictureMutationVariables>;

/**
 * __useUpdateProfileSetProfilePictureMutation__
 *
 * To run a mutation, you first call `useUpdateProfileSetProfilePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileSetProfilePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileSetProfilePictureMutation, { data, loading, error }] = useUpdateProfileSetProfilePictureMutation({
 *   variables: {
 *      profilePictureUrl: // value for 'profilePictureUrl'
 *   },
 * });
 */
export function useUpdateProfileSetProfilePictureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileSetProfilePictureMutation, UpdateProfileSetProfilePictureMutationVariables>) {
        return Apollo.useMutation<UpdateProfileSetProfilePictureMutation, UpdateProfileSetProfilePictureMutationVariables>(UpdateProfileSetProfilePictureDocument, baseOptions);
      }
export type UpdateProfileSetProfilePictureMutationHookResult = ReturnType<typeof useUpdateProfileSetProfilePictureMutation>;
export type UpdateProfileSetProfilePictureMutationResult = Apollo.MutationResult<UpdateProfileSetProfilePictureMutation>;
export type UpdateProfileSetProfilePictureMutationOptions = Apollo.BaseMutationOptions<UpdateProfileSetProfilePictureMutation, UpdateProfileSetProfilePictureMutationVariables>;
export const UpdateProfileSetNameDocument = gql`
    mutation UpdateProfileSetName($name: String!) {
  UpdateProfile(input: {actions: [{setName: {name: $name}}]}) {
    name
  }
}
    `;
export type UpdateProfileSetNameMutationFn = Apollo.MutationFunction<UpdateProfileSetNameMutation, UpdateProfileSetNameMutationVariables>;

/**
 * __useUpdateProfileSetNameMutation__
 *
 * To run a mutation, you first call `useUpdateProfileSetNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileSetNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileSetNameMutation, { data, loading, error }] = useUpdateProfileSetNameMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateProfileSetNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileSetNameMutation, UpdateProfileSetNameMutationVariables>) {
        return Apollo.useMutation<UpdateProfileSetNameMutation, UpdateProfileSetNameMutationVariables>(UpdateProfileSetNameDocument, baseOptions);
      }
export type UpdateProfileSetNameMutationHookResult = ReturnType<typeof useUpdateProfileSetNameMutation>;
export type UpdateProfileSetNameMutationResult = Apollo.MutationResult<UpdateProfileSetNameMutation>;
export type UpdateProfileSetNameMutationOptions = Apollo.BaseMutationOptions<UpdateProfileSetNameMutation, UpdateProfileSetNameMutationVariables>;
export const UpdateProfileSetIsTakingQuestionsDocument = gql`
    mutation UpdateProfileSetIsTakingQuestions($isTakingQuestions: Boolean!) {
  UpdateProfile(input: {actions: [{setIsTakingQuestions: {isTakingQuestions: $isTakingQuestions}}]}) {
    isTakingQuestions
  }
}
    `;
export type UpdateProfileSetIsTakingQuestionsMutationFn = Apollo.MutationFunction<UpdateProfileSetIsTakingQuestionsMutation, UpdateProfileSetIsTakingQuestionsMutationVariables>;

/**
 * __useUpdateProfileSetIsTakingQuestionsMutation__
 *
 * To run a mutation, you first call `useUpdateProfileSetIsTakingQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileSetIsTakingQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileSetIsTakingQuestionsMutation, { data, loading, error }] = useUpdateProfileSetIsTakingQuestionsMutation({
 *   variables: {
 *      isTakingQuestions: // value for 'isTakingQuestions'
 *   },
 * });
 */
export function useUpdateProfileSetIsTakingQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileSetIsTakingQuestionsMutation, UpdateProfileSetIsTakingQuestionsMutationVariables>) {
        return Apollo.useMutation<UpdateProfileSetIsTakingQuestionsMutation, UpdateProfileSetIsTakingQuestionsMutationVariables>(UpdateProfileSetIsTakingQuestionsDocument, baseOptions);
      }
export type UpdateProfileSetIsTakingQuestionsMutationHookResult = ReturnType<typeof useUpdateProfileSetIsTakingQuestionsMutation>;
export type UpdateProfileSetIsTakingQuestionsMutationResult = Apollo.MutationResult<UpdateProfileSetIsTakingQuestionsMutation>;
export type UpdateProfileSetIsTakingQuestionsMutationOptions = Apollo.BaseMutationOptions<UpdateProfileSetIsTakingQuestionsMutation, UpdateProfileSetIsTakingQuestionsMutationVariables>;
export const CreateQuestionDocument = gql`
    mutation CreateQuestion($artistId: ID!, $body: String!) {
  CreateQuestion(input: {artistId: $artistId, body: $body}) {
    question {
      id
    }
    success
    error {
      errorType
    }
  }
}
    `;
export type CreateQuestionMutationFn = Apollo.MutationFunction<CreateQuestionMutation, CreateQuestionMutationVariables>;

/**
 * __useCreateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMutation, { data, loading, error }] = useCreateQuestionMutation({
 *   variables: {
 *      artistId: // value for 'artistId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionMutation, CreateQuestionMutationVariables>) {
        return Apollo.useMutation<CreateQuestionMutation, CreateQuestionMutationVariables>(CreateQuestionDocument, baseOptions);
      }
export type CreateQuestionMutationHookResult = ReturnType<typeof useCreateQuestionMutation>;
export type CreateQuestionMutationResult = Apollo.MutationResult<CreateQuestionMutation>;
export type CreateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const CreateAnswerDocument = gql`
    mutation CreateAnswer($fanId: ID!, $body: String!, $questionId: ID!) {
  CreateAnswer(input: {fanId: $fanId, body: $body, questionId: $questionId}) {
    answer {
      id
      body
      questionId
    }
    success
    error {
      errorType
    }
  }
}
    `;
export type CreateAnswerMutationFn = Apollo.MutationFunction<CreateAnswerMutation, CreateAnswerMutationVariables>;

/**
 * __useCreateAnswerMutation__
 *
 * To run a mutation, you first call `useCreateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnswerMutation, { data, loading, error }] = useCreateAnswerMutation({
 *   variables: {
 *      fanId: // value for 'fanId'
 *      body: // value for 'body'
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useCreateAnswerMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnswerMutation, CreateAnswerMutationVariables>) {
        return Apollo.useMutation<CreateAnswerMutation, CreateAnswerMutationVariables>(CreateAnswerDocument, baseOptions);
      }
export type CreateAnswerMutationHookResult = ReturnType<typeof useCreateAnswerMutation>;
export type CreateAnswerMutationResult = Apollo.MutationResult<CreateAnswerMutation>;
export type CreateAnswerMutationOptions = Apollo.BaseMutationOptions<CreateAnswerMutation, CreateAnswerMutationVariables>;
export const CreateNftDocument = gql`
    mutation CreateNft($fanId: ID!, $questionId: ID!, $wallet: String!) {
  CreateNft(input: {fanId: $fanId, questionId: $questionId, wallet: $wallet}) {
    success
    error {
      errorType
    }
  }
}
    `;
export type CreateNftMutationFn = Apollo.MutationFunction<CreateNftMutation, CreateNftMutationVariables>;

/**
 * __useCreateNftMutation__
 *
 * To run a mutation, you first call `useCreateNftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNftMutation, { data, loading, error }] = useCreateNftMutation({
 *   variables: {
 *      fanId: // value for 'fanId'
 *      questionId: // value for 'questionId'
 *      wallet: // value for 'wallet'
 *   },
 * });
 */
export function useCreateNftMutation(baseOptions?: Apollo.MutationHookOptions<CreateNftMutation, CreateNftMutationVariables>) {
        return Apollo.useMutation<CreateNftMutation, CreateNftMutationVariables>(CreateNftDocument, baseOptions);
      }
export type CreateNftMutationHookResult = ReturnType<typeof useCreateNftMutation>;
export type CreateNftMutationResult = Apollo.MutationResult<CreateNftMutation>;
export type CreateNftMutationOptions = Apollo.BaseMutationOptions<CreateNftMutation, CreateNftMutationVariables>;
export const CreateSupportPaymentDocument = gql`
    mutation CreateSupportPayment($questionId: ID!, $price: Int!, $paymentMethodId: String, $savePaymentMethod: Boolean!, $couponCode: String) {
  CreateSupportPayment(input: {questionId: $questionId, price: $price, paymentMethodId: $paymentMethodId, savePaymentMethod: $savePaymentMethod, couponCode: $couponCode}) {
    supportPayment {
      id
      Supporter {
        id
      }
      price
      state
      CouponActivation {
        id
        discountAmountApplied
      }
    }
    question {
      supportPayments {
        id
      }
    }
    success
    error {
      errorType
    }
  }
}
    `;
export type CreateSupportPaymentMutationFn = Apollo.MutationFunction<CreateSupportPaymentMutation, CreateSupportPaymentMutationVariables>;

/**
 * __useCreateSupportPaymentMutation__
 *
 * To run a mutation, you first call `useCreateSupportPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportPaymentMutation, { data, loading, error }] = useCreateSupportPaymentMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      price: // value for 'price'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      savePaymentMethod: // value for 'savePaymentMethod'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useCreateSupportPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupportPaymentMutation, CreateSupportPaymentMutationVariables>) {
        return Apollo.useMutation<CreateSupportPaymentMutation, CreateSupportPaymentMutationVariables>(CreateSupportPaymentDocument, baseOptions);
      }
export type CreateSupportPaymentMutationHookResult = ReturnType<typeof useCreateSupportPaymentMutation>;
export type CreateSupportPaymentMutationResult = Apollo.MutationResult<CreateSupportPaymentMutation>;
export type CreateSupportPaymentMutationOptions = Apollo.BaseMutationOptions<CreateSupportPaymentMutation, CreateSupportPaymentMutationVariables>;
export const UpdateQuestionSetDeclinedDocument = gql`
    mutation UpdateQuestionSetDeclined($questionId: ID!) {
  UpdateQuestion(input: {id: $questionId, actions: [{setDeclined: {declined: true}}]}) {
    id
  }
}
    `;
export type UpdateQuestionSetDeclinedMutationFn = Apollo.MutationFunction<UpdateQuestionSetDeclinedMutation, UpdateQuestionSetDeclinedMutationVariables>;

/**
 * __useUpdateQuestionSetDeclinedMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionSetDeclinedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionSetDeclinedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionSetDeclinedMutation, { data, loading, error }] = useUpdateQuestionSetDeclinedMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useUpdateQuestionSetDeclinedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionSetDeclinedMutation, UpdateQuestionSetDeclinedMutationVariables>) {
        return Apollo.useMutation<UpdateQuestionSetDeclinedMutation, UpdateQuestionSetDeclinedMutationVariables>(UpdateQuestionSetDeclinedDocument, baseOptions);
      }
export type UpdateQuestionSetDeclinedMutationHookResult = ReturnType<typeof useUpdateQuestionSetDeclinedMutation>;
export type UpdateQuestionSetDeclinedMutationResult = Apollo.MutationResult<UpdateQuestionSetDeclinedMutation>;
export type UpdateQuestionSetDeclinedMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionSetDeclinedMutation, UpdateQuestionSetDeclinedMutationVariables>;
export const UpdateQuestionSetFlaggedDocument = gql`
    mutation UpdateQuestionSetFlagged($questionId: ID!, $flaggedMessage: String!) {
  UpdateQuestion(input: {id: $questionId, actions: [{setFlagged: {flaggedMessage: $flaggedMessage}}]}) {
    id
  }
}
    `;
export type UpdateQuestionSetFlaggedMutationFn = Apollo.MutationFunction<UpdateQuestionSetFlaggedMutation, UpdateQuestionSetFlaggedMutationVariables>;

/**
 * __useUpdateQuestionSetFlaggedMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionSetFlaggedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionSetFlaggedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionSetFlaggedMutation, { data, loading, error }] = useUpdateQuestionSetFlaggedMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      flaggedMessage: // value for 'flaggedMessage'
 *   },
 * });
 */
export function useUpdateQuestionSetFlaggedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionSetFlaggedMutation, UpdateQuestionSetFlaggedMutationVariables>) {
        return Apollo.useMutation<UpdateQuestionSetFlaggedMutation, UpdateQuestionSetFlaggedMutationVariables>(UpdateQuestionSetFlaggedDocument, baseOptions);
      }
export type UpdateQuestionSetFlaggedMutationHookResult = ReturnType<typeof useUpdateQuestionSetFlaggedMutation>;
export type UpdateQuestionSetFlaggedMutationResult = Apollo.MutationResult<UpdateQuestionSetFlaggedMutation>;
export type UpdateQuestionSetFlaggedMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionSetFlaggedMutation, UpdateQuestionSetFlaggedMutationVariables>;
export const UpdateAnswerSetBodyDocument = gql`
    mutation UpdateAnswerSetBody($answerId: ID!, $body: String!) {
  UpdateAnswer(input: {id: $answerId, actions: [{setBody: {body: $body}}]}) {
    body
  }
}
    `;
export type UpdateAnswerSetBodyMutationFn = Apollo.MutationFunction<UpdateAnswerSetBodyMutation, UpdateAnswerSetBodyMutationVariables>;

/**
 * __useUpdateAnswerSetBodyMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerSetBodyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerSetBodyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerSetBodyMutation, { data, loading, error }] = useUpdateAnswerSetBodyMutation({
 *   variables: {
 *      answerId: // value for 'answerId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateAnswerSetBodyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnswerSetBodyMutation, UpdateAnswerSetBodyMutationVariables>) {
        return Apollo.useMutation<UpdateAnswerSetBodyMutation, UpdateAnswerSetBodyMutationVariables>(UpdateAnswerSetBodyDocument, baseOptions);
      }
export type UpdateAnswerSetBodyMutationHookResult = ReturnType<typeof useUpdateAnswerSetBodyMutation>;
export type UpdateAnswerSetBodyMutationResult = Apollo.MutationResult<UpdateAnswerSetBodyMutation>;
export type UpdateAnswerSetBodyMutationOptions = Apollo.BaseMutationOptions<UpdateAnswerSetBodyMutation, UpdateAnswerSetBodyMutationVariables>;
export const CreateReactionDocument = gql`
    mutation CreateReaction($questionId: ID!, $emoji: EmojiReaction) {
  CreateReaction(input: {questionId: $questionId, emoji: $emoji}) {
    reactions {
      emoji
      ranking
      artistEmoji
      Reactor {
        id
      }
    }
  }
}
    `;
export type CreateReactionMutationFn = Apollo.MutationFunction<CreateReactionMutation, CreateReactionMutationVariables>;

/**
 * __useCreateReactionMutation__
 *
 * To run a mutation, you first call `useCreateReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReactionMutation, { data, loading, error }] = useCreateReactionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      emoji: // value for 'emoji'
 *   },
 * });
 */
export function useCreateReactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateReactionMutation, CreateReactionMutationVariables>) {
        return Apollo.useMutation<CreateReactionMutation, CreateReactionMutationVariables>(CreateReactionDocument, baseOptions);
      }
export type CreateReactionMutationHookResult = ReturnType<typeof useCreateReactionMutation>;
export type CreateReactionMutationResult = Apollo.MutationResult<CreateReactionMutation>;
export type CreateReactionMutationOptions = Apollo.BaseMutationOptions<CreateReactionMutation, CreateReactionMutationVariables>;
export const CreateEmailReferralDocument = gql`
    mutation CreateEmailReferral($recipientName: String!, $recipientEmail: String!, $message: String!, $username: String!) {
  CreateEmailReferral(input: {recipientName: $recipientName, recipientEmail: $recipientEmail, message: $message, username: $username})
}
    `;
export type CreateEmailReferralMutationFn = Apollo.MutationFunction<CreateEmailReferralMutation, CreateEmailReferralMutationVariables>;

/**
 * __useCreateEmailReferralMutation__
 *
 * To run a mutation, you first call `useCreateEmailReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailReferralMutation, { data, loading, error }] = useCreateEmailReferralMutation({
 *   variables: {
 *      recipientName: // value for 'recipientName'
 *      recipientEmail: // value for 'recipientEmail'
 *      message: // value for 'message'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useCreateEmailReferralMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailReferralMutation, CreateEmailReferralMutationVariables>) {
        return Apollo.useMutation<CreateEmailReferralMutation, CreateEmailReferralMutationVariables>(CreateEmailReferralDocument, baseOptions);
      }
export type CreateEmailReferralMutationHookResult = ReturnType<typeof useCreateEmailReferralMutation>;
export type CreateEmailReferralMutationResult = Apollo.MutationResult<CreateEmailReferralMutation>;
export type CreateEmailReferralMutationOptions = Apollo.BaseMutationOptions<CreateEmailReferralMutation, CreateEmailReferralMutationVariables>;
export const CreateRoyaltySummaryDocument = gql`
    mutation CreateRoyaltySummary($artistId: ID!) {
  CreateRoyaltySummary(input: {artistId: $artistId}) {
    amount
    value
    usd_value
  }
}
    `;
export type CreateRoyaltySummaryMutationFn = Apollo.MutationFunction<CreateRoyaltySummaryMutation, CreateRoyaltySummaryMutationVariables>;

/**
 * __useCreateRoyaltySummaryMutation__
 *
 * To run a mutation, you first call `useCreateRoyaltySummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoyaltySummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoyaltySummaryMutation, { data, loading, error }] = useCreateRoyaltySummaryMutation({
 *   variables: {
 *      artistId: // value for 'artistId'
 *   },
 * });
 */
export function useCreateRoyaltySummaryMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoyaltySummaryMutation, CreateRoyaltySummaryMutationVariables>) {
        return Apollo.useMutation<CreateRoyaltySummaryMutation, CreateRoyaltySummaryMutationVariables>(CreateRoyaltySummaryDocument, baseOptions);
      }
export type CreateRoyaltySummaryMutationHookResult = ReturnType<typeof useCreateRoyaltySummaryMutation>;
export type CreateRoyaltySummaryMutationResult = Apollo.MutationResult<CreateRoyaltySummaryMutation>;
export type CreateRoyaltySummaryMutationOptions = Apollo.BaseMutationOptions<CreateRoyaltySummaryMutation, CreateRoyaltySummaryMutationVariables>;
export const CreateRoyaltyPayoutDocument = gql`
    mutation CreateRoyaltyPayout($wallet: String!) {
  CreateRoyaltyPayout(input: {wallet: $wallet}) {
    success
    error {
      errorType
    }
  }
}
    `;
export type CreateRoyaltyPayoutMutationFn = Apollo.MutationFunction<CreateRoyaltyPayoutMutation, CreateRoyaltyPayoutMutationVariables>;

/**
 * __useCreateRoyaltyPayoutMutation__
 *
 * To run a mutation, you first call `useCreateRoyaltyPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoyaltyPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoyaltyPayoutMutation, { data, loading, error }] = useCreateRoyaltyPayoutMutation({
 *   variables: {
 *      wallet: // value for 'wallet'
 *   },
 * });
 */
export function useCreateRoyaltyPayoutMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoyaltyPayoutMutation, CreateRoyaltyPayoutMutationVariables>) {
        return Apollo.useMutation<CreateRoyaltyPayoutMutation, CreateRoyaltyPayoutMutationVariables>(CreateRoyaltyPayoutDocument, baseOptions);
      }
export type CreateRoyaltyPayoutMutationHookResult = ReturnType<typeof useCreateRoyaltyPayoutMutation>;
export type CreateRoyaltyPayoutMutationResult = Apollo.MutationResult<CreateRoyaltyPayoutMutation>;
export type CreateRoyaltyPayoutMutationOptions = Apollo.BaseMutationOptions<CreateRoyaltyPayoutMutation, CreateRoyaltyPayoutMutationVariables>;
export const UpdateRoyaltyPayoutDocument = gql`
    mutation UpdateRoyaltyPayout($id: ID!, $txID: String!) {
  UpdateRoyaltyPayout(input: {id: $id, txID: $txID}) {
    nftAmount
    artistWallet
    createdAt
    artistUsername
    artistId
    txID
    royalty
    settled
    royaltyIds
    id
  }
}
    `;
export type UpdateRoyaltyPayoutMutationFn = Apollo.MutationFunction<UpdateRoyaltyPayoutMutation, UpdateRoyaltyPayoutMutationVariables>;

/**
 * __useUpdateRoyaltyPayoutMutation__
 *
 * To run a mutation, you first call `useUpdateRoyaltyPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoyaltyPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoyaltyPayoutMutation, { data, loading, error }] = useUpdateRoyaltyPayoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *      txID: // value for 'txID'
 *   },
 * });
 */
export function useUpdateRoyaltyPayoutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoyaltyPayoutMutation, UpdateRoyaltyPayoutMutationVariables>) {
        return Apollo.useMutation<UpdateRoyaltyPayoutMutation, UpdateRoyaltyPayoutMutationVariables>(UpdateRoyaltyPayoutDocument, baseOptions);
      }
export type UpdateRoyaltyPayoutMutationHookResult = ReturnType<typeof useUpdateRoyaltyPayoutMutation>;
export type UpdateRoyaltyPayoutMutationResult = Apollo.MutationResult<UpdateRoyaltyPayoutMutation>;
export type UpdateRoyaltyPayoutMutationOptions = Apollo.BaseMutationOptions<UpdateRoyaltyPayoutMutation, UpdateRoyaltyPayoutMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($name: String!, $username: String!, $email: String!, $phoneNumber: PhoneNumber!, $phoneCountryCode: Int!, $password: String!, $path: String, $locale: GraphQLLocale!, $referredByCoach: String, $referredByUser: String, $campaignCode: String, $timezone: String!) {
  CreateUser(input: {name: $name, username: $username, email: $email, phoneNumber: $phoneNumber, phoneCountryCode: $phoneCountryCode, password: $password, path: $path, campaignCode: $campaignCode, referredByCoach: $referredByCoach, referredByUser: $referredByUser, timezone: $timezone, locale: $locale}) {
    token
    userId
    username
    code
    success
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      username: // value for 'username'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *      password: // value for 'password'
 *      path: // value for 'path'
 *      locale: // value for 'locale'
 *      referredByCoach: // value for 'referredByCoach'
 *      referredByUser: // value for 'referredByUser'
 *      campaignCode: // value for 'campaignCode'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, baseOptions);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const ManagerArtistLoginDocument = gql`
    mutation ManagerArtistLogin($artistUsername: String!, $managerToken: String) {
  ManagerArtistLogin(input: {artistUsername: $artistUsername, managerToken: $managerToken}) {
    token
    userId
    username
    code
    success
  }
}
    `;
export type ManagerArtistLoginMutationFn = Apollo.MutationFunction<ManagerArtistLoginMutation, ManagerArtistLoginMutationVariables>;

/**
 * __useManagerArtistLoginMutation__
 *
 * To run a mutation, you first call `useManagerArtistLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManagerArtistLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [managerArtistLoginMutation, { data, loading, error }] = useManagerArtistLoginMutation({
 *   variables: {
 *      artistUsername: // value for 'artistUsername'
 *      managerToken: // value for 'managerToken'
 *   },
 * });
 */
export function useManagerArtistLoginMutation(baseOptions?: Apollo.MutationHookOptions<ManagerArtistLoginMutation, ManagerArtistLoginMutationVariables>) {
        return Apollo.useMutation<ManagerArtistLoginMutation, ManagerArtistLoginMutationVariables>(ManagerArtistLoginDocument, baseOptions);
      }
export type ManagerArtistLoginMutationHookResult = ReturnType<typeof useManagerArtistLoginMutation>;
export type ManagerArtistLoginMutationResult = Apollo.MutationResult<ManagerArtistLoginMutation>;
export type ManagerArtistLoginMutationOptions = Apollo.BaseMutationOptions<ManagerArtistLoginMutation, ManagerArtistLoginMutationVariables>;
export const UpdateUserSetLastSeenDocument = gql`
    mutation UpdateUserSetLastSeen {
  UpdateUser(input: {actions: [{setLastSeen: {seen: true}}]}) {
    id
  }
}
    `;
export type UpdateUserSetLastSeenMutationFn = Apollo.MutationFunction<UpdateUserSetLastSeenMutation, UpdateUserSetLastSeenMutationVariables>;

/**
 * __useUpdateUserSetLastSeenMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetLastSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetLastSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetLastSeenMutation, { data, loading, error }] = useUpdateUserSetLastSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateUserSetLastSeenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetLastSeenMutation, UpdateUserSetLastSeenMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetLastSeenMutation, UpdateUserSetLastSeenMutationVariables>(UpdateUserSetLastSeenDocument, baseOptions);
      }
export type UpdateUserSetLastSeenMutationHookResult = ReturnType<typeof useUpdateUserSetLastSeenMutation>;
export type UpdateUserSetLastSeenMutationResult = Apollo.MutationResult<UpdateUserSetLastSeenMutation>;
export type UpdateUserSetLastSeenMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetLastSeenMutation, UpdateUserSetLastSeenMutationVariables>;
export const UpdateAlertDocument = gql`
    mutation UpdateAlert($alertType: AlertType!) {
  UpdateAlert(input: {alertType: $alertType}) {
    success
    error {
      errorType
    }
  }
}
    `;
export type UpdateAlertMutationFn = Apollo.MutationFunction<UpdateAlertMutation, UpdateAlertMutationVariables>;

/**
 * __useUpdateAlertMutation__
 *
 * To run a mutation, you first call `useUpdateAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertMutation, { data, loading, error }] = useUpdateAlertMutation({
 *   variables: {
 *      alertType: // value for 'alertType'
 *   },
 * });
 */
export function useUpdateAlertMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlertMutation, UpdateAlertMutationVariables>) {
        return Apollo.useMutation<UpdateAlertMutation, UpdateAlertMutationVariables>(UpdateAlertDocument, baseOptions);
      }
export type UpdateAlertMutationHookResult = ReturnType<typeof useUpdateAlertMutation>;
export type UpdateAlertMutationResult = Apollo.MutationResult<UpdateAlertMutation>;
export type UpdateAlertMutationOptions = Apollo.BaseMutationOptions<UpdateAlertMutation, UpdateAlertMutationVariables>;
export const UpdateUserSetCountryCodeAndPhoneNumberDocument = gql`
    mutation UpdateUserSetCountryCodeAndPhoneNumber($phoneCountryCode: Int!, $phoneNumber: PhoneNumber!) {
  UpdateUser(input: {actions: [{setCountryCodeAndPhoneNumber: {phoneCountryCode: $phoneCountryCode, phoneNumber: $phoneNumber}}]}) {
    phoneCountryCode
    phoneNumber
    phoneVerified
  }
}
    `;
export type UpdateUserSetCountryCodeAndPhoneNumberMutationFn = Apollo.MutationFunction<UpdateUserSetCountryCodeAndPhoneNumberMutation, UpdateUserSetCountryCodeAndPhoneNumberMutationVariables>;

/**
 * __useUpdateUserSetCountryCodeAndPhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetCountryCodeAndPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetCountryCodeAndPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetCountryCodeAndPhoneNumberMutation, { data, loading, error }] = useUpdateUserSetCountryCodeAndPhoneNumberMutation({
 *   variables: {
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateUserSetCountryCodeAndPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetCountryCodeAndPhoneNumberMutation, UpdateUserSetCountryCodeAndPhoneNumberMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetCountryCodeAndPhoneNumberMutation, UpdateUserSetCountryCodeAndPhoneNumberMutationVariables>(UpdateUserSetCountryCodeAndPhoneNumberDocument, baseOptions);
      }
export type UpdateUserSetCountryCodeAndPhoneNumberMutationHookResult = ReturnType<typeof useUpdateUserSetCountryCodeAndPhoneNumberMutation>;
export type UpdateUserSetCountryCodeAndPhoneNumberMutationResult = Apollo.MutationResult<UpdateUserSetCountryCodeAndPhoneNumberMutation>;
export type UpdateUserSetCountryCodeAndPhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetCountryCodeAndPhoneNumberMutation, UpdateUserSetCountryCodeAndPhoneNumberMutationVariables>;
export const ResendPhoneVerificationDocument = gql`
    mutation ResendPhoneVerification($resend: Boolean!) {
  UpdateUser(input: {actions: [{setResendPhoneVerification: {resend: $resend}}]}) {
    id
  }
}
    `;
export type ResendPhoneVerificationMutationFn = Apollo.MutationFunction<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>;

/**
 * __useResendPhoneVerificationMutation__
 *
 * To run a mutation, you first call `useResendPhoneVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPhoneVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPhoneVerificationMutation, { data, loading, error }] = useResendPhoneVerificationMutation({
 *   variables: {
 *      resend: // value for 'resend'
 *   },
 * });
 */
export function useResendPhoneVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>) {
        return Apollo.useMutation<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>(ResendPhoneVerificationDocument, baseOptions);
      }
export type ResendPhoneVerificationMutationHookResult = ReturnType<typeof useResendPhoneVerificationMutation>;
export type ResendPhoneVerificationMutationResult = Apollo.MutationResult<ResendPhoneVerificationMutation>;
export type ResendPhoneVerificationMutationOptions = Apollo.BaseMutationOptions<ResendPhoneVerificationMutation, ResendPhoneVerificationMutationVariables>;
export const UpdateUserSetReceiveSmsUpdatesDocument = gql`
    mutation UpdateUserSetReceiveSMSUpdates($receiveSMSUpdates: Boolean!) {
  UpdateUser(input: {actions: [{setReceiveSMSUpdates: {receiveSMSUpdates: $receiveSMSUpdates}}]}) {
    receiveSMSUpdates
  }
}
    `;
export type UpdateUserSetReceiveSmsUpdatesMutationFn = Apollo.MutationFunction<UpdateUserSetReceiveSmsUpdatesMutation, UpdateUserSetReceiveSmsUpdatesMutationVariables>;

/**
 * __useUpdateUserSetReceiveSmsUpdatesMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetReceiveSmsUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetReceiveSmsUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetReceiveSmsUpdatesMutation, { data, loading, error }] = useUpdateUserSetReceiveSmsUpdatesMutation({
 *   variables: {
 *      receiveSMSUpdates: // value for 'receiveSMSUpdates'
 *   },
 * });
 */
export function useUpdateUserSetReceiveSmsUpdatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetReceiveSmsUpdatesMutation, UpdateUserSetReceiveSmsUpdatesMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetReceiveSmsUpdatesMutation, UpdateUserSetReceiveSmsUpdatesMutationVariables>(UpdateUserSetReceiveSmsUpdatesDocument, baseOptions);
      }
export type UpdateUserSetReceiveSmsUpdatesMutationHookResult = ReturnType<typeof useUpdateUserSetReceiveSmsUpdatesMutation>;
export type UpdateUserSetReceiveSmsUpdatesMutationResult = Apollo.MutationResult<UpdateUserSetReceiveSmsUpdatesMutation>;
export type UpdateUserSetReceiveSmsUpdatesMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetReceiveSmsUpdatesMutation, UpdateUserSetReceiveSmsUpdatesMutationVariables>;
export const UpdateUserSetEnableQuestionCreatedNotificationsDocument = gql`
    mutation UpdateUserSetEnableQuestionCreatedNotifications($enableQuestionCreatedNotifications: Boolean!) {
  UpdateUser(input: {actions: [{setEnableQuestionCreatedNotifications: {enable: $enableQuestionCreatedNotifications}}]}) {
    questionCreatedNotificationEnabled
  }
}
    `;
export type UpdateUserSetEnableQuestionCreatedNotificationsMutationFn = Apollo.MutationFunction<UpdateUserSetEnableQuestionCreatedNotificationsMutation, UpdateUserSetEnableQuestionCreatedNotificationsMutationVariables>;

/**
 * __useUpdateUserSetEnableQuestionCreatedNotificationsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetEnableQuestionCreatedNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetEnableQuestionCreatedNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetEnableQuestionCreatedNotificationsMutation, { data, loading, error }] = useUpdateUserSetEnableQuestionCreatedNotificationsMutation({
 *   variables: {
 *      enableQuestionCreatedNotifications: // value for 'enableQuestionCreatedNotifications'
 *   },
 * });
 */
export function useUpdateUserSetEnableQuestionCreatedNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetEnableQuestionCreatedNotificationsMutation, UpdateUserSetEnableQuestionCreatedNotificationsMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetEnableQuestionCreatedNotificationsMutation, UpdateUserSetEnableQuestionCreatedNotificationsMutationVariables>(UpdateUserSetEnableQuestionCreatedNotificationsDocument, baseOptions);
      }
export type UpdateUserSetEnableQuestionCreatedNotificationsMutationHookResult = ReturnType<typeof useUpdateUserSetEnableQuestionCreatedNotificationsMutation>;
export type UpdateUserSetEnableQuestionCreatedNotificationsMutationResult = Apollo.MutationResult<UpdateUserSetEnableQuestionCreatedNotificationsMutation>;
export type UpdateUserSetEnableQuestionCreatedNotificationsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetEnableQuestionCreatedNotificationsMutation, UpdateUserSetEnableQuestionCreatedNotificationsMutationVariables>;
export const UpdateUserSetEnableAnswerCreatedNotificationsDocument = gql`
    mutation UpdateUserSetEnableAnswerCreatedNotifications($enableAnswerCreatedNotifications: Boolean!) {
  UpdateUser(input: {actions: [{setEnableAnswerCreatedNotifications: {enable: $enableAnswerCreatedNotifications}}]}) {
    answerCreatedNotificationEnabled
  }
}
    `;
export type UpdateUserSetEnableAnswerCreatedNotificationsMutationFn = Apollo.MutationFunction<UpdateUserSetEnableAnswerCreatedNotificationsMutation, UpdateUserSetEnableAnswerCreatedNotificationsMutationVariables>;

/**
 * __useUpdateUserSetEnableAnswerCreatedNotificationsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetEnableAnswerCreatedNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetEnableAnswerCreatedNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetEnableAnswerCreatedNotificationsMutation, { data, loading, error }] = useUpdateUserSetEnableAnswerCreatedNotificationsMutation({
 *   variables: {
 *      enableAnswerCreatedNotifications: // value for 'enableAnswerCreatedNotifications'
 *   },
 * });
 */
export function useUpdateUserSetEnableAnswerCreatedNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetEnableAnswerCreatedNotificationsMutation, UpdateUserSetEnableAnswerCreatedNotificationsMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetEnableAnswerCreatedNotificationsMutation, UpdateUserSetEnableAnswerCreatedNotificationsMutationVariables>(UpdateUserSetEnableAnswerCreatedNotificationsDocument, baseOptions);
      }
export type UpdateUserSetEnableAnswerCreatedNotificationsMutationHookResult = ReturnType<typeof useUpdateUserSetEnableAnswerCreatedNotificationsMutation>;
export type UpdateUserSetEnableAnswerCreatedNotificationsMutationResult = Apollo.MutationResult<UpdateUserSetEnableAnswerCreatedNotificationsMutation>;
export type UpdateUserSetEnableAnswerCreatedNotificationsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetEnableAnswerCreatedNotificationsMutation, UpdateUserSetEnableAnswerCreatedNotificationsMutationVariables>;
export const UpdateUserSetEnableQuestionExpirationNotificationsDocument = gql`
    mutation UpdateUserSetEnableQuestionExpirationNotifications($enableQuestionExpirationNotifications: Boolean!) {
  UpdateUser(input: {actions: [{setEnableQuestionExpirationNotifications: {enable: $enableQuestionExpirationNotifications}}]}) {
    questionExpirationReminderEnabled
  }
}
    `;
export type UpdateUserSetEnableQuestionExpirationNotificationsMutationFn = Apollo.MutationFunction<UpdateUserSetEnableQuestionExpirationNotificationsMutation, UpdateUserSetEnableQuestionExpirationNotificationsMutationVariables>;

/**
 * __useUpdateUserSetEnableQuestionExpirationNotificationsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetEnableQuestionExpirationNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetEnableQuestionExpirationNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetEnableQuestionExpirationNotificationsMutation, { data, loading, error }] = useUpdateUserSetEnableQuestionExpirationNotificationsMutation({
 *   variables: {
 *      enableQuestionExpirationNotifications: // value for 'enableQuestionExpirationNotifications'
 *   },
 * });
 */
export function useUpdateUserSetEnableQuestionExpirationNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetEnableQuestionExpirationNotificationsMutation, UpdateUserSetEnableQuestionExpirationNotificationsMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetEnableQuestionExpirationNotificationsMutation, UpdateUserSetEnableQuestionExpirationNotificationsMutationVariables>(UpdateUserSetEnableQuestionExpirationNotificationsDocument, baseOptions);
      }
export type UpdateUserSetEnableQuestionExpirationNotificationsMutationHookResult = ReturnType<typeof useUpdateUserSetEnableQuestionExpirationNotificationsMutation>;
export type UpdateUserSetEnableQuestionExpirationNotificationsMutationResult = Apollo.MutationResult<UpdateUserSetEnableQuestionExpirationNotificationsMutation>;
export type UpdateUserSetEnableQuestionExpirationNotificationsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetEnableQuestionExpirationNotificationsMutation, UpdateUserSetEnableQuestionExpirationNotificationsMutationVariables>;
export const UpdateUserSetSavePaymentMethodDocument = gql`
    mutation UpdateUserSetSavePaymentMethod($savePaymentMethod: Boolean!, $paymentMethodId: String!) {
  UpdateUser(input: {actions: [{setSavePaymentMethod: {savePaymentMethod: $savePaymentMethod, paymentMethodId: $paymentMethodId}}]}) {
    id
  }
}
    `;
export type UpdateUserSetSavePaymentMethodMutationFn = Apollo.MutationFunction<UpdateUserSetSavePaymentMethodMutation, UpdateUserSetSavePaymentMethodMutationVariables>;

/**
 * __useUpdateUserSetSavePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetSavePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetSavePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetSavePaymentMethodMutation, { data, loading, error }] = useUpdateUserSetSavePaymentMethodMutation({
 *   variables: {
 *      savePaymentMethod: // value for 'savePaymentMethod'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useUpdateUserSetSavePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetSavePaymentMethodMutation, UpdateUserSetSavePaymentMethodMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetSavePaymentMethodMutation, UpdateUserSetSavePaymentMethodMutationVariables>(UpdateUserSetSavePaymentMethodDocument, baseOptions);
      }
export type UpdateUserSetSavePaymentMethodMutationHookResult = ReturnType<typeof useUpdateUserSetSavePaymentMethodMutation>;
export type UpdateUserSetSavePaymentMethodMutationResult = Apollo.MutationResult<UpdateUserSetSavePaymentMethodMutation>;
export type UpdateUserSetSavePaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetSavePaymentMethodMutation, UpdateUserSetSavePaymentMethodMutationVariables>;
export const UpdateUserActionSetTimezoneDocument = gql`
    mutation UpdateUserActionSetTimezone($timezone: Timezone!) {
  UpdateUser(input: {actions: [{setTimezone: {timezone: $timezone}}]}) {
    id
  }
}
    `;
export type UpdateUserActionSetTimezoneMutationFn = Apollo.MutationFunction<UpdateUserActionSetTimezoneMutation, UpdateUserActionSetTimezoneMutationVariables>;

/**
 * __useUpdateUserActionSetTimezoneMutation__
 *
 * To run a mutation, you first call `useUpdateUserActionSetTimezoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserActionSetTimezoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserActionSetTimezoneMutation, { data, loading, error }] = useUpdateUserActionSetTimezoneMutation({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useUpdateUserActionSetTimezoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserActionSetTimezoneMutation, UpdateUserActionSetTimezoneMutationVariables>) {
        return Apollo.useMutation<UpdateUserActionSetTimezoneMutation, UpdateUserActionSetTimezoneMutationVariables>(UpdateUserActionSetTimezoneDocument, baseOptions);
      }
export type UpdateUserActionSetTimezoneMutationHookResult = ReturnType<typeof useUpdateUserActionSetTimezoneMutation>;
export type UpdateUserActionSetTimezoneMutationResult = Apollo.MutationResult<UpdateUserActionSetTimezoneMutation>;
export type UpdateUserActionSetTimezoneMutationOptions = Apollo.BaseMutationOptions<UpdateUserActionSetTimezoneMutation, UpdateUserActionSetTimezoneMutationVariables>;
export const UpdateUserSetTransferBalanceDocument = gql`
    mutation UpdateUserSetTransferBalance {
  UpdateUser(input: {actions: [{setTransferBalance: {transferBalance: true}}]}) {
    id
  }
}
    `;
export type UpdateUserSetTransferBalanceMutationFn = Apollo.MutationFunction<UpdateUserSetTransferBalanceMutation, UpdateUserSetTransferBalanceMutationVariables>;

/**
 * __useUpdateUserSetTransferBalanceMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetTransferBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetTransferBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetTransferBalanceMutation, { data, loading, error }] = useUpdateUserSetTransferBalanceMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateUserSetTransferBalanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetTransferBalanceMutation, UpdateUserSetTransferBalanceMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetTransferBalanceMutation, UpdateUserSetTransferBalanceMutationVariables>(UpdateUserSetTransferBalanceDocument, baseOptions);
      }
export type UpdateUserSetTransferBalanceMutationHookResult = ReturnType<typeof useUpdateUserSetTransferBalanceMutation>;
export type UpdateUserSetTransferBalanceMutationResult = Apollo.MutationResult<UpdateUserSetTransferBalanceMutation>;
export type UpdateUserSetTransferBalanceMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetTransferBalanceMutation, UpdateUserSetTransferBalanceMutationVariables>;
export const UpdateUserSetReceivePromotionalEmailUpdatesDocument = gql`
    mutation UpdateUserSetReceivePromotionalEmailUpdates($receivePromotionalEmailUpdates: Boolean!) {
  UpdateUser(input: {actions: [{setReceivePromotionalEmailUpdates: {receivePromotionalEmailUpdates: $receivePromotionalEmailUpdates}}]}) {
    receivePromotionalEmailUpdates
  }
}
    `;
export type UpdateUserSetReceivePromotionalEmailUpdatesMutationFn = Apollo.MutationFunction<UpdateUserSetReceivePromotionalEmailUpdatesMutation, UpdateUserSetReceivePromotionalEmailUpdatesMutationVariables>;

/**
 * __useUpdateUserSetReceivePromotionalEmailUpdatesMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetReceivePromotionalEmailUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetReceivePromotionalEmailUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetReceivePromotionalEmailUpdatesMutation, { data, loading, error }] = useUpdateUserSetReceivePromotionalEmailUpdatesMutation({
 *   variables: {
 *      receivePromotionalEmailUpdates: // value for 'receivePromotionalEmailUpdates'
 *   },
 * });
 */
export function useUpdateUserSetReceivePromotionalEmailUpdatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetReceivePromotionalEmailUpdatesMutation, UpdateUserSetReceivePromotionalEmailUpdatesMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetReceivePromotionalEmailUpdatesMutation, UpdateUserSetReceivePromotionalEmailUpdatesMutationVariables>(UpdateUserSetReceivePromotionalEmailUpdatesDocument, baseOptions);
      }
export type UpdateUserSetReceivePromotionalEmailUpdatesMutationHookResult = ReturnType<typeof useUpdateUserSetReceivePromotionalEmailUpdatesMutation>;
export type UpdateUserSetReceivePromotionalEmailUpdatesMutationResult = Apollo.MutationResult<UpdateUserSetReceivePromotionalEmailUpdatesMutation>;
export type UpdateUserSetReceivePromotionalEmailUpdatesMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetReceivePromotionalEmailUpdatesMutation, UpdateUserSetReceivePromotionalEmailUpdatesMutationVariables>;
export const UpdateUserSetPasswordDocument = gql`
    mutation UpdateUserSetPassword($password: String!) {
  UpdateUser(input: {actions: [{setPassword: {password: $password}}]}) {
    email
  }
}
    `;
export type UpdateUserSetPasswordMutationFn = Apollo.MutationFunction<UpdateUserSetPasswordMutation, UpdateUserSetPasswordMutationVariables>;

/**
 * __useUpdateUserSetPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetPasswordMutation, { data, loading, error }] = useUpdateUserSetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUpdateUserSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetPasswordMutation, UpdateUserSetPasswordMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetPasswordMutation, UpdateUserSetPasswordMutationVariables>(UpdateUserSetPasswordDocument, baseOptions);
      }
export type UpdateUserSetPasswordMutationHookResult = ReturnType<typeof useUpdateUserSetPasswordMutation>;
export type UpdateUserSetPasswordMutationResult = Apollo.MutationResult<UpdateUserSetPasswordMutation>;
export type UpdateUserSetPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetPasswordMutation, UpdateUserSetPasswordMutationVariables>;
export const UpdateUserSetUnlinkYouTubeDocument = gql`
    mutation UpdateUserSetUnlinkYouTube {
  UpdateUser(input: {actions: [{setUnlinkYouTube: {isYouTubeUnlinked: true}}]}) {
    id
  }
}
    `;
export type UpdateUserSetUnlinkYouTubeMutationFn = Apollo.MutationFunction<UpdateUserSetUnlinkYouTubeMutation, UpdateUserSetUnlinkYouTubeMutationVariables>;

/**
 * __useUpdateUserSetUnlinkYouTubeMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetUnlinkYouTubeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetUnlinkYouTubeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetUnlinkYouTubeMutation, { data, loading, error }] = useUpdateUserSetUnlinkYouTubeMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateUserSetUnlinkYouTubeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetUnlinkYouTubeMutation, UpdateUserSetUnlinkYouTubeMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetUnlinkYouTubeMutation, UpdateUserSetUnlinkYouTubeMutationVariables>(UpdateUserSetUnlinkYouTubeDocument, baseOptions);
      }
export type UpdateUserSetUnlinkYouTubeMutationHookResult = ReturnType<typeof useUpdateUserSetUnlinkYouTubeMutation>;
export type UpdateUserSetUnlinkYouTubeMutationResult = Apollo.MutationResult<UpdateUserSetUnlinkYouTubeMutation>;
export type UpdateUserSetUnlinkYouTubeMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetUnlinkYouTubeMutation, UpdateUserSetUnlinkYouTubeMutationVariables>;
export const UpdateUserSetManagerDocument = gql`
    mutation UpdateUserSetManager {
  UpdateUser(input: {actions: [{setManager: {isManager: true}}]}) {
    id
  }
}
    `;
export type UpdateUserSetManagerMutationFn = Apollo.MutationFunction<UpdateUserSetManagerMutation, UpdateUserSetManagerMutationVariables>;

/**
 * __useUpdateUserSetManagerMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetManagerMutation, { data, loading, error }] = useUpdateUserSetManagerMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateUserSetManagerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetManagerMutation, UpdateUserSetManagerMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetManagerMutation, UpdateUserSetManagerMutationVariables>(UpdateUserSetManagerDocument, baseOptions);
      }
export type UpdateUserSetManagerMutationHookResult = ReturnType<typeof useUpdateUserSetManagerMutation>;
export type UpdateUserSetManagerMutationResult = Apollo.MutationResult<UpdateUserSetManagerMutation>;
export type UpdateUserSetManagerMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetManagerMutation, UpdateUserSetManagerMutationVariables>;
export const UpdateUserSetUnlinkRedditDocument = gql`
    mutation UpdateUserSetUnlinkReddit {
  UpdateUser(input: {actions: [{setUnlinkReddit: {isRedditUnlinked: true}}]}) {
    id
  }
}
    `;
export type UpdateUserSetUnlinkRedditMutationFn = Apollo.MutationFunction<UpdateUserSetUnlinkRedditMutation, UpdateUserSetUnlinkRedditMutationVariables>;

/**
 * __useUpdateUserSetUnlinkRedditMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetUnlinkRedditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetUnlinkRedditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetUnlinkRedditMutation, { data, loading, error }] = useUpdateUserSetUnlinkRedditMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateUserSetUnlinkRedditMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetUnlinkRedditMutation, UpdateUserSetUnlinkRedditMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetUnlinkRedditMutation, UpdateUserSetUnlinkRedditMutationVariables>(UpdateUserSetUnlinkRedditDocument, baseOptions);
      }
export type UpdateUserSetUnlinkRedditMutationHookResult = ReturnType<typeof useUpdateUserSetUnlinkRedditMutation>;
export type UpdateUserSetUnlinkRedditMutationResult = Apollo.MutationResult<UpdateUserSetUnlinkRedditMutation>;
export type UpdateUserSetUnlinkRedditMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetUnlinkRedditMutation, UpdateUserSetUnlinkRedditMutationVariables>;
export const UpdateUserSetFavoriteUsersDocument = gql`
    mutation UpdateUserSetFavoriteUsers($userIds: [String!]!) {
  UpdateUser(input: {actions: [{setFavoriteUsers: {userIds: $userIds}}]}) {
    favoriteUserIds
  }
}
    `;
export type UpdateUserSetFavoriteUsersMutationFn = Apollo.MutationFunction<UpdateUserSetFavoriteUsersMutation, UpdateUserSetFavoriteUsersMutationVariables>;

/**
 * __useUpdateUserSetFavoriteUsersMutation__
 *
 * To run a mutation, you first call `useUpdateUserSetFavoriteUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSetFavoriteUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSetFavoriteUsersMutation, { data, loading, error }] = useUpdateUserSetFavoriteUsersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useUpdateUserSetFavoriteUsersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSetFavoriteUsersMutation, UpdateUserSetFavoriteUsersMutationVariables>) {
        return Apollo.useMutation<UpdateUserSetFavoriteUsersMutation, UpdateUserSetFavoriteUsersMutationVariables>(UpdateUserSetFavoriteUsersDocument, baseOptions);
      }
export type UpdateUserSetFavoriteUsersMutationHookResult = ReturnType<typeof useUpdateUserSetFavoriteUsersMutation>;
export type UpdateUserSetFavoriteUsersMutationResult = Apollo.MutationResult<UpdateUserSetFavoriteUsersMutation>;
export type UpdateUserSetFavoriteUsersMutationOptions = Apollo.BaseMutationOptions<UpdateUserSetFavoriteUsersMutation, UpdateUserSetFavoriteUsersMutationVariables>;
export const UpdateManagerAddArtistDocument = gql`
    mutation UpdateManagerAddArtist($artistUsername: String!) {
  UpdateManager(input: {actions: [{addArtist: {artistUsername: $artistUsername}}]}) {
    managerId
    createdAt
    artists {
      ...UserOnGetUserFragment
    }
  }
}
    ${UserOnGetUserFragmentFragmentDoc}`;
export type UpdateManagerAddArtistMutationFn = Apollo.MutationFunction<UpdateManagerAddArtistMutation, UpdateManagerAddArtistMutationVariables>;

/**
 * __useUpdateManagerAddArtistMutation__
 *
 * To run a mutation, you first call `useUpdateManagerAddArtistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManagerAddArtistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManagerAddArtistMutation, { data, loading, error }] = useUpdateManagerAddArtistMutation({
 *   variables: {
 *      artistUsername: // value for 'artistUsername'
 *   },
 * });
 */
export function useUpdateManagerAddArtistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManagerAddArtistMutation, UpdateManagerAddArtistMutationVariables>) {
        return Apollo.useMutation<UpdateManagerAddArtistMutation, UpdateManagerAddArtistMutationVariables>(UpdateManagerAddArtistDocument, baseOptions);
      }
export type UpdateManagerAddArtistMutationHookResult = ReturnType<typeof useUpdateManagerAddArtistMutation>;
export type UpdateManagerAddArtistMutationResult = Apollo.MutationResult<UpdateManagerAddArtistMutation>;
export type UpdateManagerAddArtistMutationOptions = Apollo.BaseMutationOptions<UpdateManagerAddArtistMutation, UpdateManagerAddArtistMutationVariables>;
export const UpdateManagerUpdateManagerTokenDocument = gql`
    mutation UpdateManagerUpdateManagerToken($artistUsername: String!) {
  UpdateManager(input: {actions: [{updateManagerToken: {artistUsername: $artistUsername}}]}) {
    managerId
    createdAt
    artists {
      ...UserOnGetUserFragment
    }
  }
}
    ${UserOnGetUserFragmentFragmentDoc}`;
export type UpdateManagerUpdateManagerTokenMutationFn = Apollo.MutationFunction<UpdateManagerUpdateManagerTokenMutation, UpdateManagerUpdateManagerTokenMutationVariables>;

/**
 * __useUpdateManagerUpdateManagerTokenMutation__
 *
 * To run a mutation, you first call `useUpdateManagerUpdateManagerTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManagerUpdateManagerTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManagerUpdateManagerTokenMutation, { data, loading, error }] = useUpdateManagerUpdateManagerTokenMutation({
 *   variables: {
 *      artistUsername: // value for 'artistUsername'
 *   },
 * });
 */
export function useUpdateManagerUpdateManagerTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManagerUpdateManagerTokenMutation, UpdateManagerUpdateManagerTokenMutationVariables>) {
        return Apollo.useMutation<UpdateManagerUpdateManagerTokenMutation, UpdateManagerUpdateManagerTokenMutationVariables>(UpdateManagerUpdateManagerTokenDocument, baseOptions);
      }
export type UpdateManagerUpdateManagerTokenMutationHookResult = ReturnType<typeof useUpdateManagerUpdateManagerTokenMutation>;
export type UpdateManagerUpdateManagerTokenMutationResult = Apollo.MutationResult<UpdateManagerUpdateManagerTokenMutation>;
export type UpdateManagerUpdateManagerTokenMutationOptions = Apollo.BaseMutationOptions<UpdateManagerUpdateManagerTokenMutation, UpdateManagerUpdateManagerTokenMutationVariables>;
export const UpdateUserVerifyEmailActionSendEmailVerificationDocument = gql`
    mutation UpdateUserVerifyEmailActionSendEmailVerification($email: String!) {
  VerifyEmail(input: {actions: [{sendEmailVerification: {email: $email}}]})
}
    `;
export type UpdateUserVerifyEmailActionSendEmailVerificationMutationFn = Apollo.MutationFunction<UpdateUserVerifyEmailActionSendEmailVerificationMutation, UpdateUserVerifyEmailActionSendEmailVerificationMutationVariables>;

/**
 * __useUpdateUserVerifyEmailActionSendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useUpdateUserVerifyEmailActionSendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserVerifyEmailActionSendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserVerifyEmailActionSendEmailVerificationMutation, { data, loading, error }] = useUpdateUserVerifyEmailActionSendEmailVerificationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateUserVerifyEmailActionSendEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserVerifyEmailActionSendEmailVerificationMutation, UpdateUserVerifyEmailActionSendEmailVerificationMutationVariables>) {
        return Apollo.useMutation<UpdateUserVerifyEmailActionSendEmailVerificationMutation, UpdateUserVerifyEmailActionSendEmailVerificationMutationVariables>(UpdateUserVerifyEmailActionSendEmailVerificationDocument, baseOptions);
      }
export type UpdateUserVerifyEmailActionSendEmailVerificationMutationHookResult = ReturnType<typeof useUpdateUserVerifyEmailActionSendEmailVerificationMutation>;
export type UpdateUserVerifyEmailActionSendEmailVerificationMutationResult = Apollo.MutationResult<UpdateUserVerifyEmailActionSendEmailVerificationMutation>;
export type UpdateUserVerifyEmailActionSendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<UpdateUserVerifyEmailActionSendEmailVerificationMutation, UpdateUserVerifyEmailActionSendEmailVerificationMutationVariables>;
export const UpdateUserVerifyEmailActionVerifyEmailDocument = gql`
    mutation UpdateUserVerifyEmailActionVerifyEmail($email: String!, $verificationToken: String!) {
  VerifyEmail(input: {actions: [{verifyEmail: {email: $email, verificationToken: $verificationToken}}]})
}
    `;
export type UpdateUserVerifyEmailActionVerifyEmailMutationFn = Apollo.MutationFunction<UpdateUserVerifyEmailActionVerifyEmailMutation, UpdateUserVerifyEmailActionVerifyEmailMutationVariables>;

/**
 * __useUpdateUserVerifyEmailActionVerifyEmailMutation__
 *
 * To run a mutation, you first call `useUpdateUserVerifyEmailActionVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserVerifyEmailActionVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserVerifyEmailActionVerifyEmailMutation, { data, loading, error }] = useUpdateUserVerifyEmailActionVerifyEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      verificationToken: // value for 'verificationToken'
 *   },
 * });
 */
export function useUpdateUserVerifyEmailActionVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserVerifyEmailActionVerifyEmailMutation, UpdateUserVerifyEmailActionVerifyEmailMutationVariables>) {
        return Apollo.useMutation<UpdateUserVerifyEmailActionVerifyEmailMutation, UpdateUserVerifyEmailActionVerifyEmailMutationVariables>(UpdateUserVerifyEmailActionVerifyEmailDocument, baseOptions);
      }
export type UpdateUserVerifyEmailActionVerifyEmailMutationHookResult = ReturnType<typeof useUpdateUserVerifyEmailActionVerifyEmailMutation>;
export type UpdateUserVerifyEmailActionVerifyEmailMutationResult = Apollo.MutationResult<UpdateUserVerifyEmailActionVerifyEmailMutation>;
export type UpdateUserVerifyEmailActionVerifyEmailMutationOptions = Apollo.BaseMutationOptions<UpdateUserVerifyEmailActionVerifyEmailMutation, UpdateUserVerifyEmailActionVerifyEmailMutationVariables>;
export const UpdateUserVerifyPhoneActionSendPhoneVerificationDocument = gql`
    mutation UpdateUserVerifyPhoneActionSendPhoneVerification($phoneCountryCode: Int!, $phoneNumber: String!) {
  VerifyPhone(input: {actions: [{sendPhoneVerification: {phoneCountryCode: $phoneCountryCode, phoneNumber: $phoneNumber}}]})
}
    `;
export type UpdateUserVerifyPhoneActionSendPhoneVerificationMutationFn = Apollo.MutationFunction<UpdateUserVerifyPhoneActionSendPhoneVerificationMutation, UpdateUserVerifyPhoneActionSendPhoneVerificationMutationVariables>;

/**
 * __useUpdateUserVerifyPhoneActionSendPhoneVerificationMutation__
 *
 * To run a mutation, you first call `useUpdateUserVerifyPhoneActionSendPhoneVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserVerifyPhoneActionSendPhoneVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserVerifyPhoneActionSendPhoneVerificationMutation, { data, loading, error }] = useUpdateUserVerifyPhoneActionSendPhoneVerificationMutation({
 *   variables: {
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateUserVerifyPhoneActionSendPhoneVerificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserVerifyPhoneActionSendPhoneVerificationMutation, UpdateUserVerifyPhoneActionSendPhoneVerificationMutationVariables>) {
        return Apollo.useMutation<UpdateUserVerifyPhoneActionSendPhoneVerificationMutation, UpdateUserVerifyPhoneActionSendPhoneVerificationMutationVariables>(UpdateUserVerifyPhoneActionSendPhoneVerificationDocument, baseOptions);
      }
export type UpdateUserVerifyPhoneActionSendPhoneVerificationMutationHookResult = ReturnType<typeof useUpdateUserVerifyPhoneActionSendPhoneVerificationMutation>;
export type UpdateUserVerifyPhoneActionSendPhoneVerificationMutationResult = Apollo.MutationResult<UpdateUserVerifyPhoneActionSendPhoneVerificationMutation>;
export type UpdateUserVerifyPhoneActionSendPhoneVerificationMutationOptions = Apollo.BaseMutationOptions<UpdateUserVerifyPhoneActionSendPhoneVerificationMutation, UpdateUserVerifyPhoneActionSendPhoneVerificationMutationVariables>;
export const UpdateUserVerifyPhoneActionVerifyPhoneDocument = gql`
    mutation UpdateUserVerifyPhoneActionVerifyPhone($phoneCountryCode: Int!, $phoneNumber: String!, $verificationToken: String!) {
  VerifyPhone(input: {actions: [{verifyPhone: {phoneCountryCode: $phoneCountryCode, phoneNumber: $phoneNumber, verificationToken: $verificationToken}}]})
}
    `;
export type UpdateUserVerifyPhoneActionVerifyPhoneMutationFn = Apollo.MutationFunction<UpdateUserVerifyPhoneActionVerifyPhoneMutation, UpdateUserVerifyPhoneActionVerifyPhoneMutationVariables>;

/**
 * __useUpdateUserVerifyPhoneActionVerifyPhoneMutation__
 *
 * To run a mutation, you first call `useUpdateUserVerifyPhoneActionVerifyPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserVerifyPhoneActionVerifyPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserVerifyPhoneActionVerifyPhoneMutation, { data, loading, error }] = useUpdateUserVerifyPhoneActionVerifyPhoneMutation({
 *   variables: {
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *      phoneNumber: // value for 'phoneNumber'
 *      verificationToken: // value for 'verificationToken'
 *   },
 * });
 */
export function useUpdateUserVerifyPhoneActionVerifyPhoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserVerifyPhoneActionVerifyPhoneMutation, UpdateUserVerifyPhoneActionVerifyPhoneMutationVariables>) {
        return Apollo.useMutation<UpdateUserVerifyPhoneActionVerifyPhoneMutation, UpdateUserVerifyPhoneActionVerifyPhoneMutationVariables>(UpdateUserVerifyPhoneActionVerifyPhoneDocument, baseOptions);
      }
export type UpdateUserVerifyPhoneActionVerifyPhoneMutationHookResult = ReturnType<typeof useUpdateUserVerifyPhoneActionVerifyPhoneMutation>;
export type UpdateUserVerifyPhoneActionVerifyPhoneMutationResult = Apollo.MutationResult<UpdateUserVerifyPhoneActionVerifyPhoneMutation>;
export type UpdateUserVerifyPhoneActionVerifyPhoneMutationOptions = Apollo.BaseMutationOptions<UpdateUserVerifyPhoneActionVerifyPhoneMutation, UpdateUserVerifyPhoneActionVerifyPhoneMutationVariables>;
export const GetYouTubeMediaDetailsDocument = gql`
    query GetYouTubeMediaDetails($mediaUrl: String!) {
  YouTubeMediaDetails(mediaUrl: $mediaUrl) {
    isValid
    error
    title
    thumbnail
    mediaUrl
  }
}
    `;

/**
 * __useGetYouTubeMediaDetailsQuery__
 *
 * To run a query within a React component, call `useGetYouTubeMediaDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYouTubeMediaDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYouTubeMediaDetailsQuery({
 *   variables: {
 *      mediaUrl: // value for 'mediaUrl'
 *   },
 * });
 */
export function useGetYouTubeMediaDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetYouTubeMediaDetailsQuery, GetYouTubeMediaDetailsQueryVariables>) {
        return Apollo.useQuery<GetYouTubeMediaDetailsQuery, GetYouTubeMediaDetailsQueryVariables>(GetYouTubeMediaDetailsDocument, baseOptions);
      }
export function useGetYouTubeMediaDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYouTubeMediaDetailsQuery, GetYouTubeMediaDetailsQueryVariables>) {
          return Apollo.useLazyQuery<GetYouTubeMediaDetailsQuery, GetYouTubeMediaDetailsQueryVariables>(GetYouTubeMediaDetailsDocument, baseOptions);
        }
export type GetYouTubeMediaDetailsQueryHookResult = ReturnType<typeof useGetYouTubeMediaDetailsQuery>;
export type GetYouTubeMediaDetailsLazyQueryHookResult = ReturnType<typeof useGetYouTubeMediaDetailsLazyQuery>;
export type GetYouTubeMediaDetailsQueryResult = Apollo.QueryResult<GetYouTubeMediaDetailsQuery, GetYouTubeMediaDetailsQueryVariables>;
export const CreateYouTubeCrawlJobDocument = gql`
    mutation CreateYouTubeCrawlJob($mediaUrls: [String!]!, $uploadChannel: Boolean!) {
  CreateYouTubeCrawlJob(input: {mediaUrls: $mediaUrls, uploadChannel: $uploadChannel}) {
    jobs {
      name
      status
      videoId
      schedule
      expiresAt
      createdAt
    }
    channelCrawlJob {
      name
      status
      schedule
      createdAt
    }
    success
    error
  }
}
    `;
export type CreateYouTubeCrawlJobMutationFn = Apollo.MutationFunction<CreateYouTubeCrawlJobMutation, CreateYouTubeCrawlJobMutationVariables>;

/**
 * __useCreateYouTubeCrawlJobMutation__
 *
 * To run a mutation, you first call `useCreateYouTubeCrawlJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateYouTubeCrawlJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createYouTubeCrawlJobMutation, { data, loading, error }] = useCreateYouTubeCrawlJobMutation({
 *   variables: {
 *      mediaUrls: // value for 'mediaUrls'
 *      uploadChannel: // value for 'uploadChannel'
 *   },
 * });
 */
export function useCreateYouTubeCrawlJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateYouTubeCrawlJobMutation, CreateYouTubeCrawlJobMutationVariables>) {
        return Apollo.useMutation<CreateYouTubeCrawlJobMutation, CreateYouTubeCrawlJobMutationVariables>(CreateYouTubeCrawlJobDocument, baseOptions);
      }
export type CreateYouTubeCrawlJobMutationHookResult = ReturnType<typeof useCreateYouTubeCrawlJobMutation>;
export type CreateYouTubeCrawlJobMutationResult = Apollo.MutationResult<CreateYouTubeCrawlJobMutation>;
export type CreateYouTubeCrawlJobMutationOptions = Apollo.BaseMutationOptions<CreateYouTubeCrawlJobMutation, CreateYouTubeCrawlJobMutationVariables>;
export const AuthenticateGoogleCallbackDocument = gql`
    mutation AuthenticateGoogleCallback($code: String!) {
  AuthenticateGoogleCallback(code: $code)
}
    `;
export type AuthenticateGoogleCallbackMutationFn = Apollo.MutationFunction<AuthenticateGoogleCallbackMutation, AuthenticateGoogleCallbackMutationVariables>;

/**
 * __useAuthenticateGoogleCallbackMutation__
 *
 * To run a mutation, you first call `useAuthenticateGoogleCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateGoogleCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateGoogleCallbackMutation, { data, loading, error }] = useAuthenticateGoogleCallbackMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAuthenticateGoogleCallbackMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateGoogleCallbackMutation, AuthenticateGoogleCallbackMutationVariables>) {
        return Apollo.useMutation<AuthenticateGoogleCallbackMutation, AuthenticateGoogleCallbackMutationVariables>(AuthenticateGoogleCallbackDocument, baseOptions);
      }
export type AuthenticateGoogleCallbackMutationHookResult = ReturnType<typeof useAuthenticateGoogleCallbackMutation>;
export type AuthenticateGoogleCallbackMutationResult = Apollo.MutationResult<AuthenticateGoogleCallbackMutation>;
export type AuthenticateGoogleCallbackMutationOptions = Apollo.BaseMutationOptions<AuthenticateGoogleCallbackMutation, AuthenticateGoogleCallbackMutationVariables>;
export const ValidateGoogleAccessTokenDocument = gql`
    mutation ValidateGoogleAccessToken {
  ValidateGoogleAccessToken
}
    `;
export type ValidateGoogleAccessTokenMutationFn = Apollo.MutationFunction<ValidateGoogleAccessTokenMutation, ValidateGoogleAccessTokenMutationVariables>;

/**
 * __useValidateGoogleAccessTokenMutation__
 *
 * To run a mutation, you first call `useValidateGoogleAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateGoogleAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateGoogleAccessTokenMutation, { data, loading, error }] = useValidateGoogleAccessTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useValidateGoogleAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidateGoogleAccessTokenMutation, ValidateGoogleAccessTokenMutationVariables>) {
        return Apollo.useMutation<ValidateGoogleAccessTokenMutation, ValidateGoogleAccessTokenMutationVariables>(ValidateGoogleAccessTokenDocument, baseOptions);
      }
export type ValidateGoogleAccessTokenMutationHookResult = ReturnType<typeof useValidateGoogleAccessTokenMutation>;
export type ValidateGoogleAccessTokenMutationResult = Apollo.MutationResult<ValidateGoogleAccessTokenMutation>;
export type ValidateGoogleAccessTokenMutationOptions = Apollo.BaseMutationOptions<ValidateGoogleAccessTokenMutation, ValidateGoogleAccessTokenMutationVariables>;
export const StopCrawlYouTubeMediaDocument = gql`
    mutation StopCrawlYouTubeMedia($name: String!) {
  StopCrawlYouTubeMedia(input: {name: $name})
}
    `;
export type StopCrawlYouTubeMediaMutationFn = Apollo.MutationFunction<StopCrawlYouTubeMediaMutation, StopCrawlYouTubeMediaMutationVariables>;

/**
 * __useStopCrawlYouTubeMediaMutation__
 *
 * To run a mutation, you first call `useStopCrawlYouTubeMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopCrawlYouTubeMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopCrawlYouTubeMediaMutation, { data, loading, error }] = useStopCrawlYouTubeMediaMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useStopCrawlYouTubeMediaMutation(baseOptions?: Apollo.MutationHookOptions<StopCrawlYouTubeMediaMutation, StopCrawlYouTubeMediaMutationVariables>) {
        return Apollo.useMutation<StopCrawlYouTubeMediaMutation, StopCrawlYouTubeMediaMutationVariables>(StopCrawlYouTubeMediaDocument, baseOptions);
      }
export type StopCrawlYouTubeMediaMutationHookResult = ReturnType<typeof useStopCrawlYouTubeMediaMutation>;
export type StopCrawlYouTubeMediaMutationResult = Apollo.MutationResult<StopCrawlYouTubeMediaMutation>;
export type StopCrawlYouTubeMediaMutationOptions = Apollo.BaseMutationOptions<StopCrawlYouTubeMediaMutation, StopCrawlYouTubeMediaMutationVariables>;
export const GetActivitiesDocument = gql`
    query GetActivities {
  Activities {
    newActivities {
      ...ActivityDetail
    }
    oldActivities {
      ...ActivityDetail
    }
  }
}
    ${ActivityDetailFragmentDoc}`;

/**
 * __useGetActivitiesQuery__
 *
 * To run a query within a React component, call `useGetActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
        return Apollo.useQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, baseOptions);
      }
export function useGetActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
          return Apollo.useLazyQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, baseOptions);
        }
export type GetActivitiesQueryHookResult = ReturnType<typeof useGetActivitiesQuery>;
export type GetActivitiesLazyQueryHookResult = ReturnType<typeof useGetActivitiesLazyQuery>;
export type GetActivitiesQueryResult = Apollo.QueryResult<GetActivitiesQuery, GetActivitiesQueryVariables>;
export const GetSentimentAnalysisDocument = gql`
    query GetSentimentAnalysis($days: Int!) {
  sentiments(days: $days) {
    range
    positive
    neutral
    negative
  }
}
    `;

/**
 * __useGetSentimentAnalysisQuery__
 *
 * To run a query within a React component, call `useGetSentimentAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSentimentAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSentimentAnalysisQuery({
 *   variables: {
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetSentimentAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetSentimentAnalysisQuery, GetSentimentAnalysisQueryVariables>) {
        return Apollo.useQuery<GetSentimentAnalysisQuery, GetSentimentAnalysisQueryVariables>(GetSentimentAnalysisDocument, baseOptions);
      }
export function useGetSentimentAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSentimentAnalysisQuery, GetSentimentAnalysisQueryVariables>) {
          return Apollo.useLazyQuery<GetSentimentAnalysisQuery, GetSentimentAnalysisQueryVariables>(GetSentimentAnalysisDocument, baseOptions);
        }
export type GetSentimentAnalysisQueryHookResult = ReturnType<typeof useGetSentimentAnalysisQuery>;
export type GetSentimentAnalysisLazyQueryHookResult = ReturnType<typeof useGetSentimentAnalysisLazyQuery>;
export type GetSentimentAnalysisQueryResult = Apollo.QueryResult<GetSentimentAnalysisQuery, GetSentimentAnalysisQueryVariables>;
export const GetManagerSentimentAnalysisDocument = gql`
    query GetManagerSentimentAnalysis($days: Int!, $artistId: String) {
  managerSentiments(days: $days, artistId: $artistId) {
    range
    positive
    neutral
    negative
  }
}
    `;

/**
 * __useGetManagerSentimentAnalysisQuery__
 *
 * To run a query within a React component, call `useGetManagerSentimentAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerSentimentAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerSentimentAnalysisQuery({
 *   variables: {
 *      days: // value for 'days'
 *      artistId: // value for 'artistId'
 *   },
 * });
 */
export function useGetManagerSentimentAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetManagerSentimentAnalysisQuery, GetManagerSentimentAnalysisQueryVariables>) {
        return Apollo.useQuery<GetManagerSentimentAnalysisQuery, GetManagerSentimentAnalysisQueryVariables>(GetManagerSentimentAnalysisDocument, baseOptions);
      }
export function useGetManagerSentimentAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerSentimentAnalysisQuery, GetManagerSentimentAnalysisQueryVariables>) {
          return Apollo.useLazyQuery<GetManagerSentimentAnalysisQuery, GetManagerSentimentAnalysisQueryVariables>(GetManagerSentimentAnalysisDocument, baseOptions);
        }
export type GetManagerSentimentAnalysisQueryHookResult = ReturnType<typeof useGetManagerSentimentAnalysisQuery>;
export type GetManagerSentimentAnalysisLazyQueryHookResult = ReturnType<typeof useGetManagerSentimentAnalysisLazyQuery>;
export type GetManagerSentimentAnalysisQueryResult = Apollo.QueryResult<GetManagerSentimentAnalysisQuery, GetManagerSentimentAnalysisQueryVariables>;
export const GetManagerEngagementDocument = gql`
    query GetManagerEngagement($days: Int!, $artistId: String) {
  managerEngagement(days: $days, artistId: $artistId) {
    platform
    count
  }
}
    `;

/**
 * __useGetManagerEngagementQuery__
 *
 * To run a query within a React component, call `useGetManagerEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerEngagementQuery({
 *   variables: {
 *      days: // value for 'days'
 *      artistId: // value for 'artistId'
 *   },
 * });
 */
export function useGetManagerEngagementQuery(baseOptions: Apollo.QueryHookOptions<GetManagerEngagementQuery, GetManagerEngagementQueryVariables>) {
        return Apollo.useQuery<GetManagerEngagementQuery, GetManagerEngagementQueryVariables>(GetManagerEngagementDocument, baseOptions);
      }
export function useGetManagerEngagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerEngagementQuery, GetManagerEngagementQueryVariables>) {
          return Apollo.useLazyQuery<GetManagerEngagementQuery, GetManagerEngagementQueryVariables>(GetManagerEngagementDocument, baseOptions);
        }
export type GetManagerEngagementQueryHookResult = ReturnType<typeof useGetManagerEngagementQuery>;
export type GetManagerEngagementLazyQueryHookResult = ReturnType<typeof useGetManagerEngagementLazyQuery>;
export type GetManagerEngagementQueryResult = Apollo.QueryResult<GetManagerEngagementQuery, GetManagerEngagementQueryVariables>;
export const GetEngagementDocument = gql`
    query GetEngagement($days: Int!) {
  engagement(days: $days) {
    platform
    count
  }
}
    `;

/**
 * __useGetEngagementQuery__
 *
 * To run a query within a React component, call `useGetEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementQuery({
 *   variables: {
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetEngagementQuery(baseOptions: Apollo.QueryHookOptions<GetEngagementQuery, GetEngagementQueryVariables>) {
        return Apollo.useQuery<GetEngagementQuery, GetEngagementQueryVariables>(GetEngagementDocument, baseOptions);
      }
export function useGetEngagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEngagementQuery, GetEngagementQueryVariables>) {
          return Apollo.useLazyQuery<GetEngagementQuery, GetEngagementQueryVariables>(GetEngagementDocument, baseOptions);
        }
export type GetEngagementQueryHookResult = ReturnType<typeof useGetEngagementQuery>;
export type GetEngagementLazyQueryHookResult = ReturnType<typeof useGetEngagementLazyQuery>;
export type GetEngagementQueryResult = Apollo.QueryResult<GetEngagementQuery, GetEngagementQueryVariables>;
export const GetLanguagesDocument = gql`
    query GetLanguages($days: Int!) {
  languages(days: $days)
}
    `;

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetLanguagesQuery(baseOptions: Apollo.QueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
        return Apollo.useQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, baseOptions);
      }
export function useGetLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          return Apollo.useLazyQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, baseOptions);
        }
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesQueryResult = Apollo.QueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetManagerLanguagesDocument = gql`
    query GetManagerLanguages($days: Int!, $artistId: String) {
  managerLanguages(days: $days, artistId: $artistId)
}
    `;

/**
 * __useGetManagerLanguagesQuery__
 *
 * To run a query within a React component, call `useGetManagerLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerLanguagesQuery({
 *   variables: {
 *      days: // value for 'days'
 *      artistId: // value for 'artistId'
 *   },
 * });
 */
export function useGetManagerLanguagesQuery(baseOptions: Apollo.QueryHookOptions<GetManagerLanguagesQuery, GetManagerLanguagesQueryVariables>) {
        return Apollo.useQuery<GetManagerLanguagesQuery, GetManagerLanguagesQueryVariables>(GetManagerLanguagesDocument, baseOptions);
      }
export function useGetManagerLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerLanguagesQuery, GetManagerLanguagesQueryVariables>) {
          return Apollo.useLazyQuery<GetManagerLanguagesQuery, GetManagerLanguagesQueryVariables>(GetManagerLanguagesDocument, baseOptions);
        }
export type GetManagerLanguagesQueryHookResult = ReturnType<typeof useGetManagerLanguagesQuery>;
export type GetManagerLanguagesLazyQueryHookResult = ReturnType<typeof useGetManagerLanguagesLazyQuery>;
export type GetManagerLanguagesQueryResult = Apollo.QueryResult<GetManagerLanguagesQuery, GetManagerLanguagesQueryVariables>;
export const GetDiscordGuildInfoDocument = gql`
    query GetDiscordGuildInfo($guildId: String!) {
  Username
  GuildName(guildId: $guildId)
  GuildUsers(guildId: $guildId) {
    discordUserId
    discordUsername
    guildUserStatus
  }
}
    `;

/**
 * __useGetDiscordGuildInfoQuery__
 *
 * To run a query within a React component, call `useGetDiscordGuildInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscordGuildInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscordGuildInfoQuery({
 *   variables: {
 *      guildId: // value for 'guildId'
 *   },
 * });
 */
export function useGetDiscordGuildInfoQuery(baseOptions: Apollo.QueryHookOptions<GetDiscordGuildInfoQuery, GetDiscordGuildInfoQueryVariables>) {
        return Apollo.useQuery<GetDiscordGuildInfoQuery, GetDiscordGuildInfoQueryVariables>(GetDiscordGuildInfoDocument, baseOptions);
      }
export function useGetDiscordGuildInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscordGuildInfoQuery, GetDiscordGuildInfoQueryVariables>) {
          return Apollo.useLazyQuery<GetDiscordGuildInfoQuery, GetDiscordGuildInfoQueryVariables>(GetDiscordGuildInfoDocument, baseOptions);
        }
export type GetDiscordGuildInfoQueryHookResult = ReturnType<typeof useGetDiscordGuildInfoQuery>;
export type GetDiscordGuildInfoLazyQueryHookResult = ReturnType<typeof useGetDiscordGuildInfoLazyQuery>;
export type GetDiscordGuildInfoQueryResult = Apollo.QueryResult<GetDiscordGuildInfoQuery, GetDiscordGuildInfoQueryVariables>;
export const GetMyGuildModerationStatusDocument = gql`
    query GetMyGuildModerationStatus {
  GuildModerators {
    name
    guildId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetMyGuildModerationStatusQuery__
 *
 * To run a query within a React component, call `useGetMyGuildModerationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGuildModerationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGuildModerationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyGuildModerationStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetMyGuildModerationStatusQuery, GetMyGuildModerationStatusQueryVariables>) {
        return Apollo.useQuery<GetMyGuildModerationStatusQuery, GetMyGuildModerationStatusQueryVariables>(GetMyGuildModerationStatusDocument, baseOptions);
      }
export function useGetMyGuildModerationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGuildModerationStatusQuery, GetMyGuildModerationStatusQueryVariables>) {
          return Apollo.useLazyQuery<GetMyGuildModerationStatusQuery, GetMyGuildModerationStatusQueryVariables>(GetMyGuildModerationStatusDocument, baseOptions);
        }
export type GetMyGuildModerationStatusQueryHookResult = ReturnType<typeof useGetMyGuildModerationStatusQuery>;
export type GetMyGuildModerationStatusLazyQueryHookResult = ReturnType<typeof useGetMyGuildModerationStatusLazyQuery>;
export type GetMyGuildModerationStatusQueryResult = Apollo.QueryResult<GetMyGuildModerationStatusQuery, GetMyGuildModerationStatusQueryVariables>;
export const GetFanSummaryDocument = gql`
    query GetFanSummary($days: Int!, $platform: Platform, $page: Int!, $sortUsernames: String, $sortQuestions: String, $sortAnswers: String, $limit: Int!) {
  FanSummary(days: $days, platform: $platform, page: $page, sortUsernames: $sortUsernames, sortQuestions: $sortQuestions, sortAnswers: $sortAnswers, limit: $limit) {
    fans {
      fanId
      isFavorite
      totalFans
      username
      openQuestion
      questions
      answers
      platforms
      allPlatforms
      socialUrls
      email
      identities {
        isFavorite
        score
        username
        platforms
        email
        fanId
        openQuestion
        questions
        answers
      }
    }
    pagination {
      page
      totalFans
    }
  }
}
    `;

/**
 * __useGetFanSummaryQuery__
 *
 * To run a query within a React component, call `useGetFanSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFanSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFanSummaryQuery({
 *   variables: {
 *      days: // value for 'days'
 *      platform: // value for 'platform'
 *      page: // value for 'page'
 *      sortUsernames: // value for 'sortUsernames'
 *      sortQuestions: // value for 'sortQuestions'
 *      sortAnswers: // value for 'sortAnswers'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFanSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetFanSummaryQuery, GetFanSummaryQueryVariables>) {
        return Apollo.useQuery<GetFanSummaryQuery, GetFanSummaryQueryVariables>(GetFanSummaryDocument, baseOptions);
      }
export function useGetFanSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFanSummaryQuery, GetFanSummaryQueryVariables>) {
          return Apollo.useLazyQuery<GetFanSummaryQuery, GetFanSummaryQueryVariables>(GetFanSummaryDocument, baseOptions);
        }
export type GetFanSummaryQueryHookResult = ReturnType<typeof useGetFanSummaryQuery>;
export type GetFanSummaryLazyQueryHookResult = ReturnType<typeof useGetFanSummaryLazyQuery>;
export type GetFanSummaryQueryResult = Apollo.QueryResult<GetFanSummaryQuery, GetFanSummaryQueryVariables>;
export const GetTopQuestionsDocument = gql`
    query GetTopQuestions($page: Int!, $limit: Int!) {
  TopFanQuestions(page: $page, limit: $limit) {
    topFanQuestions {
      ...QuestionDetail
    }
    topFans {
      user {
        ...ProfileOnGetProfile
      }
      questions
      answers
    }
  }
}
    ${QuestionDetailFragmentDoc}
${ProfileOnGetProfileFragmentDoc}`;

/**
 * __useGetTopQuestionsQuery__
 *
 * To run a query within a React component, call `useGetTopQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopQuestionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTopQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetTopQuestionsQuery, GetTopQuestionsQueryVariables>) {
        return Apollo.useQuery<GetTopQuestionsQuery, GetTopQuestionsQueryVariables>(GetTopQuestionsDocument, baseOptions);
      }
export function useGetTopQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopQuestionsQuery, GetTopQuestionsQueryVariables>) {
          return Apollo.useLazyQuery<GetTopQuestionsQuery, GetTopQuestionsQueryVariables>(GetTopQuestionsDocument, baseOptions);
        }
export type GetTopQuestionsQueryHookResult = ReturnType<typeof useGetTopQuestionsQuery>;
export type GetTopQuestionsLazyQueryHookResult = ReturnType<typeof useGetTopQuestionsLazyQuery>;
export type GetTopQuestionsQueryResult = Apollo.QueryResult<GetTopQuestionsQuery, GetTopQuestionsQueryVariables>;
export const GetManagerFanSummaryDocument = gql`
    query GetManagerFanSummary($days: Int!, $platform: Platform, $page: Int!, $sortUsernames: String, $sortQuestions: String, $sortAnswers: String, $artistId: String, $limit: Int!) {
  ManagerFanSummary(days: $days, platform: $platform, page: $page, sortUsernames: $sortUsernames, sortQuestions: $sortQuestions, sortAnswers: $sortAnswers, artistId: $artistId, limit: $limit) {
    fans {
      fanId
      isFavorite
      totalFans
      username
      artistName
      artistPicture
      allArtists {
        name
        picture
      }
      socialUrls
      questions
      answers
      platforms
      allPlatforms
      email
      identities {
        isFavorite
        score
        username
        platforms
        email
        fanId
        questions
        answers
        artistPicture
        artistName
      }
    }
    pagination {
      page
      totalFans
    }
  }
}
    `;

/**
 * __useGetManagerFanSummaryQuery__
 *
 * To run a query within a React component, call `useGetManagerFanSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerFanSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerFanSummaryQuery({
 *   variables: {
 *      days: // value for 'days'
 *      platform: // value for 'platform'
 *      page: // value for 'page'
 *      sortUsernames: // value for 'sortUsernames'
 *      sortQuestions: // value for 'sortQuestions'
 *      sortAnswers: // value for 'sortAnswers'
 *      artistId: // value for 'artistId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetManagerFanSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetManagerFanSummaryQuery, GetManagerFanSummaryQueryVariables>) {
        return Apollo.useQuery<GetManagerFanSummaryQuery, GetManagerFanSummaryQueryVariables>(GetManagerFanSummaryDocument, baseOptions);
      }
export function useGetManagerFanSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerFanSummaryQuery, GetManagerFanSummaryQueryVariables>) {
          return Apollo.useLazyQuery<GetManagerFanSummaryQuery, GetManagerFanSummaryQueryVariables>(GetManagerFanSummaryDocument, baseOptions);
        }
export type GetManagerFanSummaryQueryHookResult = ReturnType<typeof useGetManagerFanSummaryQuery>;
export type GetManagerFanSummaryLazyQueryHookResult = ReturnType<typeof useGetManagerFanSummaryLazyQuery>;
export type GetManagerFanSummaryQueryResult = Apollo.QueryResult<GetManagerFanSummaryQuery, GetManagerFanSummaryQueryVariables>;
export const GetFeaturedEntitiesDocument = gql`
    query GetFeaturedEntities {
  FeaturedEntities {
    id
    createdAt
    updatedAt
    questionIds
    artistIds
    answers {
      ...AnswerDetail
    }
    artists {
      ...ProfileOnGetProfile
    }
    activities {
      ...ActivityDetail
    }
  }
}
    ${AnswerDetailFragmentDoc}
${ProfileOnGetProfileFragmentDoc}
${ActivityDetailFragmentDoc}`;

/**
 * __useGetFeaturedEntitiesQuery__
 *
 * To run a query within a React component, call `useGetFeaturedEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturedEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedEntitiesQuery, GetFeaturedEntitiesQueryVariables>) {
        return Apollo.useQuery<GetFeaturedEntitiesQuery, GetFeaturedEntitiesQueryVariables>(GetFeaturedEntitiesDocument, baseOptions);
      }
export function useGetFeaturedEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedEntitiesQuery, GetFeaturedEntitiesQueryVariables>) {
          return Apollo.useLazyQuery<GetFeaturedEntitiesQuery, GetFeaturedEntitiesQueryVariables>(GetFeaturedEntitiesDocument, baseOptions);
        }
export type GetFeaturedEntitiesQueryHookResult = ReturnType<typeof useGetFeaturedEntitiesQuery>;
export type GetFeaturedEntitiesLazyQueryHookResult = ReturnType<typeof useGetFeaturedEntitiesLazyQuery>;
export type GetFeaturedEntitiesQueryResult = Apollo.QueryResult<GetFeaturedEntitiesQuery, GetFeaturedEntitiesQueryVariables>;
export const HealthCheckDocument = gql`
    query HealthCheck {
  healthCheck {
    status
    response
    timestamp
  }
}
    `;

/**
 * __useHealthCheckQuery__
 *
 * To run a query within a React component, call `useHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useHealthCheckQuery(baseOptions?: Apollo.QueryHookOptions<HealthCheckQuery, HealthCheckQueryVariables>) {
        return Apollo.useQuery<HealthCheckQuery, HealthCheckQueryVariables>(HealthCheckDocument, baseOptions);
      }
export function useHealthCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HealthCheckQuery, HealthCheckQueryVariables>) {
          return Apollo.useLazyQuery<HealthCheckQuery, HealthCheckQueryVariables>(HealthCheckDocument, baseOptions);
        }
export type HealthCheckQueryHookResult = ReturnType<typeof useHealthCheckQuery>;
export type HealthCheckLazyQueryHookResult = ReturnType<typeof useHealthCheckLazyQuery>;
export type HealthCheckQueryResult = Apollo.QueryResult<HealthCheckQuery, HealthCheckQueryVariables>;
export const GetInstagramAccountStatsDocument = gql`
    query GetInstagramAccountStats {
  InstagramAccountStats {
    followerCount
    mediaCount
    videoCrawlJobCount
    channelCrawlPublishedAfter
    latestQuestionCreatedAt
  }
}
    `;

/**
 * __useGetInstagramAccountStatsQuery__
 *
 * To run a query within a React component, call `useGetInstagramAccountStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstagramAccountStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstagramAccountStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstagramAccountStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetInstagramAccountStatsQuery, GetInstagramAccountStatsQueryVariables>) {
        return Apollo.useQuery<GetInstagramAccountStatsQuery, GetInstagramAccountStatsQueryVariables>(GetInstagramAccountStatsDocument, baseOptions);
      }
export function useGetInstagramAccountStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstagramAccountStatsQuery, GetInstagramAccountStatsQueryVariables>) {
          return Apollo.useLazyQuery<GetInstagramAccountStatsQuery, GetInstagramAccountStatsQueryVariables>(GetInstagramAccountStatsDocument, baseOptions);
        }
export type GetInstagramAccountStatsQueryHookResult = ReturnType<typeof useGetInstagramAccountStatsQuery>;
export type GetInstagramAccountStatsLazyQueryHookResult = ReturnType<typeof useGetInstagramAccountStatsLazyQuery>;
export type GetInstagramAccountStatsQueryResult = Apollo.QueryResult<GetInstagramAccountStatsQuery, GetInstagramAccountStatsQueryVariables>;
export const GetArtistInstagramActivityDocument = gql`
    query GetArtistInstagramActivity {
  ArtistInstagramCrawlJobs {
    activeVideoCrawlJobs {
      ...ArtistInstagramCrawlJobDetail
    }
    inactiveVideoCrawlJobs {
      ...ArtistInstagramCrawlJobDetail
    }
    channelCrawlJob {
      ...ArtistInstagramCrawlJobDetail
    }
  }
  InstagramAccountStats {
    followerCount
    mediaCount
    videoCrawlJobCount
    channelCrawlPublishedAfter
    latestQuestionCreatedAt
  }
}
    ${ArtistInstagramCrawlJobDetailFragmentDoc}`;

/**
 * __useGetArtistInstagramActivityQuery__
 *
 * To run a query within a React component, call `useGetArtistInstagramActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtistInstagramActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtistInstagramActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetArtistInstagramActivityQuery(baseOptions?: Apollo.QueryHookOptions<GetArtistInstagramActivityQuery, GetArtistInstagramActivityQueryVariables>) {
        return Apollo.useQuery<GetArtistInstagramActivityQuery, GetArtistInstagramActivityQueryVariables>(GetArtistInstagramActivityDocument, baseOptions);
      }
export function useGetArtistInstagramActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtistInstagramActivityQuery, GetArtistInstagramActivityQueryVariables>) {
          return Apollo.useLazyQuery<GetArtistInstagramActivityQuery, GetArtistInstagramActivityQueryVariables>(GetArtistInstagramActivityDocument, baseOptions);
        }
export type GetArtistInstagramActivityQueryHookResult = ReturnType<typeof useGetArtistInstagramActivityQuery>;
export type GetArtistInstagramActivityLazyQueryHookResult = ReturnType<typeof useGetArtistInstagramActivityLazyQuery>;
export type GetArtistInstagramActivityQueryResult = Apollo.QueryResult<GetArtistInstagramActivityQuery, GetArtistInstagramActivityQueryVariables>;
export const MyProfileDocument = gql`
    query MyProfile {
  Profile {
    ...ProfileOnGetProfile
  }
  User {
    ...UserOnGetUserFragment
  }
}
    ${ProfileOnGetProfileFragmentDoc}
${UserOnGetUserFragmentFragmentDoc}`;

/**
 * __useMyProfileQuery__
 *
 * To run a query within a React component, call `useMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileQuery(baseOptions?: Apollo.QueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
        return Apollo.useQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, baseOptions);
      }
export function useMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
          return Apollo.useLazyQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, baseOptions);
        }
export type MyProfileQueryHookResult = ReturnType<typeof useMyProfileQuery>;
export type MyProfileLazyQueryHookResult = ReturnType<typeof useMyProfileLazyQuery>;
export type MyProfileQueryResult = Apollo.QueryResult<MyProfileQuery, MyProfileQueryVariables>;
export const GetUsernameAvailableDocument = gql`
    query GetUsernameAvailable($username: String!) {
  UsernameAvailable(username: $username)
}
    `;

/**
 * __useGetUsernameAvailableQuery__
 *
 * To run a query within a React component, call `useGetUsernameAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsernameAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsernameAvailableQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetUsernameAvailableQuery(baseOptions: Apollo.QueryHookOptions<GetUsernameAvailableQuery, GetUsernameAvailableQueryVariables>) {
        return Apollo.useQuery<GetUsernameAvailableQuery, GetUsernameAvailableQueryVariables>(GetUsernameAvailableDocument, baseOptions);
      }
export function useGetUsernameAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsernameAvailableQuery, GetUsernameAvailableQueryVariables>) {
          return Apollo.useLazyQuery<GetUsernameAvailableQuery, GetUsernameAvailableQueryVariables>(GetUsernameAvailableDocument, baseOptions);
        }
export type GetUsernameAvailableQueryHookResult = ReturnType<typeof useGetUsernameAvailableQuery>;
export type GetUsernameAvailableLazyQueryHookResult = ReturnType<typeof useGetUsernameAvailableLazyQuery>;
export type GetUsernameAvailableQueryResult = Apollo.QueryResult<GetUsernameAvailableQuery, GetUsernameAvailableQueryVariables>;
export const PayoutRoyaltiesDocument = gql`
    query PayoutRoyalties {
  PayoutRoyalties {
    nftAmount
    artistWallet
    createdAt
    artistUsername
    artistId
    txID
    royalty
    settled
    royaltyIds
    id
  }
}
    `;

/**
 * __usePayoutRoyaltiesQuery__
 *
 * To run a query within a React component, call `usePayoutRoyaltiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutRoyaltiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutRoyaltiesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayoutRoyaltiesQuery(baseOptions?: Apollo.QueryHookOptions<PayoutRoyaltiesQuery, PayoutRoyaltiesQueryVariables>) {
        return Apollo.useQuery<PayoutRoyaltiesQuery, PayoutRoyaltiesQueryVariables>(PayoutRoyaltiesDocument, baseOptions);
      }
export function usePayoutRoyaltiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutRoyaltiesQuery, PayoutRoyaltiesQueryVariables>) {
          return Apollo.useLazyQuery<PayoutRoyaltiesQuery, PayoutRoyaltiesQueryVariables>(PayoutRoyaltiesDocument, baseOptions);
        }
export type PayoutRoyaltiesQueryHookResult = ReturnType<typeof usePayoutRoyaltiesQuery>;
export type PayoutRoyaltiesLazyQueryHookResult = ReturnType<typeof usePayoutRoyaltiesLazyQuery>;
export type PayoutRoyaltiesQueryResult = Apollo.QueryResult<PayoutRoyaltiesQuery, PayoutRoyaltiesQueryVariables>;
export const PayoutRoyaltiesUserDocument = gql`
    query PayoutRoyaltiesUser {
  PayoutRoyaltiesUser {
    isPending
  }
}
    `;

/**
 * __usePayoutRoyaltiesUserQuery__
 *
 * To run a query within a React component, call `usePayoutRoyaltiesUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutRoyaltiesUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutRoyaltiesUserQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayoutRoyaltiesUserQuery(baseOptions?: Apollo.QueryHookOptions<PayoutRoyaltiesUserQuery, PayoutRoyaltiesUserQueryVariables>) {
        return Apollo.useQuery<PayoutRoyaltiesUserQuery, PayoutRoyaltiesUserQueryVariables>(PayoutRoyaltiesUserDocument, baseOptions);
      }
export function usePayoutRoyaltiesUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutRoyaltiesUserQuery, PayoutRoyaltiesUserQueryVariables>) {
          return Apollo.useLazyQuery<PayoutRoyaltiesUserQuery, PayoutRoyaltiesUserQueryVariables>(PayoutRoyaltiesUserDocument, baseOptions);
        }
export type PayoutRoyaltiesUserQueryHookResult = ReturnType<typeof usePayoutRoyaltiesUserQuery>;
export type PayoutRoyaltiesUserLazyQueryHookResult = ReturnType<typeof usePayoutRoyaltiesUserLazyQuery>;
export type PayoutRoyaltiesUserQueryResult = Apollo.QueryResult<PayoutRoyaltiesUserQuery, PayoutRoyaltiesUserQueryVariables>;
export const ProfileDocument = gql`
    query Profile($username: String!) {
  Profile(username: $username) {
    ...ProfileOnGetProfile
  }
  User {
    ...UserOnGetUserFragment
  }
}
    ${ProfileOnGetProfileFragmentDoc}
${UserOnGetUserFragmentFragmentDoc}`;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useProfileQuery(baseOptions: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, baseOptions);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, baseOptions);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const GetSortedQuestionsDocument = gql`
    query GetSortedQuestions($username: String!, $platform: Platform, $page: Int!, $sort: String!, $videoId: String) {
  SortedQuestions(username: $username, platform: $platform, page: $page, sort: $sort, videoId: $videoId) {
    questions {
      ...QuestionDetail
    }
    nextPage
  }
}
    ${QuestionDetailFragmentDoc}`;

/**
 * __useGetSortedQuestionsQuery__
 *
 * To run a query within a React component, call `useGetSortedQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSortedQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSortedQuestionsQuery({
 *   variables: {
 *      username: // value for 'username'
 *      platform: // value for 'platform'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetSortedQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetSortedQuestionsQuery, GetSortedQuestionsQueryVariables>) {
        return Apollo.useQuery<GetSortedQuestionsQuery, GetSortedQuestionsQueryVariables>(GetSortedQuestionsDocument, baseOptions);
      }
export function useGetSortedQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSortedQuestionsQuery, GetSortedQuestionsQueryVariables>) {
          return Apollo.useLazyQuery<GetSortedQuestionsQuery, GetSortedQuestionsQueryVariables>(GetSortedQuestionsDocument, baseOptions);
        }
export type GetSortedQuestionsQueryHookResult = ReturnType<typeof useGetSortedQuestionsQuery>;
export type GetSortedQuestionsLazyQueryHookResult = ReturnType<typeof useGetSortedQuestionsLazyQuery>;
export type GetSortedQuestionsQueryResult = Apollo.QueryResult<GetSortedQuestionsQuery, GetSortedQuestionsQueryVariables>;
export const GetSortedAnswersDocument = gql`
    query GetSortedAnswers($username: String!, $platform: Platform, $page: Int!, $sort: String!) {
  SortedAnswers(username: $username, platform: $platform, page: $page, sort: $sort) {
    answers {
      ...QuestionDetail
    }
    nextPage
  }
}
    ${QuestionDetailFragmentDoc}`;

/**
 * __useGetSortedAnswersQuery__
 *
 * To run a query within a React component, call `useGetSortedAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSortedAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSortedAnswersQuery({
 *   variables: {
 *      username: // value for 'username'
 *      platform: // value for 'platform'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSortedAnswersQuery(baseOptions: Apollo.QueryHookOptions<GetSortedAnswersQuery, GetSortedAnswersQueryVariables>) {
        return Apollo.useQuery<GetSortedAnswersQuery, GetSortedAnswersQueryVariables>(GetSortedAnswersDocument, baseOptions);
      }
export function useGetSortedAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSortedAnswersQuery, GetSortedAnswersQueryVariables>) {
          return Apollo.useLazyQuery<GetSortedAnswersQuery, GetSortedAnswersQueryVariables>(GetSortedAnswersDocument, baseOptions);
        }
export type GetSortedAnswersQueryHookResult = ReturnType<typeof useGetSortedAnswersQuery>;
export type GetSortedAnswersLazyQueryHookResult = ReturnType<typeof useGetSortedAnswersLazyQuery>;
export type GetSortedAnswersQueryResult = Apollo.QueryResult<GetSortedAnswersQuery, GetSortedAnswersQueryVariables>;
export const SignedUploadUrlDocument = gql`
    query SignedUploadUrl($id: ID!, $key: String, $fileType: String!) {
  Question(id: $id) {
    signedUploadUrl(key: $key, fileType: $fileType)
  }
}
    `;

/**
 * __useSignedUploadUrlQuery__
 *
 * To run a query within a React component, call `useSignedUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignedUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignedUploadUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      key: // value for 'key'
 *      fileType: // value for 'fileType'
 *   },
 * });
 */
export function useSignedUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<SignedUploadUrlQuery, SignedUploadUrlQueryVariables>) {
        return Apollo.useQuery<SignedUploadUrlQuery, SignedUploadUrlQueryVariables>(SignedUploadUrlDocument, baseOptions);
      }
export function useSignedUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignedUploadUrlQuery, SignedUploadUrlQueryVariables>) {
          return Apollo.useLazyQuery<SignedUploadUrlQuery, SignedUploadUrlQueryVariables>(SignedUploadUrlDocument, baseOptions);
        }
export type SignedUploadUrlQueryHookResult = ReturnType<typeof useSignedUploadUrlQuery>;
export type SignedUploadUrlLazyQueryHookResult = ReturnType<typeof useSignedUploadUrlLazyQuery>;
export type SignedUploadUrlQueryResult = Apollo.QueryResult<SignedUploadUrlQuery, SignedUploadUrlQueryVariables>;
export const SignedUploadShareUrlDocument = gql`
    query SignedUploadShareUrl($id: ID!, $key: String, $fileType: String!) {
  Question(id: $id) {
    signedUploadShareUrl(key: $key, fileType: $fileType)
  }
}
    `;

/**
 * __useSignedUploadShareUrlQuery__
 *
 * To run a query within a React component, call `useSignedUploadShareUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignedUploadShareUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignedUploadShareUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      key: // value for 'key'
 *      fileType: // value for 'fileType'
 *   },
 * });
 */
export function useSignedUploadShareUrlQuery(baseOptions: Apollo.QueryHookOptions<SignedUploadShareUrlQuery, SignedUploadShareUrlQueryVariables>) {
        return Apollo.useQuery<SignedUploadShareUrlQuery, SignedUploadShareUrlQueryVariables>(SignedUploadShareUrlDocument, baseOptions);
      }
export function useSignedUploadShareUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignedUploadShareUrlQuery, SignedUploadShareUrlQueryVariables>) {
          return Apollo.useLazyQuery<SignedUploadShareUrlQuery, SignedUploadShareUrlQueryVariables>(SignedUploadShareUrlDocument, baseOptions);
        }
export type SignedUploadShareUrlQueryHookResult = ReturnType<typeof useSignedUploadShareUrlQuery>;
export type SignedUploadShareUrlLazyQueryHookResult = ReturnType<typeof useSignedUploadShareUrlLazyQuery>;
export type SignedUploadShareUrlQueryResult = Apollo.QueryResult<SignedUploadShareUrlQuery, SignedUploadShareUrlQueryVariables>;
export const GetQuestionDocument = gql`
    query GetQuestion($id: ID!) {
  Question(id: $id) {
    ...QuestionDetail
  }
  User {
    ...UserOnGetUserFragment
  }
}
    ${QuestionDetailFragmentDoc}
${UserOnGetUserFragmentFragmentDoc}`;

/**
 * __useGetQuestionQuery__
 *
 * To run a query within a React component, call `useGetQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionQuery, GetQuestionQueryVariables>) {
        return Apollo.useQuery<GetQuestionQuery, GetQuestionQueryVariables>(GetQuestionDocument, baseOptions);
      }
export function useGetQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionQuery, GetQuestionQueryVariables>) {
          return Apollo.useLazyQuery<GetQuestionQuery, GetQuestionQueryVariables>(GetQuestionDocument, baseOptions);
        }
export type GetQuestionQueryHookResult = ReturnType<typeof useGetQuestionQuery>;
export type GetQuestionLazyQueryHookResult = ReturnType<typeof useGetQuestionLazyQuery>;
export type GetQuestionQueryResult = Apollo.QueryResult<GetQuestionQuery, GetQuestionQueryVariables>;
export const GetNewestOpenQuestionDocument = gql`
    query GetNewestOpenQuestion {
  NewestOpenQuestion {
    ...QuestionDetail
  }
}
    ${QuestionDetailFragmentDoc}`;

/**
 * __useGetNewestOpenQuestionQuery__
 *
 * To run a query within a React component, call `useGetNewestOpenQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewestOpenQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewestOpenQuestionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewestOpenQuestionQuery(baseOptions?: Apollo.QueryHookOptions<GetNewestOpenQuestionQuery, GetNewestOpenQuestionQueryVariables>) {
        return Apollo.useQuery<GetNewestOpenQuestionQuery, GetNewestOpenQuestionQueryVariables>(GetNewestOpenQuestionDocument, baseOptions);
      }
export function useGetNewestOpenQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewestOpenQuestionQuery, GetNewestOpenQuestionQueryVariables>) {
          return Apollo.useLazyQuery<GetNewestOpenQuestionQuery, GetNewestOpenQuestionQueryVariables>(GetNewestOpenQuestionDocument, baseOptions);
        }
export type GetNewestOpenQuestionQueryHookResult = ReturnType<typeof useGetNewestOpenQuestionQuery>;
export type GetNewestOpenQuestionLazyQueryHookResult = ReturnType<typeof useGetNewestOpenQuestionLazyQuery>;
export type GetNewestOpenQuestionQueryResult = Apollo.QueryResult<GetNewestOpenQuestionQuery, GetNewestOpenQuestionQueryVariables>;
export const GetQuestionListNavigationDocument = gql`
    query GetQuestionListNavigation($username: String!, $currentQuestionId: String!, $state: QuestionState!) {
  QuestionListNavigation(currentQuestionId: $currentQuestionId, username: $username, state: $state) {
    NextQuestion {
      ...QuestionDetail
    }
    PreviousQuestion {
      ...QuestionDetail
    }
    Index
    TotalCount
  }
}
    ${QuestionDetailFragmentDoc}`;

/**
 * __useGetQuestionListNavigationQuery__
 *
 * To run a query within a React component, call `useGetQuestionListNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionListNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionListNavigationQuery({
 *   variables: {
 *      username: // value for 'username'
 *      currentQuestionId: // value for 'currentQuestionId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetQuestionListNavigationQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionListNavigationQuery, GetQuestionListNavigationQueryVariables>) {
        return Apollo.useQuery<GetQuestionListNavigationQuery, GetQuestionListNavigationQueryVariables>(GetQuestionListNavigationDocument, baseOptions);
      }
export function useGetQuestionListNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionListNavigationQuery, GetQuestionListNavigationQueryVariables>) {
          return Apollo.useLazyQuery<GetQuestionListNavigationQuery, GetQuestionListNavigationQueryVariables>(GetQuestionListNavigationDocument, baseOptions);
        }
export type GetQuestionListNavigationQueryHookResult = ReturnType<typeof useGetQuestionListNavigationQuery>;
export type GetQuestionListNavigationLazyQueryHookResult = ReturnType<typeof useGetQuestionListNavigationLazyQuery>;
export type GetQuestionListNavigationQueryResult = Apollo.QueryResult<GetQuestionListNavigationQuery, GetQuestionListNavigationQueryVariables>;
export const AuthenticateRedditCallbackDocument = gql`
    mutation AuthenticateRedditCallback($code: String!, $state: String) {
  AuthenticateRedditCallback(code: $code, state: $state) {
    redirectTarget
    token
    userId
    username
    code
    error
  }
}
    `;
export type AuthenticateRedditCallbackMutationFn = Apollo.MutationFunction<AuthenticateRedditCallbackMutation, AuthenticateRedditCallbackMutationVariables>;

/**
 * __useAuthenticateRedditCallbackMutation__
 *
 * To run a mutation, you first call `useAuthenticateRedditCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateRedditCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateRedditCallbackMutation, { data, loading, error }] = useAuthenticateRedditCallbackMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useAuthenticateRedditCallbackMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateRedditCallbackMutation, AuthenticateRedditCallbackMutationVariables>) {
        return Apollo.useMutation<AuthenticateRedditCallbackMutation, AuthenticateRedditCallbackMutationVariables>(AuthenticateRedditCallbackDocument, baseOptions);
      }
export type AuthenticateRedditCallbackMutationHookResult = ReturnType<typeof useAuthenticateRedditCallbackMutation>;
export type AuthenticateRedditCallbackMutationResult = Apollo.MutationResult<AuthenticateRedditCallbackMutation>;
export type AuthenticateRedditCallbackMutationOptions = Apollo.BaseMutationOptions<AuthenticateRedditCallbackMutation, AuthenticateRedditCallbackMutationVariables>;
export const GetSubredditArtistBonsaiConfigDocument = gql`
    query GetSubredditArtistBonsaiConfig($subredditId: String!) {
  SubredditArtistBonsaiConfig(subredditId: $subredditId) {
    questionRecipient {
      id
      name
      username
    }
  }
}
    `;

/**
 * __useGetSubredditArtistBonsaiConfigQuery__
 *
 * To run a query within a React component, call `useGetSubredditArtistBonsaiConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubredditArtistBonsaiConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubredditArtistBonsaiConfigQuery({
 *   variables: {
 *      subredditId: // value for 'subredditId'
 *   },
 * });
 */
export function useGetSubredditArtistBonsaiConfigQuery(baseOptions: Apollo.QueryHookOptions<GetSubredditArtistBonsaiConfigQuery, GetSubredditArtistBonsaiConfigQueryVariables>) {
        return Apollo.useQuery<GetSubredditArtistBonsaiConfigQuery, GetSubredditArtistBonsaiConfigQueryVariables>(GetSubredditArtistBonsaiConfigDocument, baseOptions);
      }
export function useGetSubredditArtistBonsaiConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubredditArtistBonsaiConfigQuery, GetSubredditArtistBonsaiConfigQueryVariables>) {
          return Apollo.useLazyQuery<GetSubredditArtistBonsaiConfigQuery, GetSubredditArtistBonsaiConfigQueryVariables>(GetSubredditArtistBonsaiConfigDocument, baseOptions);
        }
export type GetSubredditArtistBonsaiConfigQueryHookResult = ReturnType<typeof useGetSubredditArtistBonsaiConfigQuery>;
export type GetSubredditArtistBonsaiConfigLazyQueryHookResult = ReturnType<typeof useGetSubredditArtistBonsaiConfigLazyQuery>;
export type GetSubredditArtistBonsaiConfigQueryResult = Apollo.QueryResult<GetSubredditArtistBonsaiConfigQuery, GetSubredditArtistBonsaiConfigQueryVariables>;
export const GetMySubredditsDocument = gql`
    query GetMySubreddits {
  MySubreddits {
    subredditId
    subredditName
    subredditUrl
  }
}
    `;

/**
 * __useGetMySubredditsQuery__
 *
 * To run a query within a React component, call `useGetMySubredditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubredditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubredditsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySubredditsQuery(baseOptions?: Apollo.QueryHookOptions<GetMySubredditsQuery, GetMySubredditsQueryVariables>) {
        return Apollo.useQuery<GetMySubredditsQuery, GetMySubredditsQueryVariables>(GetMySubredditsDocument, baseOptions);
      }
export function useGetMySubredditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySubredditsQuery, GetMySubredditsQueryVariables>) {
          return Apollo.useLazyQuery<GetMySubredditsQuery, GetMySubredditsQueryVariables>(GetMySubredditsDocument, baseOptions);
        }
export type GetMySubredditsQueryHookResult = ReturnType<typeof useGetMySubredditsQuery>;
export type GetMySubredditsLazyQueryHookResult = ReturnType<typeof useGetMySubredditsLazyQuery>;
export type GetMySubredditsQueryResult = Apollo.QueryResult<GetMySubredditsQuery, GetMySubredditsQueryVariables>;
export const UpsertSubredditArtistBonsaiConfigDocument = gql`
    mutation UpsertSubredditArtistBonsaiConfig($subredditId: String!, $questionRecipientId: String) {
  UpsertSubredditArtistBonsaiConfig(input: {subredditId: $subredditId, questionRecipientId: $questionRecipientId}) {
    success
    error
    questionRecipient {
      id
      name
      username
    }
  }
}
    `;
export type UpsertSubredditArtistBonsaiConfigMutationFn = Apollo.MutationFunction<UpsertSubredditArtistBonsaiConfigMutation, UpsertSubredditArtistBonsaiConfigMutationVariables>;

/**
 * __useUpsertSubredditArtistBonsaiConfigMutation__
 *
 * To run a mutation, you first call `useUpsertSubredditArtistBonsaiConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSubredditArtistBonsaiConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSubredditArtistBonsaiConfigMutation, { data, loading, error }] = useUpsertSubredditArtistBonsaiConfigMutation({
 *   variables: {
 *      subredditId: // value for 'subredditId'
 *      questionRecipientId: // value for 'questionRecipientId'
 *   },
 * });
 */
export function useUpsertSubredditArtistBonsaiConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSubredditArtistBonsaiConfigMutation, UpsertSubredditArtistBonsaiConfigMutationVariables>) {
        return Apollo.useMutation<UpsertSubredditArtistBonsaiConfigMutation, UpsertSubredditArtistBonsaiConfigMutationVariables>(UpsertSubredditArtistBonsaiConfigDocument, baseOptions);
      }
export type UpsertSubredditArtistBonsaiConfigMutationHookResult = ReturnType<typeof useUpsertSubredditArtistBonsaiConfigMutation>;
export type UpsertSubredditArtistBonsaiConfigMutationResult = Apollo.MutationResult<UpsertSubredditArtistBonsaiConfigMutation>;
export type UpsertSubredditArtistBonsaiConfigMutationOptions = Apollo.BaseMutationOptions<UpsertSubredditArtistBonsaiConfigMutation, UpsertSubredditArtistBonsaiConfigMutationVariables>;
export const GetSubredditModeratorsDocument = gql`
    query GetSubredditModerators($subredditId: String!) {
  SubredditModerators(subredditId: $subredditId) {
    success
    error
    subreddit {
      subredditName
      subredditUrl
    }
    moderators {
      id
      name
      username
    }
  }
}
    `;

/**
 * __useGetSubredditModeratorsQuery__
 *
 * To run a query within a React component, call `useGetSubredditModeratorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubredditModeratorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubredditModeratorsQuery({
 *   variables: {
 *      subredditId: // value for 'subredditId'
 *   },
 * });
 */
export function useGetSubredditModeratorsQuery(baseOptions: Apollo.QueryHookOptions<GetSubredditModeratorsQuery, GetSubredditModeratorsQueryVariables>) {
        return Apollo.useQuery<GetSubredditModeratorsQuery, GetSubredditModeratorsQueryVariables>(GetSubredditModeratorsDocument, baseOptions);
      }
export function useGetSubredditModeratorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubredditModeratorsQuery, GetSubredditModeratorsQueryVariables>) {
          return Apollo.useLazyQuery<GetSubredditModeratorsQuery, GetSubredditModeratorsQueryVariables>(GetSubredditModeratorsDocument, baseOptions);
        }
export type GetSubredditModeratorsQueryHookResult = ReturnType<typeof useGetSubredditModeratorsQuery>;
export type GetSubredditModeratorsLazyQueryHookResult = ReturnType<typeof useGetSubredditModeratorsLazyQuery>;
export type GetSubredditModeratorsQueryResult = Apollo.QueryResult<GetSubredditModeratorsQuery, GetSubredditModeratorsQueryVariables>;
export const CheckRedditInstallationStatusDocument = gql`
    query CheckRedditInstallationStatus($subredditId: String!) {
  CheckRedditInstallationStatus(subredditId: $subredditId)
}
    `;

/**
 * __useCheckRedditInstallationStatusQuery__
 *
 * To run a query within a React component, call `useCheckRedditInstallationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRedditInstallationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRedditInstallationStatusQuery({
 *   variables: {
 *      subredditId: // value for 'subredditId'
 *   },
 * });
 */
export function useCheckRedditInstallationStatusQuery(baseOptions: Apollo.QueryHookOptions<CheckRedditInstallationStatusQuery, CheckRedditInstallationStatusQueryVariables>) {
        return Apollo.useQuery<CheckRedditInstallationStatusQuery, CheckRedditInstallationStatusQueryVariables>(CheckRedditInstallationStatusDocument, baseOptions);
      }
export function useCheckRedditInstallationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckRedditInstallationStatusQuery, CheckRedditInstallationStatusQueryVariables>) {
          return Apollo.useLazyQuery<CheckRedditInstallationStatusQuery, CheckRedditInstallationStatusQueryVariables>(CheckRedditInstallationStatusDocument, baseOptions);
        }
export type CheckRedditInstallationStatusQueryHookResult = ReturnType<typeof useCheckRedditInstallationStatusQuery>;
export type CheckRedditInstallationStatusLazyQueryHookResult = ReturnType<typeof useCheckRedditInstallationStatusLazyQuery>;
export type CheckRedditInstallationStatusQueryResult = Apollo.QueryResult<CheckRedditInstallationStatusQuery, CheckRedditInstallationStatusQueryVariables>;
export const SearchDocument = gql`
    query Search($substring: String!) {
  Search(substring: $substring) {
    results {
      __typename
      ... on UserSearchResult {
        name
        username
        verified
        profilePictureUrl
        entityType
        bio
        highlight {
          name {
            value
            fullyHighlighted
            matchedWords
            matchLevel
          }
          bio {
            value
            fullyHighlighted
            matchedWords
            matchLevel
          }
        }
      }
      ... on QuestionSearchResult {
        Artist {
          name
          bio
          profilePictureUrl
        }
        id
        body
        entityType
        highlight {
          body {
            value
            fullyHighlighted
            matchedWords
            matchLevel
          }
        }
      }
      ... on AnswerSearchResult {
        Artist {
          name
          bio
          profilePictureUrl
        }
        body
        questionId
        transcript
        entityType
        highlight {
          transcript {
            value
            fullyHighlighted
            matchedWords
            matchLevel
          }
          body {
            value
            fullyHighlighted
            matchedWords
            matchLevel
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      substring: // value for 'substring'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, baseOptions);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, baseOptions);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const ProfileSearchDocument = gql`
    query ProfileSearch($substring: String!, $username: String!) {
  ProfileSearch(substring: $substring, username: $username) {
    results {
      __typename
      ... on SourceCommentSearchResult {
        entityType
        videoId
        count
        thumbnail
        youTubeVideoTitle
        instagramMediaCaption
        highlight {
          youTubeVideoTitle {
            value
            fullyHighlighted
            matchedWords
            matchLevel
          }
          instagramMediaCaption {
            value
            fullyHighlighted
            matchedWords
            matchLevel
          }
        }
      }
      ... on QuestionSearchResult {
        Fan {
          name
          bio
          profilePictureUrl
        }
        id
        body
        fanName
        entityType
        highlight {
          fanName {
            value
            fullyHighlighted
            matchedWords
            matchLevel
          }
          body {
            value
            fullyHighlighted
            matchedWords
            matchLevel
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProfileSearchQuery__
 *
 * To run a query within a React component, call `useProfileSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileSearchQuery({
 *   variables: {
 *      substring: // value for 'substring'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useProfileSearchQuery(baseOptions: Apollo.QueryHookOptions<ProfileSearchQuery, ProfileSearchQueryVariables>) {
        return Apollo.useQuery<ProfileSearchQuery, ProfileSearchQueryVariables>(ProfileSearchDocument, baseOptions);
      }
export function useProfileSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileSearchQuery, ProfileSearchQueryVariables>) {
          return Apollo.useLazyQuery<ProfileSearchQuery, ProfileSearchQueryVariables>(ProfileSearchDocument, baseOptions);
        }
export type ProfileSearchQueryHookResult = ReturnType<typeof useProfileSearchQuery>;
export type ProfileSearchLazyQueryHookResult = ReturnType<typeof useProfileSearchLazyQuery>;
export type ProfileSearchQueryResult = Apollo.QueryResult<ProfileSearchQuery, ProfileSearchQueryVariables>;
export const TagPageDocument = gql`
    query TagPage($slug: String!) {
  TagPage(slug: $slug) {
    Tag {
      name
    }
    Coaches {
      ...ProfileOnGetProfile
    }
  }
}
    ${ProfileOnGetProfileFragmentDoc}`;

/**
 * __useTagPageQuery__
 *
 * To run a query within a React component, call `useTagPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTagPageQuery(baseOptions: Apollo.QueryHookOptions<TagPageQuery, TagPageQueryVariables>) {
        return Apollo.useQuery<TagPageQuery, TagPageQueryVariables>(TagPageDocument, baseOptions);
      }
export function useTagPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagPageQuery, TagPageQueryVariables>) {
          return Apollo.useLazyQuery<TagPageQuery, TagPageQueryVariables>(TagPageDocument, baseOptions);
        }
export type TagPageQueryHookResult = ReturnType<typeof useTagPageQuery>;
export type TagPageLazyQueryHookResult = ReturnType<typeof useTagPageLazyQuery>;
export type TagPageQueryResult = Apollo.QueryResult<TagPageQuery, TagPageQueryVariables>;
export const TagsDocument = gql`
    query Tags {
  Tags {
    id
    name
    slug
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, baseOptions);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, baseOptions);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const SiteMapDataDocument = gql`
    query SiteMapData {
  AllUsersTakingQuestions {
    id
    username
    updatedAt
  }
  AllQuestions {
    id
    state
    updatedAt
  }
}
    `;

/**
 * __useSiteMapDataQuery__
 *
 * To run a query within a React component, call `useSiteMapDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteMapDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteMapDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteMapDataQuery(baseOptions?: Apollo.QueryHookOptions<SiteMapDataQuery, SiteMapDataQueryVariables>) {
        return Apollo.useQuery<SiteMapDataQuery, SiteMapDataQueryVariables>(SiteMapDataDocument, baseOptions);
      }
export function useSiteMapDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteMapDataQuery, SiteMapDataQueryVariables>) {
          return Apollo.useLazyQuery<SiteMapDataQuery, SiteMapDataQueryVariables>(SiteMapDataDocument, baseOptions);
        }
export type SiteMapDataQueryHookResult = ReturnType<typeof useSiteMapDataQuery>;
export type SiteMapDataLazyQueryHookResult = ReturnType<typeof useSiteMapDataLazyQuery>;
export type SiteMapDataQueryResult = Apollo.QueryResult<SiteMapDataQuery, SiteMapDataQueryVariables>;
export const GetAppPreflightDataDocument = gql`
    query GetAppPreflightData {
  Preflight {
    authRole
    success
    code
    publicId
    id
    name
    username
    profilePictureUrl
    email
    authRole
  }
}
    `;

/**
 * __useGetAppPreflightDataQuery__
 *
 * To run a query within a React component, call `useGetAppPreflightDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppPreflightDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppPreflightDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppPreflightDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAppPreflightDataQuery, GetAppPreflightDataQueryVariables>) {
        return Apollo.useQuery<GetAppPreflightDataQuery, GetAppPreflightDataQueryVariables>(GetAppPreflightDataDocument, baseOptions);
      }
export function useGetAppPreflightDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppPreflightDataQuery, GetAppPreflightDataQueryVariables>) {
          return Apollo.useLazyQuery<GetAppPreflightDataQuery, GetAppPreflightDataQueryVariables>(GetAppPreflightDataDocument, baseOptions);
        }
export type GetAppPreflightDataQueryHookResult = ReturnType<typeof useGetAppPreflightDataQuery>;
export type GetAppPreflightDataLazyQueryHookResult = ReturnType<typeof useGetAppPreflightDataLazyQuery>;
export type GetAppPreflightDataQueryResult = Apollo.QueryResult<GetAppPreflightDataQuery, GetAppPreflightDataQueryVariables>;
export const GetUserDocument = gql`
    query GetUser {
  User {
    ...UserOnGetUserFragment
  }
}
    ${UserOnGetUserFragmentFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, baseOptions);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, baseOptions);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetSignedUploadUrlDocument = gql`
    query GetSignedUploadUrl($fileType: String!) {
  User {
    id
    signedUploadUrl(fileType: $fileType)
  }
}
    `;

/**
 * __useGetSignedUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetSignedUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedUploadUrlQuery({
 *   variables: {
 *      fileType: // value for 'fileType'
 *   },
 * });
 */
export function useGetSignedUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSignedUploadUrlQuery, GetSignedUploadUrlQueryVariables>) {
        return Apollo.useQuery<GetSignedUploadUrlQuery, GetSignedUploadUrlQueryVariables>(GetSignedUploadUrlDocument, baseOptions);
      }
export function useGetSignedUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedUploadUrlQuery, GetSignedUploadUrlQueryVariables>) {
          return Apollo.useLazyQuery<GetSignedUploadUrlQuery, GetSignedUploadUrlQueryVariables>(GetSignedUploadUrlDocument, baseOptions);
        }
export type GetSignedUploadUrlQueryHookResult = ReturnType<typeof useGetSignedUploadUrlQuery>;
export type GetSignedUploadUrlLazyQueryHookResult = ReturnType<typeof useGetSignedUploadUrlLazyQuery>;
export type GetSignedUploadUrlQueryResult = Apollo.QueryResult<GetSignedUploadUrlQuery, GetSignedUploadUrlQueryVariables>;
export const GetStripeConnectStateDocument = gql`
    query GetStripeConnectState {
  User {
    stripeConnectState
  }
}
    `;

/**
 * __useGetStripeConnectStateQuery__
 *
 * To run a query within a React component, call `useGetStripeConnectStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeConnectStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeConnectStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripeConnectStateQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeConnectStateQuery, GetStripeConnectStateQueryVariables>) {
        return Apollo.useQuery<GetStripeConnectStateQuery, GetStripeConnectStateQueryVariables>(GetStripeConnectStateDocument, baseOptions);
      }
export function useGetStripeConnectStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeConnectStateQuery, GetStripeConnectStateQueryVariables>) {
          return Apollo.useLazyQuery<GetStripeConnectStateQuery, GetStripeConnectStateQueryVariables>(GetStripeConnectStateDocument, baseOptions);
        }
export type GetStripeConnectStateQueryHookResult = ReturnType<typeof useGetStripeConnectStateQuery>;
export type GetStripeConnectStateLazyQueryHookResult = ReturnType<typeof useGetStripeConnectStateLazyQuery>;
export type GetStripeConnectStateQueryResult = Apollo.QueryResult<GetStripeConnectStateQuery, GetStripeConnectStateQueryVariables>;
export const GetStripeConnectLoginUrlDocument = gql`
    query GetStripeConnectLoginUrl {
  User {
    stripeConnectLoginUrl
  }
}
    `;

/**
 * __useGetStripeConnectLoginUrlQuery__
 *
 * To run a query within a React component, call `useGetStripeConnectLoginUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeConnectLoginUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeConnectLoginUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripeConnectLoginUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeConnectLoginUrlQuery, GetStripeConnectLoginUrlQueryVariables>) {
        return Apollo.useQuery<GetStripeConnectLoginUrlQuery, GetStripeConnectLoginUrlQueryVariables>(GetStripeConnectLoginUrlDocument, baseOptions);
      }
export function useGetStripeConnectLoginUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeConnectLoginUrlQuery, GetStripeConnectLoginUrlQueryVariables>) {
          return Apollo.useLazyQuery<GetStripeConnectLoginUrlQuery, GetStripeConnectLoginUrlQueryVariables>(GetStripeConnectLoginUrlDocument, baseOptions);
        }
export type GetStripeConnectLoginUrlQueryHookResult = ReturnType<typeof useGetStripeConnectLoginUrlQuery>;
export type GetStripeConnectLoginUrlLazyQueryHookResult = ReturnType<typeof useGetStripeConnectLoginUrlLazyQuery>;
export type GetStripeConnectLoginUrlQueryResult = Apollo.QueryResult<GetStripeConnectLoginUrlQuery, GetStripeConnectLoginUrlQueryVariables>;
export const GetStripeConnectSetupUrlDocument = gql`
    query GetStripeConnectSetupUrl($country: String!) {
  User {
    stripeConnectSetupUrl(country: $country)
  }
}
    `;

/**
 * __useGetStripeConnectSetupUrlQuery__
 *
 * To run a query within a React component, call `useGetStripeConnectSetupUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeConnectSetupUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeConnectSetupUrlQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetStripeConnectSetupUrlQuery(baseOptions: Apollo.QueryHookOptions<GetStripeConnectSetupUrlQuery, GetStripeConnectSetupUrlQueryVariables>) {
        return Apollo.useQuery<GetStripeConnectSetupUrlQuery, GetStripeConnectSetupUrlQueryVariables>(GetStripeConnectSetupUrlDocument, baseOptions);
      }
export function useGetStripeConnectSetupUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeConnectSetupUrlQuery, GetStripeConnectSetupUrlQueryVariables>) {
          return Apollo.useLazyQuery<GetStripeConnectSetupUrlQuery, GetStripeConnectSetupUrlQueryVariables>(GetStripeConnectSetupUrlDocument, baseOptions);
        }
export type GetStripeConnectSetupUrlQueryHookResult = ReturnType<typeof useGetStripeConnectSetupUrlQuery>;
export type GetStripeConnectSetupUrlLazyQueryHookResult = ReturnType<typeof useGetStripeConnectSetupUrlLazyQuery>;
export type GetStripeConnectSetupUrlQueryResult = Apollo.QueryResult<GetStripeConnectSetupUrlQuery, GetStripeConnectSetupUrlQueryVariables>;
export const GetPhoneNumberAvailableDocument = gql`
    query GetPhoneNumberAvailable($phoneCountryCode: Int!, $phoneNumber: String!) {
  PhoneNumberAvailable(phoneCountryCode: $phoneCountryCode, phoneNumber: $phoneNumber)
}
    `;

/**
 * __useGetPhoneNumberAvailableQuery__
 *
 * To run a query within a React component, call `useGetPhoneNumberAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneNumberAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneNumberAvailableQuery({
 *   variables: {
 *      phoneCountryCode: // value for 'phoneCountryCode'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useGetPhoneNumberAvailableQuery(baseOptions: Apollo.QueryHookOptions<GetPhoneNumberAvailableQuery, GetPhoneNumberAvailableQueryVariables>) {
        return Apollo.useQuery<GetPhoneNumberAvailableQuery, GetPhoneNumberAvailableQueryVariables>(GetPhoneNumberAvailableDocument, baseOptions);
      }
export function useGetPhoneNumberAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhoneNumberAvailableQuery, GetPhoneNumberAvailableQueryVariables>) {
          return Apollo.useLazyQuery<GetPhoneNumberAvailableQuery, GetPhoneNumberAvailableQueryVariables>(GetPhoneNumberAvailableDocument, baseOptions);
        }
export type GetPhoneNumberAvailableQueryHookResult = ReturnType<typeof useGetPhoneNumberAvailableQuery>;
export type GetPhoneNumberAvailableLazyQueryHookResult = ReturnType<typeof useGetPhoneNumberAvailableLazyQuery>;
export type GetPhoneNumberAvailableQueryResult = Apollo.QueryResult<GetPhoneNumberAvailableQuery, GetPhoneNumberAvailableQueryVariables>;
export const GetEmailAvailableDocument = gql`
    query GetEmailAvailable($email: String!) {
  EmailAvailable(email: $email)
}
    `;

/**
 * __useGetEmailAvailableQuery__
 *
 * To run a query within a React component, call `useGetEmailAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailAvailableQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetEmailAvailableQuery(baseOptions: Apollo.QueryHookOptions<GetEmailAvailableQuery, GetEmailAvailableQueryVariables>) {
        return Apollo.useQuery<GetEmailAvailableQuery, GetEmailAvailableQueryVariables>(GetEmailAvailableDocument, baseOptions);
      }
export function useGetEmailAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailAvailableQuery, GetEmailAvailableQueryVariables>) {
          return Apollo.useLazyQuery<GetEmailAvailableQuery, GetEmailAvailableQueryVariables>(GetEmailAvailableDocument, baseOptions);
        }
export type GetEmailAvailableQueryHookResult = ReturnType<typeof useGetEmailAvailableQuery>;
export type GetEmailAvailableLazyQueryHookResult = ReturnType<typeof useGetEmailAvailableLazyQuery>;
export type GetEmailAvailableQueryResult = Apollo.QueryResult<GetEmailAvailableQuery, GetEmailAvailableQueryVariables>;
export const IsUsernameValidDocument = gql`
    query isUsernameValid($username: String!) {
  UsernameValid(username: $username) {
    isValid
    message
    suggestedUsername
  }
}
    `;

/**
 * __useIsUsernameValidQuery__
 *
 * To run a query within a React component, call `useIsUsernameValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUsernameValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUsernameValidQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useIsUsernameValidQuery(baseOptions: Apollo.QueryHookOptions<IsUsernameValidQuery, IsUsernameValidQueryVariables>) {
        return Apollo.useQuery<IsUsernameValidQuery, IsUsernameValidQueryVariables>(IsUsernameValidDocument, baseOptions);
      }
export function useIsUsernameValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsUsernameValidQuery, IsUsernameValidQueryVariables>) {
          return Apollo.useLazyQuery<IsUsernameValidQuery, IsUsernameValidQueryVariables>(IsUsernameValidDocument, baseOptions);
        }
export type IsUsernameValidQueryHookResult = ReturnType<typeof useIsUsernameValidQuery>;
export type IsUsernameValidLazyQueryHookResult = ReturnType<typeof useIsUsernameValidLazyQuery>;
export type IsUsernameValidQueryResult = Apollo.QueryResult<IsUsernameValidQuery, IsUsernameValidQueryVariables>;
export const GetManagerDocument = gql`
    query GetManager($managerId: String) {
  Manager(managerId: $managerId) {
    token
    manager {
      managerId
      createdAt
      artists {
        ...UserOnGetUserFragment
      }
    }
  }
}
    ${UserOnGetUserFragmentFragmentDoc}`;

/**
 * __useGetManagerQuery__
 *
 * To run a query within a React component, call `useGetManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerQuery({
 *   variables: {
 *      managerId: // value for 'managerId'
 *   },
 * });
 */
export function useGetManagerQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerQuery, GetManagerQueryVariables>) {
        return Apollo.useQuery<GetManagerQuery, GetManagerQueryVariables>(GetManagerDocument, baseOptions);
      }
export function useGetManagerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerQuery, GetManagerQueryVariables>) {
          return Apollo.useLazyQuery<GetManagerQuery, GetManagerQueryVariables>(GetManagerDocument, baseOptions);
        }
export type GetManagerQueryHookResult = ReturnType<typeof useGetManagerQuery>;
export type GetManagerLazyQueryHookResult = ReturnType<typeof useGetManagerLazyQuery>;
export type GetManagerQueryResult = Apollo.QueryResult<GetManagerQuery, GetManagerQueryVariables>;
export const LoginAssignedManagerDocument = gql`
    query LoginAssignedManager($assignedId: String!) {
  LoginAssignedManager(assignedId: $assignedId) {
    token
    manager {
      managerId
      createdAt
      artists {
        ...UserOnGetUserFragment
      }
    }
  }
}
    ${UserOnGetUserFragmentFragmentDoc}`;

/**
 * __useLoginAssignedManagerQuery__
 *
 * To run a query within a React component, call `useLoginAssignedManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginAssignedManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginAssignedManagerQuery({
 *   variables: {
 *      assignedId: // value for 'assignedId'
 *   },
 * });
 */
export function useLoginAssignedManagerQuery(baseOptions: Apollo.QueryHookOptions<LoginAssignedManagerQuery, LoginAssignedManagerQueryVariables>) {
        return Apollo.useQuery<LoginAssignedManagerQuery, LoginAssignedManagerQueryVariables>(LoginAssignedManagerDocument, baseOptions);
      }
export function useLoginAssignedManagerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginAssignedManagerQuery, LoginAssignedManagerQueryVariables>) {
          return Apollo.useLazyQuery<LoginAssignedManagerQuery, LoginAssignedManagerQueryVariables>(LoginAssignedManagerDocument, baseOptions);
        }
export type LoginAssignedManagerQueryHookResult = ReturnType<typeof useLoginAssignedManagerQuery>;
export type LoginAssignedManagerLazyQueryHookResult = ReturnType<typeof useLoginAssignedManagerLazyQuery>;
export type LoginAssignedManagerQueryResult = Apollo.QueryResult<LoginAssignedManagerQuery, LoginAssignedManagerQueryVariables>;
export const GetArtistYouTubeCrawlJobsDocument = gql`
    query GetArtistYouTubeCrawlJobs {
  crawlJobsDetail {
    channelCrawlJob {
      name
      status
      youTubeChannelId
      schedule
      createdAt
      updatedAt
    }
    videoCrawlJobs {
      name
      status
      mediaUrl
      thumbnail
      caption
      schedule
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetArtistYouTubeCrawlJobsQuery__
 *
 * To run a query within a React component, call `useGetArtistYouTubeCrawlJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtistYouTubeCrawlJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtistYouTubeCrawlJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetArtistYouTubeCrawlJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetArtistYouTubeCrawlJobsQuery, GetArtistYouTubeCrawlJobsQueryVariables>) {
        return Apollo.useQuery<GetArtistYouTubeCrawlJobsQuery, GetArtistYouTubeCrawlJobsQueryVariables>(GetArtistYouTubeCrawlJobsDocument, baseOptions);
      }
export function useGetArtistYouTubeCrawlJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtistYouTubeCrawlJobsQuery, GetArtistYouTubeCrawlJobsQueryVariables>) {
          return Apollo.useLazyQuery<GetArtistYouTubeCrawlJobsQuery, GetArtistYouTubeCrawlJobsQueryVariables>(GetArtistYouTubeCrawlJobsDocument, baseOptions);
        }
export type GetArtistYouTubeCrawlJobsQueryHookResult = ReturnType<typeof useGetArtistYouTubeCrawlJobsQuery>;
export type GetArtistYouTubeCrawlJobsLazyQueryHookResult = ReturnType<typeof useGetArtistYouTubeCrawlJobsLazyQuery>;
export type GetArtistYouTubeCrawlJobsQueryResult = Apollo.QueryResult<GetArtistYouTubeCrawlJobsQuery, GetArtistYouTubeCrawlJobsQueryVariables>;